webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';
	
	var _underscore = __webpack_require__(6);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vue = __webpack_require__(35);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _Home = __webpack_require__(455);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Login = __webpack_require__(463);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _PasswordReset = __webpack_require__(465);
	
	var _PasswordReset2 = _interopRequireDefault(_PasswordReset);
	
	var _PasswordForgot = __webpack_require__(464);
	
	var _PasswordForgot2 = _interopRequireDefault(_PasswordForgot);
	
	var _Soc = __webpack_require__(473);
	
	var _Soc2 = _interopRequireDefault(_Soc);
	
	var _SocPublic = __webpack_require__(474);
	
	var _SocPublic2 = _interopRequireDefault(_SocPublic);
	
	var _Admin = __webpack_require__(456);
	
	var _Admin2 = _interopRequireDefault(_Admin);
	
	var _AdminUsers = __webpack_require__(458);
	
	var _AdminUsers2 = _interopRequireDefault(_AdminUsers);
	
	var _AdminUser = __webpack_require__(457);
	
	var _AdminUser2 = _interopRequireDefault(_AdminUser);
	
	var _Serial = __webpack_require__(471);
	
	var _Serial2 = _interopRequireDefault(_Serial);
	
	var _SerialList = __webpack_require__(472);
	
	var _SerialList2 = _interopRequireDefault(_SerialList);
	
	var _License = __webpack_require__(462);
	
	var _License2 = _interopRequireDefault(_License);
	
	var _Sandbox = __webpack_require__(469);
	
	var _Sandbox2 = _interopRequireDefault(_Sandbox);
	
	var _SandboxRecord = __webpack_require__(470);
	
	var _SandboxRecord2 = _interopRequireDefault(_SandboxRecord);
	
	var _UserProfile = __webpack_require__(476);
	
	var _UserProfile2 = _interopRequireDefault(_UserProfile);
	
	var _Report = __webpack_require__(466);
	
	var _Report2 = _interopRequireDefault(_Report);
	
	var _ReportSecurityEvent = __webpack_require__(468);
	
	var _ReportSecurityEvent2 = _interopRequireDefault(_ReportSecurityEvent);
	
	var _ReportLicenseExpiry = __webpack_require__(467);
	
	var _ReportLicenseExpiry2 = _interopRequireDefault(_ReportLicenseExpiry);
	
	var _HashLookup = __webpack_require__(461);
	
	var _HashLookup2 = _interopRequireDefault(_HashLookup);
	
	var _vueRouter = __webpack_require__(516);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueAsyncComputed = __webpack_require__(454);
	
	var _vueAsyncComputed2 = _interopRequireDefault(_vueAsyncComputed);
	
	var _auth = __webpack_require__(32);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _store = __webpack_require__(226);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _mutationTypes = __webpack_require__(2);
	
	var mutationTypes = _interopRequireWildcard(_mutationTypes);
	
	var _apiWsoc = __webpack_require__(222);
	
	var _apiWsoc2 = _interopRequireDefault(_apiWsoc);
	
	var _apiSandbox = __webpack_require__(220);
	
	var _apiSandbox2 = _interopRequireDefault(_apiSandbox);
	
	var _apiAdmin = __webpack_require__(219);
	
	var _apiAdmin2 = _interopRequireDefault(_apiAdmin);
	
	__webpack_require__(439);
	
	__webpack_require__(440);
	
	__webpack_require__(443);
	
	var _vueTables = __webpack_require__(266);
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }newObj.default = obj;return newObj;
	  }
	}
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	_vue2.default.use(_vueTables.ClientTable, {}, false);
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueAsyncComputed2.default);
	_vue2.default.use(_apiWsoc2.default);
	_vue2.default.use(_apiSandbox2.default);
	_vue2.default.use(_apiAdmin2.default);
	
	function requireAuth(to, from, next) {
	  if (!_auth2.default.loggedIn()) {
	    next({
	      path: '/login',
	      query: { redirect: to.fullPath }
	    });
	  } else {
	    if (_underscore2.default.isEmpty(_store2.default.getters.user)) {
	      console.log('updating user profile');
	      _vue2.default.prototype.$apiAdmin.fetchUser(_auth2.default.getUserId()).then(function (user) {
	        _store2.default.commit(mutationTypes.USER_PROFILE_SET, user);
	        next();
	      }).catch({ status: 401 }, function () {
	        console.log('not authenticated - redirect to login');
	        next({
	          path: '/login',
	          query: { redirect: to.fullPath }
	        });
	      });
	    } else {
	      next();
	    }
	  }
	}
	
	function requireAdmin(to, from, next) {
	  if (!_store2.default.getters.userIsAdmin) {
	    next({
	      path: '/'
	    });
	  } else {
	    requireAuth(to, from, next);
	  }
	}
	
	var router = new _vueRouter2.default({
	  linkActiveClass: 'active',
	  base: __dirname,
	  routes: [{
	    path: '/',
	    redirect: '/soc/dashboard'
	  }, {
	    path: '/login',
	    component: _Login2.default,
	    name: 'login'
	  }, {
	    path: '/logout',
	    name: 'logout',
	    beforeEnter: function beforeEnter(to, from, next) {
	      console.log('logoff');
	      _auth2.default.logout();
	      next('/login');
	    }
	  }, {
	    path: '/reset-password',
	    component: _PasswordReset2.default,
	    name: 'reset-password'
	  }, {
	    path: '/forgot-password',
	    component: _PasswordForgot2.default,
	    name: 'forgot-password'
	  }, {
	    path: '/admin',
	    component: _Admin2.default,
	    name: 'admin',
	    beforeEnter: requireAdmin,
	    children: [{
	      path: 'user',
	      component: _AdminUsers2.default,
	      name: 'adminUsers',
	      beforeEnter: requireAdmin
	    }, {
	      path: 'user/:id',
	      component: _AdminUser2.default,
	      name: 'adminUser',
	      beforeEnter: requireAdmin
	    }]
	  }, {
	    path: '/user',
	    component: _Soc2.default,
	    name: 'user',
	    beforeEnter: requireAuth,
	    children: [{
	      path: 'profile',
	      component: _UserProfile2.default,
	      name: 'userProfile',
	      beforeEnter: requireAuth
	    }]
	  }, {
	    path: '/socpublic',
	    component: _SocPublic2.default,
	    name: 'socpublic',
	    children: [{
	      path: 'hashlookup',
	      component: _HashLookup2.default,
	      name: 'hashLookup'
	    }]
	  }, {
	    path: '/soc',
	    component: _Soc2.default,
	    name: 'soc',
	    beforeEnter: requireAuth,
	    children: [{
	      path: 'dashboard',
	      component: _Home2.default,
	      name: 'dashboard',
	      beforeEnter: requireAuth
	    }, {
	      path: 'serial',
	      component: _SerialList2.default,
	      name: 'serial-list',
	      beforeEnter: requireAuth
	    }, {
	      path: 'serial/:id',
	      component: _Serial2.default,
	      name: 'serial',
	      beforeEnter: requireAuth
	    }, {
	      path: 'license',
	      name: 'license',
	      component: _License2.default,
	      beforeEnter: requireAuth
	    }, {
	      path: 'sandbox',
	      name: 'sandbox',
	      component: _Sandbox2.default,
	      beforeEnter: requireAuth
	    }, {
	      path: 'sandbox/record/:sha1/:size',
	      name: 'SandboxRecord',
	      component: _SandboxRecord2.default,
	      beforeEnter: requireAuth
	    }, {
	      path: 'report',
	      name: 'report',
	      beforeEnter: requireAuth,
	      component: _Report2.default,
	      children: [{
	        path: 'security-event',
	        name: 'reportSecurityEvent',
	        component: _ReportSecurityEvent2.default,
	        beforeEnter: requireAuth
	      }, {
	        path: 'license-expiry',
	        name: 'reportLicenseExpiry',
	        component: _ReportLicenseExpiry2.default,
	        beforeEnter: requireAuth
	      }]
	    }]
	  }]
	});
	
	_vue2.default.prototype.$redirectLogin = function () {
	  var redirectPath = router.currentRoute.fullPath;
	
	  if (router.currentRoute.name === 'login') {
	    if ('redirect' in router.currentRoute.query) {
	      redirectPath = router.currentRoute.query.redirect;
	    }
	  }
	
	  router.replace({
	    name: 'login',
	    query: { redirect: redirectPath }
	  });
	};
	
	new _vue2.default({
	  router: router,
	  store: _store2.default
	}).$mount('#app');
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var USER_PROFILE_LOGIN = exports.USER_PROFILE_LOGIN = 'USER_PROFILE_LOGIN';
	var USER_PROFILE_SET = exports.USER_PROFILE_SET = 'USER_PROFILE_SET';
	var USER_PROFILE_LOGOUT = exports.USER_PROFILE_LOGOUT = 'USER_PROFILE_LOGOUT';
	
	var LOADER_LOADING = exports.LOADER_LOADING = 'LOADER_LOADING';
	var LOADER_NOT_LOADING = exports.LOADER_NOT_LOADING = 'LOADER_NOT_LOADING';
	
	var FILTER_SERIALS_SEARCH = exports.FILTER_SERIALS_SEARCH = 'FILTER_SERIALS_SEARCH';
	var FILTER_SERIALS_SELECT_CUSTOMER = exports.FILTER_SERIALS_SELECT_CUSTOMER = 'FILTER_SERIALS_SELECT_CUSTOMER';
	var FILTER_SERIALS_SELECT_CITY = exports.FILTER_SERIALS_SELECT_CITY = 'FILTER_SERIALS_SELECT_CITY';
	var FILTER_SERIALS_SELECT_COUNTRY = exports.FILTER_SERIALS_SELECT_COUNTRY = 'FILTER_SERIALS_SELECT_COUNTRY';
	
	var FILTER_DATE_RANGE = exports.FILTER_DATE_RANGE = 'FILTER_DATE_RANGE';
	
	var FILTER_REPORT_LICENSE_EXPIRY_DATE_RANGE = exports.FILTER_REPORT_LICENSE_EXPIRY_DATE_RANGE = 'FILTER_REPORT_LICENSE_EXPIRY_DATE_RANGE';
	var FILTER_REPORT_LICENSE_EXPIRY_EXPIRES_IN_DAYS = exports.FILTER_REPORT_LICENSE_EXPIRY_EXPIRES_IN_DAYS = 'FILTER_REPORT_LICENSE_EXPIRY_EXPIRES_IN_DAYS';
	var FILTER_REPORT_LICENSE_EXPIRY_EXPIRES_AGO_DAYS = exports.FILTER_REPORT_LICENSE_EXPIRY_EXPIRES_AGO_DAYS = 'FILTER_REPORT_LICENSE_EXPIRY_EXPIRES_AGO_DAYS';

/***/ },
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  M_FMT_MS: 'x',
	  M_FMT_READABLE_WEEKDAY: 'ddd MMM D, YYYY'
	};

/***/ },
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(38);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _bluebird = __webpack_require__(54);
	
	var _jquery = __webpack_require__(30);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _querystringBrowser = __webpack_require__(447);
	
	var _querystringBrowser2 = _interopRequireDefault(_querystringBrowser);
	
	var _underscore = __webpack_require__(6);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _auth = __webpack_require__(32);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var METHOD_GET = 'GET';
	var METHOD_POST = 'POST';
	var METHOD_PUT = 'PUT';
	var METHOD_PATCH = 'PATCH';
	var METHOD_DELETE = 'DELETE';
	
	exports.default = {
	  queryStringWithAuth: function queryStringWithAuth(paramsObj) {
	    var authParams = {};
	    authParams[_auth2.default.PARAM_ACCESS_TOKEN] = _auth2.default.getToken();
	
	    return '?' + _querystringBrowser2.default.stringify(_underscore2.default.extend(paramsObj || {}, authParams));
	  },
	  ajax: function ajax(type, url, data, notAuthorizedHandler) {
	    return new _bluebird.Promise(function (resolve, reject) {
	      var request = {
	        type: type,
	        url: url
	      };
	      if (data) {
	        request.data = (0, _stringify2.default)(data);
	        request.contentType = 'application/json; charset=utf-8';
	        request.dataType = 'json';
	      }
	
	      _jquery2.default.ajax(request).done(resolve).fail(reject);
	    }).catch({ status: 401 }, function (error) {
	      if (notAuthorizedHandler) {
	        console.log('Not authenticated - redirecting to login');
	        notAuthorizedHandler();
	      }
	      throw error;
	    });
	  },
	  get: function get(url, notAuthorizedHandler) {
	    return this.ajax(METHOD_GET, url, null, notAuthorizedHandler);
	  },
	  put: function put(url, data, notAuthorizedHandler) {
	    return this.ajax(METHOD_PUT, url, data, notAuthorizedHandler);
	  },
	  patch: function patch(url, data, notAuthorizedHandler) {
	    return this.ajax(METHOD_PATCH, url, data, notAuthorizedHandler);
	  },
	  post: function post(url, data, notAuthorizedHandler) {
	    return this.ajax(METHOD_POST, url, data, notAuthorizedHandler);
	  },
	  delete: function _delete(url, notAuthorizedHandler) {
	    return this.ajax(METHOD_DELETE, url, notAuthorizedHandler);
	  }
	};

/***/ },
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(432)
	
	/* script */
	__vue_exports__ = __webpack_require__(239)
	
	/* template */
	var __vue_template__ = __webpack_require__(508)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _config = __webpack_require__(73);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _httpRequest = __webpack_require__(22);
	
	var _httpRequest2 = _interopRequireDefault(_httpRequest);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var routeLogin = _config2.default.api + '/WedgeUsers/login';
	var routeLogout = _config2.default.api + '/WedgeUsers/logout';
	var routeResetPasswordEmail = _config2.default.api + '/WedgeUsers/reset';
	var routeResetPassword = _config2.default.api + '/reset-password';
	
	var paramAccessToken = 'access_token';
	
	var LS_AUTH_TOKEN_KEY = 'wsoc-auth-token';
	var LS_AUTH_USER_ID = 'wsoc-auth-user-id';
	var LS_AUTH_TTL = 'wsoc-auth-ttl';
	var LS_AUTH_CREATED = 'wsoc-auth-created';
	
	exports.default = {
	  PARAM_ACCESS_TOKEN: paramAccessToken,
	
	  resetPasswordEmail: function resetPasswordEmail(email) {
	    return _httpRequest2.default.post(routeResetPasswordEmail, {
	      email: email
	    });
	  },
	  resetPassword: function resetPassword(password, accessToken) {
	    var url = routeResetPassword + '?access_token=' + accessToken;
	    return _httpRequest2.default.post(url, {
	      password: password
	    });
	  },
	  login: function login(email, pass, cb) {
	    var _this = this;
	
	    cb = arguments[arguments.length - 1];
	
	    loginRequest(email, pass, function (res) {
	      if (res.authenticated) {
	        localStorage[LS_AUTH_TOKEN_KEY] = res.auth.id;
	        localStorage[LS_AUTH_USER_ID] = res.auth.userId;
	        localStorage[LS_AUTH_TTL] = res.auth.ttl;
	        localStorage[LS_AUTH_CREATED] = res.auth.created;
	        if (cb) cb(res);
	        _this.onChange(true);
	      } else {
	        if (cb) cb(res);
	        _this.onChange(false);
	      }
	    });
	  },
	  getToken: function getToken() {
	    return localStorage[LS_AUTH_TOKEN_KEY];
	  },
	  getUserId: function getUserId() {
	    return localStorage[LS_AUTH_USER_ID];
	  },
	  logout: function logout(cb) {
	    if (this.loggedIn()) {
	      logoutRequest(localStorage[LS_AUTH_TOKEN_KEY]);
	      delete localStorage[LS_AUTH_TOKEN_KEY];
	      delete localStorage[LS_AUTH_USER_ID];
	      delete localStorage[LS_AUTH_TTL];
	      delete localStorage[LS_AUTH_CREATED];
	      this.onChange(false);
	    }
	    if (cb) cb();
	  },
	  loggedIn: function loggedIn() {
	    if (!localStorage[LS_AUTH_TOKEN_KEY] || !localStorage[LS_AUTH_TTL] || !localStorage[LS_AUTH_CREATED]) {
	      console.log('auth tokens not present');
	      return false;
	    }
	
	    if ((0, _moment2.default)().isAfter((0, _moment2.default)(localStorage[LS_AUTH_CREATED]).add(localStorage[LS_AUTH_TTL], 'seconds'))) {
	      console.log('auth token expired');
	      return false;
	    }
	
	    return true;
	  },
	  onChange: function onChange() {}
	};
	
	function loginRequest(email, password, cb) {
	  var loginResponse = {
	    authenticated: false,
	    auth: {}
	  };
	
	  _httpRequest2.default.post(routeLogin, {
	    email: email,
	    password: password
	  }).then(function (result) {
	    if (!('id' in result)) {
	      throw new Error('token not in login response', result);
	    }
	    loginResponse.authenticated = true;
	    loginResponse.auth = result;
	
	    cb(loginResponse);
	  }).catch(function (error) {
	    console.log('error', error);
	    cb(loginResponse);
	  });
	}
	
	function logoutRequest(token) {
	  _httpRequest2.default.post(routeLogout + '?' + paramAccessToken + '=' + token).then(function (result) {
	    console.log('logged out', result);
	  }).catch(function (error) {
	    console.log('logged out error', error);
	  });
	}

/***/ },
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	exports.default = {
	  WARN_DAYS: 10,
	
	  licenseExpiryDate: function licenseExpiryDate(activationDate, expiryDate, duration) {
	    var durationExpirationDate, expiresExpirationDate;
	    var expirationDate = null;
	
	    duration = Number(duration);
	    if (duration === 0 && !expiryDate) {
	      throw new Error('unexpected license with no duration or expiry date set!');
	    }
	
	    if (expiryDate) {
	      expiresExpirationDate = (0, _moment2.default)(expiryDate);
	    }
	    if (duration && duration !== 0) {
	      durationExpirationDate = (0, _moment2.default)(activationDate).add(duration, 'days');
	    }
	
	    if (expiryDate && duration && duration !== 0) {
	      expirationDate = durationExpirationDate.isBefore(expiresExpirationDate) ? durationExpirationDate : expiresExpirationDate;
	    } else if (expiryDate) {
	      expirationDate = expiresExpirationDate;
	    } else {
	      expirationDate = durationExpirationDate;
	    }
	
	    return expirationDate;
	  }
	};

/***/ },
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(236)
	
	/* template */
	var __vue_template__ = __webpack_require__(507)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(416)
	
	/* script */
	__vue_exports__ = __webpack_require__(241)
	
	/* template */
	var __vue_template__ = __webpack_require__(489)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-260e1014"
	
	module.exports = __vue_exports__


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(415)
	
	/* script */
	__vue_exports__ = __webpack_require__(244)
	
	/* template */
	var __vue_template__ = __webpack_require__(488)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 71 */,
/* 72 */,
/* 73 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var API = '/loopback/api';
	
	exports.default = {
	  api: API
	};

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bluebird = __webpack_require__(54);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _config = __webpack_require__(73);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _httpRequest = __webpack_require__(22);
	
	var _httpRequest2 = _interopRequireDefault(_httpRequest);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var ROLE_ADMIN = 'Admin';
	var API = _config2.default.api;
	var ROUTE_USERS = API + '/WedgeUsers/';
	
	exports.default = {
	  ROLE_ADMIN: ROLE_ADMIN,
	
	  fetchUsers: function fetchUsers() {
	    var url = ROUTE_USERS;
	    url += _httpRequest2.default.queryStringWithAuth();
	    return _httpRequest2.default.get(url);
	  },
	  fetchUser: function fetchUser(id) {
	    var queryFilter = '{"include": "roles"}';
	    var url = ROUTE_USERS + id;
	    if (!id) {
	      return _bluebird2.default.reject('id is a required parameter');
	    }
	    url += _httpRequest2.default.queryStringWithAuth({
	      filter: queryFilter
	    });
	    return _httpRequest2.default.get(url);
	  },
	  createUser: function createUser(user) {
	    var url = ROUTE_USERS;
	    if (!user) {
	      return _bluebird2.default.reject('user is a required parameter');
	    }
	    url += _httpRequest2.default.queryStringWithAuth();
	    return _httpRequest2.default.post(url, user);
	  },
	  updateUser: function updateUser(userId, user) {
	    var url = ROUTE_USERS + (userId !== '0' ? '/' + userId : '');
	    if (userId === '0' || !userId || !user) {
	      return _bluebird2.default.reject('userId and user are a required parameters');
	    }
	    url += _httpRequest2.default.queryStringWithAuth();
	    return _httpRequest2.default.put(url, user);
	  }
	};

/***/ },
/* 75 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PROTOCOLS = ['HTTP', 'SMTP', 'FTP', 'IMAP', 'POP3'];
	
	exports.default = {
	  protocols: PROTOCOLS
	};

/***/ },
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (source) {
	  return function (h) {
	
	    var rows = __webpack_require__(341)(h, this);
	    var normalFilter = __webpack_require__(337)(h, this);
	    var dropdownPagination = __webpack_require__(332)(h, this);
	    var columnFilters = __webpack_require__(329)(h, this);
	    var footerHeadings = __webpack_require__(333)(h, this);
	    var noResults = __webpack_require__(336)(h, this);
	    var pagination = __webpack_require__(338)(h, this);
	    var dropdownPaginationCount = __webpack_require__(331)(h, this);
	    var headings = __webpack_require__(334)(h, this);
	    var perPage = __webpack_require__(340)(h, this);
	
	    return h(
	      'div',
	      { 'class': "VueTables VueTables--" + this.source },
	      [h(
	        'div',
	        { 'class': 'row' },
	        [h(
	          'div',
	          { 'class': 'col-md-6' },
	          [normalFilter]
	        ), h(
	          'div',
	          { 'class': 'col-md-6' },
	          [dropdownPagination, perPage]
	        )]
	      ), h(
	        'table',
	        { 'class': 'VueTables__table table ' + this.opts.skin },
	        [h(
	          'thead',
	          null,
	          [h(
	            'tr',
	            null,
	            [headings]
	          ), columnFilters]
	        ), footerHeadings, h(
	          'tbody',
	          null,
	          [noResults, rows]
	        )]
	      ), pagination, dropdownPaginationCount]
	    );
	  };
	};

/***/ },
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(436)
	
	/* script */
	__vue_exports__ = __webpack_require__(237)
	
	/* template */
	var __vue_template__ = __webpack_require__(513)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c3249e56"
	
	module.exports = __vue_exports__


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(419)
	
	/* script */
	__vue_exports__ = __webpack_require__(243)
	
	/* template */
	var __vue_template__ = __webpack_require__(492)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-291f9ae6"
	
	module.exports = __vue_exports__


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(421)
	
	/* script */
	__vue_exports__ = __webpack_require__(246)
	
	/* template */
	var __vue_template__ = __webpack_require__(494)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-43318cd6"
	
	module.exports = __vue_exports__


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(423)
	
	/* script */
	__vue_exports__ = __webpack_require__(248)
	
	/* template */
	var __vue_template__ = __webpack_require__(497)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(438)
	
	/* script */
	__vue_exports__ = __webpack_require__(348)
	
	/* template */
	var __vue_template__ = __webpack_require__(515)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _apiAdminLib = __webpack_require__(74);
	
	var _apiAdminLib2 = _interopRequireDefault(_apiAdminLib);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function plugin(Vue) {
	  if (plugin.installed) {
	    return;
	  }
	
	  var apiAdmin = new Vue({
	    methods: _apiAdminLib2.default
	  });
	
	  Object.defineProperty(Vue.prototype, '$apiAdmin', {
	    get: function get() {
	      return apiAdmin;
	    }
	  });
	}
	
	if (typeof window !== 'undefined' && window.Vue) {
	  window.Vue.use(plugin);
	}
	
	exports.default = plugin;

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _httpRequest = __webpack_require__(22);
	
	var _httpRequest2 = _interopRequireDefault(_httpRequest);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var api = '/loopback/api/Sandboxes';
	var prefix = api;
	
	var routeVerdicts = prefix + '/verdicts';
	var routeVerdict = prefix + '/verdict';
	var routeVerdictClassification = routeVerdict + '-classification';
	
	var routeVerdictOverride = routeVerdict + '/override';
	var routeVerdictOverrideGet = routeVerdictOverride + '-get';
	var routeVerdictOverridePut = routeVerdictOverride + '-put';
	var routeVerdictOverrideDelete = routeVerdictOverride + '-delete';
	
	var routeRecords = prefix + '/records/';
	var routeGraywareDownload = prefix + '/grayware-download/';
	
	function plugin(Vue) {
	  if (plugin.installed) {
	    return;
	  }
	
	  var apiSandbox = new Vue({
	    methods: {
	      graywareDownloadLink: function graywareDownloadLink(sha1Checksum, size) {
	        var url = routeGraywareDownload;
	        url += _httpRequest2.default.queryStringWithAuth({
	          sha1: sha1Checksum,
	          size: size
	        });
	        return url;
	      },
	      fetchVerdicts: function fetchVerdicts(epochStart, epochEnd) {
	        var url = routeVerdicts;
	        url += _httpRequest2.default.queryStringWithAuth();
	        return _httpRequest2.default.get(url, this.$redirectLogin);
	      },
	      fetchVerdict: function fetchVerdict(sha1Checksum, size) {
	        var url = routeVerdict + '/' + sha1Checksum + '/' + size;
	        url += _httpRequest2.default.queryStringWithAuth();
	        return _httpRequest2.default.get(url, this.$redirectLogin);
	      },
	      fetchVerdictClassifications: function fetchVerdictClassifications() {
	        var url = routeVerdictClassification;
	        url += _httpRequest2.default.queryStringWithAuth();
	        return _httpRequest2.default.get(url, this.$redirectLogin);
	      },
	      fetchVerdictOverride: function fetchVerdictOverride(sha1Checksum, size) {
	        var url = routeVerdictOverrideGet + '/' + sha1Checksum + '/' + size;
	        url += _httpRequest2.default.queryStringWithAuth();
	        return _httpRequest2.default.get(url, this.$redirectLogin);
	      },
	      updateVerdictOverride: function updateVerdictOverride(sha1Checksum, size, classification) {
	        var url = routeVerdictOverridePut + '/' + sha1Checksum + '/' + size;
	        var data = {
	          classification: classification
	        };
	        url += _httpRequest2.default.queryStringWithAuth();
	        return _httpRequest2.default.put(url, data, this.$redirectLogin);
	      },
	      deleteVerdictOverride: function deleteVerdictOverride(sha1Checksum, size) {
	        var url = routeVerdictOverrideDelete + '/' + sha1Checksum + '/' + size;
	        url += _httpRequest2.default.queryStringWithAuth();
	        return _httpRequest2.default.delete(url, this.$redirectLogin);
	      },
	      fetchRecords: function fetchRecords(sha1Checksum, size) {
	        var url = routeRecords + sha1Checksum + '/' + size;
	        url += _httpRequest2.default.queryStringWithAuth();
	        return _httpRequest2.default.get(url, this.$redirectLogin);
	      }
	    }
	  });
	
	  Object.defineProperty(Vue.prototype, '$apiSandbox', {
	    get: function get() {
	      return apiSandbox;
	    }
	  });
	}
	
	if (typeof window !== 'undefined' && window.Vue) {
	  window.Vue.use(plugin);
	}
	
	exports.default = plugin;

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _httpRequest = __webpack_require__(22);
	
	var _httpRequest2 = _interopRequireDefault(_httpRequest);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var api = '/loopback/api/SandboxPublics';
	var prefix = api;
	var routeVerdict = prefix + '/verdict';
	
	exports.default = {
	  fetchVerdict: function fetchVerdict(sha1Checksum) {
	    var url = routeVerdict + '/' + sha1Checksum;
	    return _httpRequest2.default.get(url);
	  }
	};

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bluebird = __webpack_require__(54);
	
	var _httpRequest = __webpack_require__(22);
	
	var _httpRequest2 = _interopRequireDefault(_httpRequest);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var api = '/api';
	var version = '/1.0.0';
	
	var prefix = api + version;
	var routeStats = version + '/stats/';
	var routeActive = version + '/applianceactive/';
	var routeDetails = version + '/appliancedetail/';
	var routeLicenses = version + '/appliance-license/';
	
	var routeCustomer = prefix + '/customer';
	var routeCustomerSerials = routeCustomer + '/serials';
	
	var routeEvent = prefix + '/applianceevent';
	
	var routeApplianceTrack = prefix + '/appliancetrack';
	
	var routeAggregates = prefix + '/agg';
	var routeApplianceTotal = routeAggregates + '/appliancetotal';
	var routeSoftwareVersion = routeAggregates + '/softwareversion';
	var routeTrackIp = routeAggregates + '/track-ip';
	var routeProxyProtocolStats = routeAggregates + '/proxyprotocolstat';
	
	var routeGeoIp = prefix + '/geoip';
	
	function plugin(Vue) {
	  if (plugin.installed) {
	    return;
	  }
	
	  var apiWsoc = new Vue({
	    methods: {
	      geoIpLookup: function geoIpLookup(ipAddresses) {
	        var url = routeGeoIp;
	        url += _httpRequest2.default.queryStringWithAuth();
	        return _httpRequest2.default.post(url, ipAddresses, this.$redirectLogin);
	      },
	      fetchStats: function fetchStats(serial, epochStart, epochEnd) {
	        var url = api + routeStats + serial;
	        var queryObj = {
	          epochStart: epochStart,
	          epochEnd: epochEnd
	        };
	        url += _httpRequest2.default.queryStringWithAuth(queryObj);
	        return _httpRequest2.default.get(url, this.$redirectLogin);
	      },
	      fetchActiveSerials: function fetchActiveSerials() {
	        var url = routeActive;
	        url += _httpRequest2.default.queryStringWithAuth();
	        return _httpRequest2.default.get(url, this.$redirectLogin);
	      },
	      fetchDetails: function fetchDetails(serial, epochStart, epochEnd) {
	        var url = api + routeDetails + (serial || '');
	        var queryObj = {
	          epochStart: epochStart,
	          epochEnd: epochEnd
	        };
	        url += _httpRequest2.default.queryStringWithAuth(queryObj);
	        return _httpRequest2.default.get(url, this.$redirectLogin);
	      },
	      fetchLicenses: function fetchLicenses(serial, epochStart, epochEnd) {
	        var url = api + routeLicenses + (serial || '');
	        var queryObj = {
	          epochStart: epochStart,
	          epochEnd: epochEnd
	        };
	        url += _httpRequest2.default.queryStringWithAuth(queryObj);
	        return _httpRequest2.default.get(url, this.$redirectLogin);
	      },
	      fetchCustomers: function fetchCustomers() {
	        var url = routeCustomer;
	        url += _httpRequest2.default.queryStringWithAuth();
	        return _httpRequest2.default.get(url, this.$redirectLogin);
	      },
	      fetchCustomerSerials: function fetchCustomerSerials() {
	        var url = routeCustomerSerials;
	        url += _httpRequest2.default.queryStringWithAuth();
	        return _httpRequest2.default.get(url, this.$redirectLogin);
	      },
	      fetchTrack: function fetchTrack(serial, epochStart, epochEnd) {
	        var url = routeApplianceTrack + '/' + serial;
	        var queryObj = {
	          epochStart: epochStart,
	          epochEnd: epochEnd
	        };
	        url += _httpRequest2.default.queryStringWithAuth(queryObj);
	        return _httpRequest2.default.get(url, this.$redirectLogin);
	      },
	      fetchEvents: function fetchEvents(serial, epochStart, epochEnd) {
	        var url = routeEvent + '/' + serial;
	        var queryObj = {
	          epochStart: epochStart,
	          epochEnd: epochEnd
	        };
	        url += _httpRequest2.default.queryStringWithAuth(queryObj);
	        return _httpRequest2.default.get(url, this.$redirectLogin);
	      },
	      fetchTotalAppliance: function fetchTotalAppliance(start, end) {
	        var url = routeApplianceTotal;
	        var queryObj = {
	          start: start,
	          end: end
	        };
	
	        if (!start || !end) {
	          return _bluebird.Promise.reject('all of start and end are required');
	        }
	
	        url += _httpRequest2.default.queryStringWithAuth(queryObj);
	        return _httpRequest2.default.get(url, this.$redirectLogin);
	      },
	      fetchSoftwareVersions: function fetchSoftwareVersions(start, end) {
	        var url = routeSoftwareVersion;
	        var queryObj = {
	          start: start,
	          end: end
	        };
	
	        if (!start || !end) {
	          return _bluebird.Promise.reject('all of start and end are required');
	        }
	
	        url += _httpRequest2.default.queryStringWithAuth(queryObj);
	        return _httpRequest2.default.get(url, this.$redirectLogin);
	      },
	      fetchTrackIp: function fetchTrackIp(start, end) {
	        var url = routeTrackIp;
	        var queryObj = {
	          start: start,
	          end: end
	        };
	
	        if (!start || !end) {
	          return _bluebird.Promise.reject('all of start and end are required');
	        }
	
	        url += _httpRequest2.default.queryStringWithAuth(queryObj);
	        return _httpRequest2.default.get(url, this.$redirectLogin);
	      },
	      fetchProxyProtocolStats: function fetchProxyProtocolStats(start, end) {
	        var url = routeProxyProtocolStats;
	        var queryObj = {
	          start: start,
	          end: end
	        };
	
	        if (!start || !end) {
	          return _bluebird.Promise.reject('all of start and end are required');
	        }
	
	        url += _httpRequest2.default.queryStringWithAuth(queryObj);
	        return _httpRequest2.default.get(url, this.$redirectLogin);
	      }
	    }
	  });
	
	  Object.defineProperty(Vue.prototype, '$apiWsoc', {
	    get: function get() {
	      return apiWsoc;
	    }
	  });
	}
	
	if (typeof window !== 'undefined' && window.Vue) {
	  window.Vue.use(plugin);
	}
	
	exports.default = plugin;

/***/ },
/* 223 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  percentageChartOptions: function percentageChartOptions(title, yAxisTitle) {
	    return {
	      credits: {
	        enabled: false
	      },
	      chart: {
	        type: 'area'
	      },
	      title: {
	        text: title
	      },
	      xAxis: {
	        categories: [],
	        tickmarkPlacement: 'on',
	        title: {
	          enabled: false
	        }
	      },
	      yAxis: {
	        title: {
	          text: 'Percent'
	        }
	      },
	      tooltip: {
	        pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.percentage:.1f}%</b> ({point.y:,.0f})<br/>',
	        split: true
	      },
	      plotOptions: {
	        area: {
	          stacking: 'percent',
	          lineColor: '#ffffff',
	          lineWidth: 1,
	          marker: {
	            lineWidth: 1,
	            lineColor: '#ffffff'
	          }
	        }
	      }
	    };
	  },
	  chartOptions: function chartOptions(type, title, yAxisTitle) {
	    return {
	      credits: {
	        enabled: false
	      },
	      chart: {
	        type: type
	      },
	      title: {
	        text: title
	      },
	      xAxis: {
	        categories: [],
	        crosshair: true
	      },
	      yAxis: {
	        min: 0,
	        title: {
	          text: yAxisTitle
	        }
	      },
	      tooltip: {
	        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
	        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y}</b></td></tr>',
	        footerFormat: '</table>',
	        shared: true,
	        useHTML: true
	      },
	      plotOptions: {
	        column: {
	          pointPadding: 0.2,
	          borderWidth: 0
	        }
	      }
	    };
	  }
	};

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.wedgeUserAdd = undefined;
	
	var _mutationTypes = __webpack_require__(2);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }newObj.default = obj;return newObj;
	  }
	}
	
	var wedgeUserAdd = exports.wedgeUserAdd = function wedgeUserAdd(_ref, user) {
	  var commit = _ref.commit;
	
	  commit(types.WEDGEUSER_ADD, user);
	};

/***/ },
/* 225 */
/***/ function(module, exports) {

	"use strict";

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(35);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(49);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _logger = __webpack_require__(523);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _actions = __webpack_require__(224);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _getters = __webpack_require__(225);
	
	var getters = _interopRequireWildcard(_getters);
	
	var _userProfile = __webpack_require__(231);
	
	var _userProfile2 = _interopRequireDefault(_userProfile);
	
	var _loading = __webpack_require__(230);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _filterSerialList = __webpack_require__(229);
	
	var _filterSerialList2 = _interopRequireDefault(_filterSerialList);
	
	var _filterDateRange = __webpack_require__(227);
	
	var _filterDateRange2 = _interopRequireDefault(_filterDateRange);
	
	var _filterReportLicenseExpiry = __webpack_require__(228);
	
	var _filterReportLicenseExpiry2 = _interopRequireDefault(_filterReportLicenseExpiry);
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }newObj.default = obj;return newObj;
	  }
	}
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	_vue2.default.use(_vuex2.default);
	
	var debug = ("production") !== 'prod';
	
	exports.default = new _vuex2.default.Store({
	  actions: actions,
	  getters: getters,
	  modules: {
	    userProfile: _userProfile2.default,
	    loading: _loading2.default,
	    filterSerialList: _filterSerialList2.default,
	    filterDateRange: _filterDateRange2.default,
	    filterReportLicenseExpiry: _filterReportLicenseExpiry2.default
	  },
	  strict: debug,
	  plugins: debug ? [(0, _logger2.default)()] : []
	});

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(8);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _mutationTypes = __webpack_require__(2);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _constants = __webpack_require__(12);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }newObj.default = obj;return newObj;
	  }
	}
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var state = {
	  dateRange: [(0, _moment2.default)().subtract(60, 'days').format(_constants2.default.M_FMT_MS), (0, _moment2.default)().format(_constants2.default.M_FMT_MS)]
	};
	
	var getters = {
	  dateRange: function dateRange(state) {
	    return state.dateRange;
	  }
	};
	
	var actions = {};
	
	var mutations = (0, _defineProperty3.default)({}, types.FILTER_DATE_RANGE, function (state, dateRange) {
	  state.dateRange = dateRange;
	});
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(8);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _mutationTypes = __webpack_require__(2);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	var _constants = __webpack_require__(12);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }newObj.default = obj;return newObj;
	  }
	}
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var state = {
	  dateRange: [(0, _moment2.default)().subtract(90, 'days').format(_constants2.default.M_FMT_MS), (0, _moment2.default)().format(_constants2.default.M_FMT_MS)],
	  expiresInDays: 14,
	  expiresAgoDays: 30
	};
	
	var getters = {
	  reportLicenseExpiryDateRange: function reportLicenseExpiryDateRange(state) {
	    return state.dateRange;
	  },
	  expiresInDays: function expiresInDays(state) {
	    return state.expiresInDays;
	  },
	  expiresAgoDays: function expiresAgoDays(state) {
	    return state.expiresAgoDays;
	  }
	};
	
	var actions = {};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.FILTER_REPORT_LICENSE_EXPIRY_DATE_RANGE, function (state, dateRange) {
	  state.dateRange = dateRange;
	}), (0, _defineProperty3.default)(_mutations, types.FILTER_REPORT_LICENSE_EXPIRY_EXPIRES_IN_DAYS, function (state, expiresInDays) {
	  state.expiresInDays = expiresInDays;
	}), (0, _defineProperty3.default)(_mutations, types.FILTER_REPORT_LICENSE_EXPIRY_EXPIRES_AGO_DAYS, function (state, expiresAgoDays) {
	  state.expiresAgoDays = expiresAgoDays;
	}), _mutations);
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(8);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(2);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }newObj.default = obj;return newObj;
	  }
	}
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var state = {
	  search: '',
	  selectCustomer: '',
	  selectCity: '',
	  selectCountry: ''
	};
	
	var getters = {
	  search: function search(state) {
	    return state.search;
	  },
	  selectCustomer: function selectCustomer(state) {
	    return state.selectCustomer;
	  },
	  selectCity: function selectCity(state) {
	    return state.selectCity;
	  },
	  selectCountry: function selectCountry(state) {
	    return state.selectCountry;
	  }
	};
	
	var actions = {};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.FILTER_SERIALS_SEARCH, function (state, search) {
	  state.search = search;
	}), (0, _defineProperty3.default)(_mutations, types.FILTER_SERIALS_SELECT_CUSTOMER, function (state, customer) {
	  state.selectCustomer = customer;
	}), (0, _defineProperty3.default)(_mutations, types.FILTER_SERIALS_SELECT_CITY, function (state, city) {
	  state.selectCity = city;
	}), (0, _defineProperty3.default)(_mutations, types.FILTER_SERIALS_SELECT_COUNTRY, function (state, country) {
	  state.selectCountry = country;
	}), _mutations);
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(8);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(2);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }newObj.default = obj;return newObj;
	  }
	}
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var state = {
	  loading: false
	};
	
	var getters = {
	  loading: function loading(state) {
	    return state.loading;
	  }
	};
	
	var actions = {};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.LOADER_LOADING, function (state) {
	  state.loading = true;
	}), (0, _defineProperty3.default)(_mutations, types.LOADER_NOT_LOADING, function (state) {
	  state.loading = false;
	}), _mutations);
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(8);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _underscore = __webpack_require__(6);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _apiAdminLib = __webpack_require__(74);
	
	var _apiAdminLib2 = _interopRequireDefault(_apiAdminLib);
	
	var _mutationTypes = __webpack_require__(2);
	
	var types = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }newObj.default = obj;return newObj;
	  }
	}
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	var state = {
	  auth: {},
	  user: {}
	};
	
	var getters = {
	  auth: function auth(state) {
	    return state.auth;
	  },
	  user: function user(state) {
	    return state.user;
	  },
	  userIsAdmin: function userIsAdmin(state) {
	    if (_underscore2.default.isEmpty(state.user)) {
	      return false;
	    }
	
	    if (!('roles' in state.user)) {
	      return false;
	    }
	    return _underscore2.default.find(state.user.roles, function (item) {
	      return item.name === _apiAdminLib2.default.ROLE_ADMIN;
	    }) !== undefined;
	  }
	};
	
	var actions = {
	  getUser: function getUser(_ref) {
	    var commit = _ref.commit;
	
	    if (!('userId' in state.auth)) {
	      console.log('userProfile store - no logged in user');
	      return;
	    }
	    _apiAdminLib2.default.fetchUser(state.auth.userId).then(function (user) {
	      commit(types.USER_PROFILE_SET, user);
	    });
	  }
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, types.USER_PROFILE_LOGIN, function (state, auth) {
	  state.auth = auth;
	}), (0, _defineProperty3.default)(_mutations, types.USER_PROFILE_SET, function (state, user) {
	  state.user = user;
	}), (0, _defineProperty3.default)(_mutations, types.USER_PROFILE_LOGOUT, function (state) {
	  state.user = {};
	  state.auth = {};
	}), _mutations);
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(13);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _slicedToArray2 = __webpack_require__(25);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _underscore = __webpack_require__(6);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _mutationTypes = __webpack_require__(2);
	
	var mutationTypes = _interopRequireWildcard(_mutationTypes);
	
	var _BootstrapPanel = __webpack_require__(210);
	
	var _BootstrapPanel2 = _interopRequireDefault(_BootstrapPanel);
	
	var _DateRangePicker = __webpack_require__(31);
	
	var _DateRangePicker2 = _interopRequireDefault(_DateRangePicker);
	
	var _HighChart = __webpack_require__(211);
	
	var _HighChart2 = _interopRequireDefault(_HighChart);
	
	var _GoogleMap = __webpack_require__(69);
	
	var _GoogleMap2 = _interopRequireDefault(_GoogleMap);
	
	var _constants = __webpack_require__(12);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _stats = __webpack_require__(75);
	
	var _stats2 = _interopRequireDefault(_stats);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    BootstrapPanel: _BootstrapPanel2.default,
	    DateRangePicker: _DateRangePicker2.default,
	    HighChart: _HighChart2.default,
	    GoogleMap: _GoogleMap2.default
	  },
	
	  data: function data() {
	    return {
	      totalAppliances: {},
	      softwareVersion: {},
	      proxyProtocolStats: {},
	
	      reducedVersions: {},
	      reducedProxyProtocolStats: {},
	
	      trackCoordinates: [],
	
	      malwareChartSeries: [],
	      malwareChartOptions: { chart: {} },
	
	      requestsChartSeries: [],
	      requestsChartOptions: { chart: {} },
	
	      bytesChartSeries: [],
	      bytesChartOptions: { chart: {} },
	
	      connectionsChartSeries: [],
	      connectionsChartOptions: { chart: {} },
	
	      urlsChartSeries: [],
	      urlsChartOptions: { chart: {} },
	
	      aiMalwareChartSeries: [],
	      aiMalwareChartOptions: { chart: {} },
	
	      aiGraywareChartSeries: [],
	      aiGraywareChartOptions: { chart: {} },
	
	      sandboxMalwareChartSeries: [],
	      sandboxMalwareChartOptions: { chart: {} },
	
	      sandboxCleanChartSeries: [],
	      sandboxCleanChartOptions: { chart: {} },
	
	      spamChartSeries: [],
	      spamChartOptions: { chart: {} },
	
	      appliancesChartSeries: [{
	        name: 'Appliances',
	        data: []
	      }],
	      appliancesChartOptions: {
	        chart: {
	          type: 'column'
	        },
	        title: {
	          text: 'Tracked Appliances'
	        },
	        xAxis: {
	          categories: [],
	          crosshair: true
	        },
	        yAxis: {
	          min: 0,
	          title: {
	            text: 'Count'
	          }
	        },
	        tooltip: {
	          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
	          pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y}</b></td></tr>',
	          footerFormat: '</table>',
	          shared: true,
	          useHTML: true
	        },
	        plotOptions: {
	          column: {
	            pointPadding: 0.2,
	            borderWidth: 0
	          }
	        }
	      },
	
	      versionsChartSeries: [{
	        name: 'Versions',
	        data: []
	      }],
	      versionsChartOptions: {
	        chart: {
	          type: 'column'
	        },
	        title: {
	          text: 'Software Versions'
	        },
	        xAxis: {
	          categories: [],
	          crosshair: true
	        },
	        yAxis: {
	          min: 0,
	          title: {
	            text: 'Count'
	          }
	        },
	        tooltip: {
	          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
	          pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y}</b></td></tr>',
	          footerFormat: '</table>',
	          shared: true,
	          useHTML: true
	        },
	        plotOptions: {
	          column: {
	            pointPadding: 0.2,
	            borderWidth: 0
	          }
	        }
	      }
	    };
	  },
	  mounted: function mounted() {
	    this.malwareChartOptions = this.chartOptions('column', 'AV Malware', 'count');
	    this.bytesChartOptions = this.chartOptions('column', 'Bytes', 'count');
	    this.connectionsChartOptions = this.chartOptions('column', 'Connections', 'count');
	    this.requestsChartOptions = this.chartOptions('column', 'Requests', 'count');
	
	    this.aiMalwareChartOptions = this.chartOptions('column', 'AI Malware', 'count');
	    this.aiGraywareChartOptions = this.chartOptions('column', 'AI Grayware', 'count');
	    this.sandboxMalwareChartOptions = this.chartOptions('column', 'Sandbox Malware', 'count');
	    this.sandboxCleanChartOptions = this.chartOptions('column', 'Sandbox Clean', 'count');
	
	    this.urlsChartOptions = this.chartOptions('column', 'Urls', 'count');
	    this.spamChartOptions = this.chartOptions('column', 'Spam', 'count');
	
	    this.fetch();
	  },
	
	
	  computed: {
	    dateRange: {
	      get: function get() {
	        return this.$store.state.filterDateRange.dateRange;
	      },
	      set: function set(value) {
	        this.$store.commit(mutationTypes.FILTER_DATE_RANGE, value);
	      }
	    },
	
	    dateStart: function dateStart() {
	      return (0, _moment2.default)(this.dateRange[0], _constants2.default.M_FMT_MS).utc();
	    },
	    dateEnd: function dateEnd() {
	      return (0, _moment2.default)(this.dateRange[1], _constants2.default.M_FMT_MS).utc();
	    }
	  },
	
	  methods: {
	    dateRangeFormat: function dateRangeFormat(date) {
	      return (0, _moment2.default)(date).format(_constants2.default.M_FMT_READABLE_WEEKDAY);
	    },
	    dateRangeChange: function dateRangeChange(e) {
	      this.dateRange = e;
	    },
	    chartSeries: function chartSeries(statName) {
	      var _this = this;
	
	      return _stats2.default.protocols.map(function (protocol) {
	        return {
	          name: protocol,
	          data: _underscore2.default.values(_this.reducedProxyProtocolStats[protocol + '.' + statName])
	        };
	      });
	    },
	    chartOptions: function chartOptions(type, title, yAxisTitle) {
	      return {
	        credits: {
	          enabled: false
	        },
	        chart: {
	          type: type
	        },
	        title: {
	          text: title
	        },
	        xAxis: {
	          categories: [],
	          crosshair: true
	        },
	        yAxis: {
	          min: 0,
	          title: {
	            text: yAxisTitle
	          }
	        },
	        tooltip: {
	          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
	          pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y}</b></td></tr>',
	          footerFormat: '</table>',
	          shared: true,
	          useHTML: true
	        },
	        plotOptions: {
	          column: {
	            pointPadding: 0.2,
	            borderWidth: 0
	          }
	        }
	      };
	    },
	    reduceSoftwareVersions: function reduceSoftwareVersions(softwareVersions) {
	      var reducedVersions = _underscore2.default.chain(softwareVersions).values().flatten().uniq().map(function (version) {
	        return version.split(':')[1];
	      }).countBy().value();
	
	      reducedVersions = _underscore2.default.object(_underscore2.default.sortBy(_underscore2.default.pairs(reducedVersions), function (o) {
	        return o[0];
	      }));
	
	      return reducedVersions;
	    },
	    reduceStats: function reduceStats(stats) {
	      var reducedStats = {};
	
	      _underscore2.default.forEach(stats, function (obj, key) {
	        reducedStats[key] = {};
	        _underscore2.default.forEach(obj, function (serialStats, date) {
	          reducedStats[key][date] = _underscore2.default.reduce(_underscore2.default.values(serialStats), function (memo, count) {
	            return memo + parseInt(count);
	          }, 0);
	        });
	      });
	
	      return reducedStats;
	    },
	    reduceTrackCoordinates: function reduceTrackCoordinates(trackIps) {
	      var SEP = ':';
	
	      var result = _underscore2.default.chain(trackIps).values().flatten().reject(_underscore2.default.isEmpty).groupBy(function (val) {
	        return val.latitude + SEP + val.longitude;
	      }).map(function (value, key) {
	        var serials = _underscore2.default.reduce(value, function (memo, val) {
	          memo[val.serial] = '<a href="/#/soc/serial/' + val.serial + '">' + val.serial.substring(0, 8) + '</a>';
	          return memo;
	        }, {});
	        return { latlong: key, serials: serials };
	      }).value();
	
	      return result.map(function (item) {
	        var _item$latlong$split = item.latlong.split(SEP),
	            _item$latlong$split2 = (0, _slicedToArray3.default)(_item$latlong$split, 2),
	            lat = _item$latlong$split2[0],
	            long = _item$latlong$split2[1];
	
	        return {
	          lat: Number(lat),
	          long: Number(long),
	          popupText: _underscore2.default.values(item.serials).join('<br>')
	        };
	      });
	    },
	    fetch: function fetch() {
	      var _this2 = this;
	
	      var appliance = this.$apiWsoc.fetchTotalAppliance(this.dateStart.format('x'), this.dateEnd.format('x'));
	      var versions = this.$apiWsoc.fetchSoftwareVersions(this.dateStart.format('x'), this.dateEnd.format('x'));
	      var trackIps = this.$apiWsoc.fetchTrackIp(this.dateStart.format('x'), this.dateEnd.format('x'));
	      var proxyProtocolStats = this.$apiWsoc.fetchProxyProtocolStats(this.dateStart.format('x'), this.dateEnd.format('x'));
	
	      this.$store.commit(mutationTypes.LOADER_LOADING);
	      _promise2.default.all([appliance, versions, trackIps, proxyProtocolStats]).then(function (_ref) {
	        var _ref2 = (0, _slicedToArray3.default)(_ref, 4),
	            applianceResult = _ref2[0],
	            versionsResult = _ref2[1],
	            trackIpsResult = _ref2[2],
	            protocolStatsResult = _ref2[3];
	
	        _this2.totalAppliances = applianceResult.result;
	        _this2.softwareVersion = versionsResult.result;
	        _this2.proxyProtocolStats = protocolStatsResult.result;
	        _this2.trackCoordinates = _this2.reduceTrackCoordinates(trackIpsResult.result);
	
	        _this2.appliancesChartSeries = [{
	          name: 'Appliances',
	          data: _underscore2.default.values(_this2.totalAppliances)
	        }];
	        _this2.appliancesChartOptions.xAxis.categories = _underscore2.default.keys(_this2.totalAppliances);
	
	        _this2.reducedVersions = _this2.reduceSoftwareVersions(_this2.softwareVersion);
	        _this2.versionsChartSeries = [{
	          name: 'Versions',
	          data: _underscore2.default.values(_this2.reducedVersions)
	        }];
	        _this2.versionsChartOptions.xAxis.categories = _underscore2.default.keys(_this2.reducedVersions);
	
	        _this2.reducedProxyProtocolStats = _this2.reduceStats(_this2.proxyProtocolStats);
	
	        _this2.requestsChartSeries = _this2.chartSeries('totalRequests');
	        _this2.requestsChartOptions.xAxis.categories = _underscore2.default.keys(_this2.reducedProxyProtocolStats['HTTP.totalRequests']);
	
	        _this2.malwareChartSeries = _this2.chartSeries('blockedVirus');
	        _this2.malwareChartOptions.xAxis.categories = _underscore2.default.keys(_this2.reducedProxyProtocolStats['HTTP.blockedVirus']);
	
	        _this2.bytesChartSeries = _this2.chartSeries('totalBytesRead');
	        _this2.bytesChartOptions.xAxis.categories = _underscore2.default.keys(_this2.reducedProxyProtocolStats['HTTP.totalBytesRead']);
	
	        _this2.connectionsChartSeries = _this2.chartSeries('totalConnections');
	        _this2.connectionsChartOptions.xAxis.categories = _underscore2.default.keys(_this2.reducedProxyProtocolStats['HTTP.totalConnections']);
	
	        _this2.urlsChartSeries = [{
	          name: 'Blocked URL',
	          data: _underscore2.default.values(_this2.reducedProxyProtocolStats['HTTP.blockedUrls'])
	        }, {
	          name: 'Blocked WF URL',
	          data: _underscore2.default.values(_this2.reducedProxyProtocolStats['HTTP.blockedWfUrls'])
	        }, {
	          name: 'Warned WF URL',
	          data: _underscore2.default.values(_this2.reducedProxyProtocolStats['HTTP.warnedWfUrls'])
	        }, {
	          name: 'Blocked CM URL',
	          data: _underscore2.default.values(_this2.reducedProxyProtocolStats['HTTP.blockedCMUrls'])
	        }, {
	          name: 'Warned CM URL',
	          data: _underscore2.default.values(_this2.reducedProxyProtocolStats['HTTP.warnedCMUrls'])
	        }];
	        _this2.urlsChartOptions.xAxis.categories = _underscore2.default.keys(_this2.reducedProxyProtocolStats['HTTP.blockedUrls']);
	
	        _this2.aiMalwareChartSeries = _this2.chartSeries('cylanceAvMalware');
	        _this2.aiMalwareChartOptions.xAxis.categories = _underscore2.default.keys(_this2.reducedProxyProtocolStats['HTTP.cylanceAvMalware']);
	
	        _this2.aiGraywareChartSeries = _this2.chartSeries('cylanceAvGrayware');
	        _this2.aiGraywareChartOptions.xAxis.categories = _underscore2.default.keys(_this2.reducedProxyProtocolStats['HTTP.cylanceAvGrayware']);
	
	        _this2.sandboxMalwareChartSeries = _this2.chartSeries('sandboxAvHashMalware');
	        _this2.sandboxMalwareChartOptions.xAxis.categories = _underscore2.default.keys(_this2.reducedProxyProtocolStats['HTTP.sandboxAvHashMalware']);
	
	        _this2.sandboxCleanChartSeries = _this2.chartSeries('sandboxAvHashClean');
	        _this2.sandboxCleanChartOptions.xAxis.categories = _underscore2.default.keys(_this2.reducedProxyProtocolStats['HTTP.sandboxAvHashClean']);
	
	        _this2.spamChartSeries = [{
	          name: 'SMTP',
	          data: _underscore2.default.values(_this2.reducedProxyProtocolStats['SMTP.spamCount'])
	        }, {
	          name: 'POP3',
	          data: _underscore2.default.values(_this2.reducedProxyProtocolStats['POP3.spamCount'])
	        }, {
	          name: 'IMAP',
	          data: _underscore2.default.values(_this2.reducedProxyProtocolStats['IMAP.spamCount'])
	        }];
	        _this2.spamChartOptions.xAxis.categories = _underscore2.default.keys(_this2.reducedProxyProtocolStats['SMTP.spamCount']);
	
	        _this2.$store.commit(mutationTypes.LOADER_NOT_LOADING);
	      }).catch(function (error) {
	        console.log('ERROR', error);
	        _this2.$store.commit(mutationTypes.LOADER_NOT_LOADING);
	      });
	    }
	  },
	
	  watch: {
	    dateRange: function dateRange() {
	      this.fetch();
	    }
	  }
	};

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavBar = __webpack_require__(213);
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _LoadingBar = __webpack_require__(212);
	
	var _LoadingBar2 = _interopRequireDefault(_LoadingBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    NavBar: _NavBar2.default,
	    LoadingBar: _LoadingBar2.default
	  }
	};

/***/ },
/* 234 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      user: {
	        id: 0,
	        password: Math.random().toString(36).slice(2),
	        first_name: '',
	        last_name: '',
	        email: ''
	      },
	      saved: false,
	      savedError: false
	    };
	  },
	
	
	  computed: {
	    userId: function userId() {
	      return this.$route.params.id;
	    }
	  },
	
	  methods: {
	    showSavedMessage: function showSavedMessage() {
	      var _this = this;
	
	      this.saved = true;
	      setTimeout(function () {
	        _this.saved = false;
	      }, 3000);
	    },
	    save: function save() {
	      var _this2 = this;
	
	      var promise;
	      this.saved = false;
	      this.savedError = false;
	
	      if (this.user.id === 0) {
	        promise = this.$apiAdmin.createUser(this.user);
	      } else {
	        promise = this.$apiAdmin.updateUser(this.user.id, this.user);
	      }
	
	      promise.then(function (user) {
	        _this2.user = user;
	        _this2.showSavedMessage();
	
	        if (_this2.userId === 0) {
	          _this2.$router.replace(_this2.$route.path.replace('0', user.id));
	        }
	      }).catch(function (error) {
	        _this2.savedError = true;
	        console.log('user update error', error);
	      });
	    },
	    fetch: function fetch() {
	      var _this3 = this;
	
	      if (this.userId === 0) {
	        return;
	      }
	
	      this.$apiAdmin.fetchUser(this.userId).then(function (user) {
	        _this3.user = user;
	      }).catch(function (error) {
	        console.log('admin user fetch error', error);
	      });
	    }
	  },
	
	  mounted: function mounted() {
	    this.fetch();
	  }
	};

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(6);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      users: [],
	      searchTerm: ''
	    };
	  },
	
	
	  computed: {
	    sortedUsers: function sortedUsers() {
	      return _underscore2.default.sortBy(this.users, 'last_name');
	    }
	  },
	
	  methods: {
	    clearSearchTerm: function clearSearchTerm() {
	      this.searchTerm = '';
	    },
	    fetch: function fetch() {
	      var _this = this;
	
	      this.$apiAdmin.fetchUsers().then(function (users) {
	        _this.users = users;
	      }).catch(function (error) {
	        console.log('admin users fetch error', error);
	      });
	    }
	  },
	
	  mounted: function mounted() {
	    this.fetch();
	  }
	};

/***/ },
/* 236 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['title', 'name']
	};

/***/ },
/* 237 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    title: {
	      type: String,
	      required: false
	    }
	  }
	};

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(30);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    title: {
	      type: String,
	      required: false
	    },
	    content: {
	      type: String,
	      required: false
	    },
	    placement: {
	      type: String,
	      required: false,
	      default: 'auto'
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.$nextTick(function () {
	      (0, _jquery2.default)(_this.$el).popover({
	        placement: _this.placement
	      });
	    });
	  },
	  destroyed: function destroyed() {
	    var _this2 = this;
	
	    this.$nextTick(function () {
	      (0, _jquery2.default)(_this2.$el).popover('destroy');
	    });
	  }
	};

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(30);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _daterangepicker = __webpack_require__(404);
	
	var _daterangepicker2 = _interopRequireDefault(_daterangepicker);
	
	__webpack_require__(407);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dateRangeFormat = 'YYYY-MM-DD';
	var timeFormat = 'HH:mm:ss';
	
	var events = {
	  'DATERANGE_CHANGE': 'daterange-change'
	};
	
	exports.default = {
	  events: events,
	
	  data: function data() {
	    return {
	      options: {
	        timePicker: false,
	        autoUpdateInput: true,
	        format: dateRangeFormat,
	        ranges: this.ranges
	      },
	      value: ''
	    };
	  },
	
	
	  props: {
	    placeHolder: {
	      type: String,
	      required: false,
	      default: 'Choose Dates'
	    },
	
	    ranges: {
	      type: Object,
	      required: false,
	      default: function _default() {
	        return {
	          'Last 1 days': [(0, _moment2.default)().subtract(1, 'days'), (0, _moment2.default)()],
	          'Last 2 days': [(0, _moment2.default)().subtract(2, 'days'), (0, _moment2.default)()],
	          'Last 7 days': [(0, _moment2.default)().subtract(7, 'days'), (0, _moment2.default)()],
	          'Last 30 days': [(0, _moment2.default)().subtract(30, 'days'), (0, _moment2.default)()],
	          'Last 2 months': [(0, _moment2.default)().subtract(2, 'months'), (0, _moment2.default)()]
	        };
	      }
	    }
	  },
	
	  methods: {
	    update: function update(event, picker) {
	      console.log('apply event', event.target.value);
	      var matches = /(\d\d\d\d-\d\d-\d\d)\s+-\s+(\d\d\d\d-\d\d-\d\d)/.exec(event.target.value);
	      var dateRange = [(0, _moment2.default)(matches[1] + '00:00:00', dateRangeFormat + timeFormat).format('x'), (0, _moment2.default)(matches[2] + '23:59:59', dateRangeFormat + timeFormat).format('x')];
	
	      this.value = event.target.value;
	      this.$emit(events.DATERANGE_CHANGE, dateRange);
	    }
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.$nextTick(function () {
	      _daterangepicker2.default ? '' : '';
	
	      (0, _jquery2.default)(_this.$refs.el).daterangepicker(_this.options);
	      (0, _jquery2.default)(_this.$refs.el).on('apply.daterangepicker', _this.update);
	    });
	  }
	};

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(24);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  $el: function $el() {
	    return '#el';
	  },
	  data: function data() {
	    return {
	      dayStyles: [],
	      trackDays: {}
	    };
	  },
	
	
	  props: {
	    dateStart: {
	      type: String,
	      required: true,
	      default: function _default() {
	        return '';
	      }
	    },
	    dateEnd: {
	      type: String,
	      required: true,
	      default: function _default() {
	        return '';
	      }
	    },
	    days: {
	      type: Array,
	      required: true,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	
	  methods: {
	    buildTrackdays: function buildTrackdays() {
	      var date = (0, _moment2.default)(this.dateStart, 'x');
	
	      do {
	        this.trackDays[date.format('YYYYMMDD')] = 0;
	        date = date.add(1, 'day');
	      } while (date.format('x') < this.dateEnd);
	    }
	  },
	
	  mouted: function mouted() {
	    var date, keys, i;
	    var dayStyles = [];
	    var dayCount, dayStyle;
	
	    this.buildTrackdays();
	    for (i = 0; i < this.days.length; i++) {
	      date = (0, _moment2.default)(this.days[i].timestamp, 'x').format('YYYYMMDD');
	
	      if (date in this.trackDays) {
	        this.trackDays[date]++;
	      }
	    }
	
	    keys = (0, _keys2.default)(this.trackDays).sort();
	    for (i = 0; i < keys.length; i++) {
	      dayCount = this.trackDays[keys[i]];
	
	      if (dayCount === 0) {
	        dayStyle = 'q0';
	      } else if (dayCount > 0 && dayCount <= 50) {
	        dayStyle = 'q1';
	      } else if (dayCount > 51 && dayCount <= 100) {
	        dayStyle = 'q2';
	      } else if (dayCount > 101 && dayCount <= 200) {
	        dayStyle = 'q3';
	      } else {
	        dayStyle = 'q4';
	      }
	
	      dayStyles.push(dayStyle);
	    }
	
	    this.dayStyles = dayStyles;
	  }
	};

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(6);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vue2GoogleMaps = __webpack_require__(522);
	
	var VueGoogleMaps = _interopRequireWildcard(_vue2GoogleMaps);
	
	var _vue = __webpack_require__(35);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API_KEY = 'AIzaSyDDWDFo5BKfv3C-wmPmigHhpLMG5sDs8tU';
	var calgaryCoordinates = { lat: 51.0486, lng: -114.0708 };
	
	_vue2.default.use(VueGoogleMaps, {
	  load: {
	    key: API_KEY,
	    v: '3.26' }
	});
	
	exports.default = {
	  props: ['coordinates', 'height'],
	
	  data: function data() {
	    return {
	      center: calgaryCoordinates,
	      statusText: '',
	      markersVisibility: {}
	    };
	  },
	
	
	  methods: {
	    markerClick: function markerClick(index) {
	      _vue2.default.set(this.markersVisibility, index, true);
	    },
	    infoWindowClose: function infoWindowClose(index) {
	      _vue2.default.set(this.markersVisibility, index, false);
	    }
	  },
	
	  computed: {
	    centerPosition: function centerPosition() {
	      if (!this.coordinates || this.coordinates.length === 0) {
	        return {
	          position: calgaryCoordinates,
	          zoom: 5
	        };
	      }
	
	      var latitudearray = _underscore2.default.pluck(this.coordinates, 'lat');
	      var longitudearray = _underscore2.default.pluck(this.coordinates, 'long');
	
	      latitudearray.sort(function (a, b) {
	        return a - b;
	      });
	      longitudearray.sort(function (a, b) {
	        return a - b;
	      });
	
	      var latdifferenece = latitudearray[latitudearray.length - 1] - latitudearray[0];
	      var temp = (latdifferenece / 2).toFixed(4);
	      var latitudeMid = parseFloat(latitudearray[0]) + parseFloat(temp);
	      var longidifferenece = longitudearray[longitudearray.length - 1] - longitudearray[0];
	      temp = (longidifferenece / 2).toFixed(4);
	      var longitudeMid = parseFloat(longitudearray[0]) + parseFloat(temp);
	      var maxdifference = latdifferenece > longidifferenece ? latdifferenece : longidifferenece;
	      var zoomvalue;
	
	      if (maxdifference >= 0 && maxdifference <= 0.0037) {
	        zoomvalue = 17;
	      } else if (maxdifference > 0.0037 && maxdifference <= 0.0070) {
	        zoomvalue = 16;
	      } else if (maxdifference > 0.0070 && maxdifference <= 0.0130) {
	        zoomvalue = 15;
	      } else if (maxdifference > 0.0130 && maxdifference <= 0.0290) {
	        zoomvalue = 14;
	      } else if (maxdifference > 0.0290 && maxdifference <= 0.0550) {
	        zoomvalue = 13;
	      } else if (maxdifference > 0.0550 && maxdifference <= 0.1200) {
	        zoomvalue = 12;
	      } else if (maxdifference > 0.1200 && maxdifference <= 0.4640) {
	        zoomvalue = 10;
	      } else if (maxdifference > 0.4640 && maxdifference <= 1.8580) {
	        zoomvalue = 8;
	      } else if (maxdifference > 1.8580 && maxdifference <= 3.5310) {
	        zoomvalue = 7;
	      } else if (maxdifference > 3.5310 && maxdifference <= 7.3367) {
	        zoomvalue = 6;
	      } else if (maxdifference > 7.3367 && maxdifference <= 14.222) {
	        zoomvalue = 5;
	      } else if (maxdifference > 14.222 && maxdifference <= 28.000) {
	        zoomvalue = 4;
	      } else if (maxdifference > 28.000 && maxdifference <= 58.000) {
	        zoomvalue = 3;
	      } else {
	        zoomvalue = 3;
	      }
	
	      return {
	        position: {
	          lat: latitudeMid,
	          lng: longitudeMid
	        },
	        zoom: zoomvalue - 1
	      };
	    },
	    markers: function markers() {
	      var markers = [];
	      var i;
	      var loc;
	
	      if (!this.coordinates) {
	        return [];
	      }
	
	      for (i = 0; i < this.coordinates.length; i++) {
	        loc = this.coordinates[i];
	
	        markers.push({
	          position: {
	            lat: Number(loc.lat),
	            lng: Number(loc.long)
	          },
	          popupText: loc.popupText,
	          showMarker: this.markersVisibility[i]
	        });
	      }
	
	      return markers;
	    }
	  }
	};

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _jquery = __webpack_require__(30);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _apiSandboxPublic = __webpack_require__(221);
	
	var _apiSandboxPublic2 = _interopRequireDefault(_apiSandboxPublic);
	
	var _Json = __webpack_require__(70);
	
	var _Json2 = _interopRequireDefault(_Json);
	
	var _BootstrapModal = __webpack_require__(68);
	
	var _BootstrapModal2 = _interopRequireDefault(_BootstrapModal);
	
	var _constants = __webpack_require__(12);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    BootstrapModal: _BootstrapModal2.default,
	    Json: _Json2.default
	  },
	
	  data: function data() {
	    return {
	      contentHash: '',
	      displayVerdict: false,
	      verdicts: []
	    };
	  },
	  mounted: function mounted() {
	    this.$nextTick(function () {
	      (0, _jquery2.default)('[autofocus]:first').focus();
	    });
	  },
	
	
	  methods: {
	    fetch: function fetch() {
	      var _this = this;
	
	      if (this.contentHash === '') {
	        return;
	      }
	
	      _apiSandboxPublic2.default.fetchVerdict(this.contentHash).then(function (result) {
	        _this.verdicts = result;
	        _this.displayVerdict = true;
	      }).catch(function (error) {
	        console.log('error fetching verdicts', error);
	      });
	    },
	    lookupSubmit: function lookupSubmit() {
	      this.fetch();
	    },
	    clearForm: function clearForm() {
	      this.contentHash = '';
	      this.displayVerdict = false;
	      this.verdicts = [];
	    },
	    formatEpoch: function formatEpoch(epoch) {
	      return (0, _moment2.default)(epoch, _constants2.default.M_FMT_MS).format('YYYY-MM-DD');
	    }
	  }
	};

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _highcharts = __webpack_require__(441);
	
	var _highcharts2 = _interopRequireDefault(_highcharts);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_moment2.default.locale('en');
	
	exports.default = {
	  props: {
	    selected: {
	      type: String,
	      required: false,
	      default: function _default() {
	        return '';
	      }
	    },
	    options: {
	      type: Object,
	      required: true,
	      default: function _default() {
	        return {};
	      }
	    },
	    series: {
	      type: Array,
	      required: true,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	
	  methods: {
	    renderChart: function renderChart() {
	      var opts = this.options;
	      opts.chart.renderTo = this.$refs.el;
	      opts.series = this.series;
	
	      this.chart = new _highcharts2.default.Chart(opts);
	    },
	    updateChart: function updateChart() {
	      this.chart.series = this.series;
	      this.chart.redraw();
	    }
	  },
	
	  mounted: function mounted() {
	    this.renderChart();
	  },
	  data: function data() {
	    return {
	      chart: null
	    };
	  },
	
	
	  watch: {
	    series: function series(val) {
	      this.$nextTick(function () {
	        this.renderChart();
	      });
	    }
	  }
	};

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(38);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function syntaxHighlight(json) {
	  if (!json) {
	    return '';
	  }
	
	  if (typeof json === 'string') {
	    json = JSON.parse(json);
	  }
	  json = (0, _stringify2.default)(json, undefined, 2);
	
	  json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	  return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
	    var cls = 'number';
	    if (/^"/.test(match)) {
	      if (/:$/.test(match)) {
	        cls = 'key';
	      } else {
	        cls = 'string';
	      }
	    } else if (/true|false/.test(match)) {
	      cls = 'boolean';
	    } else if (/null/.test(match)) {
	      cls = 'null';
	    }
	    return '<span class="' + 'json' + cls + '">' + match + '</span>';
	  });
	}
	
	exports.default = {
	  props: ['jsonObject'],
	
	  computed: {
	    json: function json() {
	      return syntaxHighlight(this.jsonObject);
	    }
	  }
	};

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(25);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(13);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _underscore = __webpack_require__(6);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _mutationTypes = __webpack_require__(2);
	
	var mutationTypes = _interopRequireWildcard(_mutationTypes);
	
	var _license = __webpack_require__(51);
	
	var _license2 = _interopRequireDefault(_license);
	
	var _DateRangePicker = __webpack_require__(31);
	
	var _DateRangePicker2 = _interopRequireDefault(_DateRangePicker);
	
	var _constants = __webpack_require__(12);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DateRangePicker: _DateRangePicker2.default
	  },
	
	  data: function data() {
	    return {
	      licenses: [],
	      serials: []
	    };
	  },
	
	
	  computed: {
	    dateRange: {
	      get: function get() {
	        return this.$store.state.filterDateRange.dateRange;
	      },
	      set: function set(value) {
	        this.$store.commit(mutationTypes.FILTER_DATE_RANGE, value);
	      }
	    },
	    dateStart: function dateStart() {
	      return (0, _moment2.default)(this.dateRange[0], _constants2.default.M_FMT_MS).utc();
	    },
	    dateEnd: function dateEnd() {
	      return (0, _moment2.default)(this.dateRange[1], _constants2.default.M_FMT_MS).utc();
	    },
	    epochStart: function epochStart() {
	      return this.dateRange[0];
	    },
	    epochEnd: function epochEnd() {
	      return this.dateRange[1];
	    },
	    sortedLicenses: function sortedLicenses() {
	      return _underscore2.default.sortBy(this.licenses, function (item) {
	        return item.license.issued;
	      }).reverse();
	    },
	    licenseCount: function licenseCount() {
	      return this.sortedLicenses.length;
	    },
	    serialDetails: function serialDetails() {
	      return _underscore2.default.mapObject(this.serials, function (item) {
	        return {
	          customer: item.details.length > 0 ? item.details[0].customer : ''
	        };
	      });
	    }
	  },
	
	  methods: {
	    fetch: function fetch() {
	      var _this = this;
	
	      this.$store.commit(mutationTypes.LOADER_LOADING);
	      _promise2.default.all([this.$apiWsoc.fetchLicenses(null, this.epochStart, this.epochEnd), this.$apiWsoc.fetchDetails(null, this.epochStart, this.epochEnd)]).then(function (_ref) {
	        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	            licenseResult = _ref2[0],
	            detailsResult = _ref2[1];
	
	        _this.$store.commit(mutationTypes.LOADER_NOT_LOADING);
	        _this.licenses = licenseResult.result;
	        _this.serials = detailsResult;
	      }).catch(function (error) {
	        _this.$store.commit(mutationTypes.LOADER_NOT_LOADING);
	        console.log('error fetching', error);
	      });
	    },
	    licenseExpiryDate: function licenseExpiryDate(activationDate, expiryDate, duration) {
	      return _license2.default.licenseExpiryDate(activationDate, expiryDate, duration);
	    },
	    expiresRowClass: function expiresRowClass(activationDate, expiryDate, duration) {
	      var licenseExpiryDate = _license2.default.licenseExpiryDate(activationDate, expiryDate, duration);
	      var expiryDays = licenseExpiryDate.diff((0, _moment2.default)(), 'days');
	      if (expiryDays < 0) {
	        return 'danger';
	      }
	      if (expiryDays < _license2.default.WARN_DAYS) {
	        return 'warning';
	      }
	      return '';
	    },
	    trim: function trim(str, length) {
	      return str.substring(0, length);
	    },
	    formatDate: function formatDate(date) {
	      return (0, _moment2.default)(date).format('YYYY-MM-DD HH:mm');
	    },
	    dateRangeFormat: function dateRangeFormat(date) {
	      return (0, _moment2.default)(date).format(_constants2.default.M_FMT_READABLE_WEEKDAY);
	    },
	    dateRangeChange: function dateRangeChange(e) {
	      this.dateRange = e;
	    }
	  },
	
	  mounted: function mounted() {
	    this.fetch();
	  },
	
	
	  watch: {
	    dateRange: function dateRange() {
	      this.fetch();
	    }
	  }
	};

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(49);
	
	exports.default = {
	  computed: (0, _vuex.mapGetters)({
	    loading: 'loading'
	  })
	};

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(32);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _mutationTypes = __webpack_require__(2);
	
	var mutationTypes = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      email: '',
	      password: '',
	      error: false,
	      validate: false
	    };
	  },
	
	  methods: {
	    submit: function submit() {
	      var _this = this;
	
	      this.validate = true;
	      if (!this.isValid) {
	        return;
	      }
	      _auth2.default.login(this.email, this.password, function (result) {
	        if (!result.authenticated) {
	          _this.error = true;
	        } else {
	          _this.$store.commit(mutationTypes.USER_PROFILE_LOGIN, result.auth);
	          _this.$store.dispatch('getUser');
	          _this.$router.replace(_this.$route.query.redirect || '/');
	        }
	      });
	    }
	  },
	  computed: {
	    validateEmail: function validateEmail() {
	      return !this.validate || this.email !== '';
	    },
	    validatePassword: function validatePassword() {
	      return !this.validate || this.password !== '';
	    },
	    isValid: function isValid() {
	      return this.validateEmail && this.validatePassword;
	    }
	  }
	};

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(49);
	
	exports.default = {
	  methods: {
	    pathPrefixMatches: function pathPrefixMatches(prefix) {
	      var re = new RegExp('^' + prefix);
	      return this.$route.path.match(re);
	    }
	  },
	
	  computed: (0, _vuex.mapGetters)({
	    userProfileAuth: 'auth',
	    userProfile: 'user',
	    userIsAdmin: 'userIsAdmin'
	  })
	};

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(32);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      email: '',
	      error: false,
	      validate: false,
	      success: false
	    };
	  },
	
	  methods: {
	    submit: function submit() {
	      var _this = this;
	
	      this.validate = true;
	      this.error = false;
	      if (!this.isValid) {
	        return;
	      }
	      _auth2.default.resetPasswordEmail(this.email).then(function (result) {
	        _this.success = true;
	      }).catch(function (error) {
	        _this.error = true;
	        console.log('forgot password email error', error);
	      });
	    }
	  },
	  computed: {
	    validateEmail: function validateEmail() {
	      return !this.validate || this.email !== '';
	    },
	    isValid: function isValid() {
	      return this.validateEmail;
	    }
	  }
	};

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(32);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      passwordMinLength: 6,
	      password: '',
	      password2: '',
	      error: false,
	      validate: false,
	      success: false
	    };
	  },
	
	  methods: {
	    submit: function submit() {
	      var _this = this;
	
	      this.validate = true;
	      if (!this.isValid) {
	        return;
	      }
	      _auth2.default.resetPassword(this.password, this.accessToken).then(function (result) {
	        _this.success = true;
	      }).catch(function (error) {
	        _this.error = true;
	        console.log('password reset error', error);
	      });
	    }
	  },
	  computed: {
	    accessToken: function accessToken() {
	      return this.$route.query.access_token;
	    },
	    preValidation: function preValidation() {
	      return !!this.accessToken;
	    },
	    passwordsMatch: function passwordsMatch() {
	      return this.password === this.password2;
	    },
	    passwordLength: function passwordLength() {
	      return !this.validate || this.password.length >= this.passwordMinLength;
	    },
	    validatePassword: function validatePassword() {
	      return !this.validate || this.password !== '';
	    },
	    validatePassword2: function validatePassword2() {
	      return !this.validate || this.password2 !== '';
	    },
	    isValid: function isValid() {
	      return this.passwordsMatch && this.passwordLength && this.validatePassword && this.validatePassword2;
	    }
	  }
	};

/***/ },
/* 251 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  components: {}
	};

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(25);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(13);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _underscore = __webpack_require__(6);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _mutationTypes = __webpack_require__(2);
	
	var mutationTypes = _interopRequireWildcard(_mutationTypes);
	
	var _license = __webpack_require__(51);
	
	var _license2 = _interopRequireDefault(_license);
	
	var _DateRangePicker = __webpack_require__(31);
	
	var _DateRangePicker2 = _interopRequireDefault(_DateRangePicker);
	
	var _BootstrapModal = __webpack_require__(68);
	
	var _BootstrapModal2 = _interopRequireDefault(_BootstrapModal);
	
	var _Json = __webpack_require__(70);
	
	var _Json2 = _interopRequireDefault(_Json);
	
	var _constants = __webpack_require__(12);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    BootstrapModal: _BootstrapModal2.default,
	    DateRangePicker: _DateRangePicker2.default,
	    Json: _Json2.default
	  },
	
	  data: function data() {
	    return {
	      licenses: [],
	      serials: [],
	
	      datePickerRanges: {
	        'Last 30 days': [(0, _moment2.default)().subtract(30, 'days'), (0, _moment2.default)()],
	        'Last 90 days': [(0, _moment2.default)().subtract(90, 'days'), (0, _moment2.default)()],
	        'Last 180 days': [(0, _moment2.default)().subtract(180, 'days'), (0, _moment2.default)()],
	        'Last year': [(0, _moment2.default)().subtract(1, 'years'), (0, _moment2.default)()],
	        'Last 2 years': [(0, _moment2.default)().subtract(2, 'years'), (0, _moment2.default)()]
	      }
	    };
	  },
	
	
	  computed: {
	    dateRange: {
	      get: function get() {
	        return this.$store.state.filterReportLicenseExpiry.dateRange;
	      },
	      set: function set(value) {
	        this.$store.commit(mutationTypes.FILTER_REPORT_LICENSE_EXPIRY_DATE_RANGE, value);
	      }
	    },
	    expiresInDays: {
	      get: function get() {
	        return this.$store.state.filterReportLicenseExpiry.expiresInDays;
	      },
	      set: function set(value) {
	        this.$store.commit(mutationTypes.FILTER_REPORT_LICENSE_EXPIRY_EXPIRES_IN_DAYS, value);
	      }
	    },
	    expiresAgoDays: {
	      get: function get() {
	        return this.$store.state.filterReportLicenseExpiry.expiresAgoDays;
	      },
	      set: function set(value) {
	        this.$store.commit(mutationTypes.FILTER_REPORT_LICENSE_EXPIRY_EXPIRES_AGO_DAYS, value);
	      }
	    },
	    dateStart: function dateStart() {
	      return (0, _moment2.default)(this.dateRange[0], _constants2.default.M_FMT_MS).utc();
	    },
	    dateEnd: function dateEnd() {
	      return (0, _moment2.default)(this.dateRange[1], _constants2.default.M_FMT_MS).utc();
	    },
	    epochStart: function epochStart() {
	      return this.dateRange[0];
	    },
	    epochEnd: function epochEnd() {
	      return this.dateRange[1];
	    },
	    licenseCount: function licenseCount() {
	      return this.filteredActivations.length;
	    },
	    serialDetails: function serialDetails() {
	      return _underscore2.default.mapObject(this.serials, function (item) {
	        return {
	          customer: item.details.length > 0 ? item.details[0].customer : ''
	        };
	      });
	    },
	    activations: function activations() {
	      var _this = this;
	
	      var licenseActivations = [];
	      _underscore2.default.each(this.licenses, function (license) {
	        _underscore2.default.each(license.activations, function (activation) {
	          var licenseActivation = _underscore2.default.clone(license.license);
	          if (activation.installed === 1) {
	            licenseActivation.activation = activation;
	            licenseActivation.attributes = license.attributes;
	            licenseActivation.duration = license.attributes.license.root.duration;
	            licenseActivation.expires = license.attributes.license.root.expires;
	            licenseActivation.licenseExpiryDate = _license2.default.licenseExpiryDate(activation.activationDate, licenseActivation.expires, licenseActivation.duration);
	            licenseActivation.expiryDays = licenseActivation.licenseExpiryDate.diff((0, _moment2.default)(), 'days');
	            licenseActivation.customer = _this.serialDetails[activation.serial] ? _this.serialDetails[activation.serial].customer : license.attributes.license.root.customer;
	            licenseActivation.rowClass = licenseActivation.expiryDays < 0 ? 'danger' : '';
	            licenseActivations.push(licenseActivation);
	          }
	        });
	      });
	      return licenseActivations;
	    },
	    filteredActivations: function filteredActivations() {
	      var _this2 = this;
	
	      return _underscore2.default.chain(this.activations).filter(function (activation) {
	        if (activation.customer === 'Wedge R&D') {
	          return false;
	        }
	        if (activation.expiryDays > _this2.expiresInDays || activation.expiryDays < -_this2.expiresAgoDays) {
	          return false;
	        }
	        return true;
	      }).sortBy('expiryDays').value();
	    }
	  },
	
	  methods: {
	    fetch: function fetch() {
	      var _this3 = this;
	
	      this.$store.commit(mutationTypes.LOADER_LOADING);
	      _promise2.default.all([this.$apiWsoc.fetchLicenses(null, this.epochStart, this.epochEnd), this.$apiWsoc.fetchDetails(null, this.epochStart, this.epochEnd)]).then(function (_ref) {
	        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	            licenseResult = _ref2[0],
	            detailsResult = _ref2[1];
	
	        _this3.$store.commit(mutationTypes.LOADER_NOT_LOADING);
	        _this3.licenses = licenseResult.result;
	        _this3.serials = detailsResult;
	      }).catch(function (error) {
	        _this3.$store.commit(mutationTypes.LOADER_NOT_LOADING);
	        console.log('error fetching', error);
	      });
	    },
	    trim: function trim(str, length) {
	      return str.substring(0, length);
	    },
	    formatDate: function formatDate(date) {
	      return (0, _moment2.default)(date).format('YYYY-MM-DD HH:mm');
	    },
	    dateRangeFormat: function dateRangeFormat(date) {
	      return (0, _moment2.default)(date).format(_constants2.default.M_FMT_READABLE_WEEKDAY);
	    },
	    dateRangeChange: function dateRangeChange(e) {
	      this.dateRange = e;
	    }
	  },
	
	  mounted: function mounted() {
	    this.fetch();
	  },
	
	
	  watch: {
	    dateRange: function dateRange() {
	      this.fetch();
	    }
	  }
	};

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(25);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(13);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _underscore = __webpack_require__(6);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _mutationTypes = __webpack_require__(2);
	
	var mutationTypes = _interopRequireWildcard(_mutationTypes);
	
	var _constants = __webpack_require__(12);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _DateRangePicker = __webpack_require__(31);
	
	var _DateRangePicker2 = _interopRequireDefault(_DateRangePicker);
	
	var _serialLink = __webpack_require__(351);
	
	var _serialLink2 = _interopRequireDefault(_serialLink);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PROTOCOLS = ['HTTP', 'SMTP', 'FTP', 'POP3', 'IMAP'];
	
	exports.default = {
	  components: {
	    DateRangePicker: _DateRangePicker2.default
	  },
	
	  data: function data() {
	    return {
	      details: {},
	      proxyProtocolStats: {},
	
	      protocols: PROTOCOLS,
	      selectedProtocols: ['HTTP'],
	      showDetails: false,
	
	      options: {
	        perPage: 1000,
	        perPageValues: [100, 500, 1000],
	        templates: {
	          serial: _serialLink2.default
	        }
	      },
	
	      aggregateBy: {
	        'Scanned Bytes': this.statProtocols('totalBytesRead'),
	        'Connections': this.statProtocols('totalConnections'),
	        'AV Malware': this.statProtocols('blockedVirus'),
	        'AI Malware': this.statProtocols('cylanceAvMalware'),
	        'AI Clean': this.statProtocols('cylanceAvClean'),
	        'Sandbox Malware': this.statProtocols('sandboxAvHashClean'),
	        'Sandbox Clean': this.statProtocols('sandboxAvHashMalware'),
	        'Sandbox Submitted': this.statProtocols('sandboxAvPayloadSubmit'),
	        'Web Filter': _underscore2.default.flatten([this.statProtocols('blockedUrls'), this.statProtocols('blockedWfUrls'), this.statProtocols('warnedWfUrls'), this.statProtocols('blockedCMUrls'), this.statProtocols('warnedCMUrls')])
	      }
	    };
	  },
	  mounted: function mounted() {
	    this.fetch();
	  },
	
	
	  computed: {
	    dateRange: {
	      get: function get() {
	        return this.$store.state.filterDateRange.dateRange;
	      },
	      set: function set(value) {
	        this.$store.commit(mutationTypes.FILTER_DATE_RANGE, value);
	      }
	    },
	
	    dateStart: function dateStart() {
	      return (0, _moment2.default)(this.dateRange[0], _constants2.default.M_FMT_MS).utc();
	    },
	    dateEnd: function dateEnd() {
	      return (0, _moment2.default)(this.dateRange[1], _constants2.default.M_FMT_MS).utc();
	    },
	    columns: function columns() {
	      var columns = ['serial', 'customer', 'city', 'country'];
	      return this.showDetails ? columns.concat(this.statKeys) : columns.concat(_underscore2.default.keys(this.aggregateBy));
	    },
	    tableData: function tableData() {
	      var _this = this;
	
	      var data = this.showDetails ? this.serialStats : this.aggregateStats;
	
	      return _underscore2.default.map(data, function (stats, key) {
	        var obj = {
	          serial: key,
	          customer: _this.serialCustomer(key),
	          city: key in _this.details ? _this.details[key].latestTrack.location.city : '',
	          country: key in _this.details ? _this.details[key].latestTrack.location.country_name : ''
	        };
	
	        if (_this.showDetails) {
	          _underscore2.default.each(_this.statKeys, function (statKey) {
	            obj[statKey] = statKey in stats ? stats[statKey] : 0;
	          });
	        } else {
	          _underscore2.default.extend(obj, stats);
	        }
	
	        return obj;
	      });
	    },
	    statKeys: function statKeys() {
	      var _this2 = this;
	
	      var re = new RegExp(this.selectedProtocols.join('|'));
	
	      return _underscore2.default.filter(_underscore2.default.keys(this.proxyProtocolStats), function (item) {
	        if (_this2.selectedProtocols.length === 0) {
	          return false;
	        }
	        return item.match(re);
	      }).map(this.columnNameFixup);
	    },
	    serialStats: function serialStats() {
	      var _this3 = this;
	
	      var serialStats = {};
	
	      _underscore2.default.each(this.proxyProtocolStats, function (date, statKey) {
	        statKey = _this3.columnNameFixup(statKey);
	        _underscore2.default.each(date, function (stats) {
	          _underscore2.default.each(stats, function (val, serial) {
	            if (!(serial in serialStats)) {
	              serialStats[serial] = {};
	            }
	            if (!(statKey in serialStats[serial])) {
	              serialStats[serial][statKey] = 0;
	            }
	            serialStats[serial][statKey] += Number(val);
	          });
	        });
	      });
	
	      return serialStats;
	    },
	    aggregateStats: function aggregateStats() {
	      var _this4 = this;
	
	      return _underscore2.default.mapObject(this.serialStats, function (stat) {
	        var obj = {};
	
	        _underscore2.default.each(_this4.aggregateBy, function (val, aggregateKey) {
	          var total = 0;
	          _underscore2.default.each(val, function (statKey) {
	            total += stat[statKey] || 0;
	          });
	          obj[aggregateKey] = total;
	        });
	        return obj;
	      });
	    }
	  },
	
	  methods: {
	    fetch: function fetch() {
	      var _this5 = this;
	
	      var details = this.$apiWsoc.fetchDetails(null, this.dateStart.format('x'), this.dateEnd.format('x'));
	      var proxyProtocolStats = this.$apiWsoc.fetchProxyProtocolStats(this.dateStart.format('x'), this.dateEnd.format('x'));
	
	      this.$store.commit(mutationTypes.LOADER_LOADING);
	      _promise2.default.all([details, proxyProtocolStats]).then(function (_ref) {
	        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	            detailResult = _ref2[0],
	            protocolStatsResult = _ref2[1];
	
	        _this5.details = detailResult;
	        _this5.proxyProtocolStats = protocolStatsResult.result;
	
	        _this5.$store.commit(mutationTypes.LOADER_NOT_LOADING);
	      }).catch(function (error) {
	        console.log('error fetching security events', error);
	        _this5.$store.commit(mutationTypes.LOADER_NOT_LOADING);
	      });
	    },
	    dateRangeFormat: function dateRangeFormat(date) {
	      return (0, _moment2.default)(date).format(_constants2.default.M_FMT_READABLE_WEEKDAY);
	    },
	    dateRangeChange: function dateRangeChange(e) {
	      this.dateRange = e;
	    },
	    serialCustomer: function serialCustomer(serial) {
	      if (!(serial in this.details)) {
	        return '';
	      }
	
	      if (!('details' in this.details[serial]) || this.details[serial].details.length === 0) {
	        return '';
	      }
	
	      return this.details[serial].details[0].customer;
	    },
	    statProtocols: function statProtocols(statName) {
	      return PROTOCOLS.map(function (protocol) {
	        return protocol + ' ' + statName;
	      });
	    },
	    columnNameFixup: function columnNameFixup(columnName) {
	      return columnName.replace(/\./, ' ');
	    }
	  },
	
	  watch: {
	    dateRange: function dateRange() {
	      this.fetch();
	    }
	  }
	};

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(6);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _mutationTypes = __webpack_require__(2);
	
	var mutationTypes = _interopRequireWildcard(_mutationTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      epochStart: (0, _moment2.default)().subtract(30, 'days').format('x'),
	      epochEnd: (0, _moment2.default)().format('x'),
	      verdicts: []
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.$store.commit(mutationTypes.LOADER_LOADING);
	    this.$apiSandbox.fetchVerdicts(this.epochStart, this.epochEnd).then(function (result) {
	      _this.$store.commit(mutationTypes.LOADER_NOT_LOADING);
	      _this.verdicts = result;
	    });
	  },
	
	
	  computed: {
	    verdictsSorted: function verdictsSorted() {
	      return _underscore2.default.sortBy(this.verdicts, 'timestamp').reverse();
	    }
	  },
	
	  methods: {
	    epochDate: function epochDate(epoch) {
	      return (0, _moment2.default)(epoch, 'x').format('YYYY-MM-DD');
	    },
	    tableRowStyle: function tableRowStyle(classification) {
	      var styles = {
	        CLEAN: 'success',
	        APT: 'danger',
	        UNKNOWN: ''
	      };
	      if (!(classification in styles)) {
	        return '';
	      }
	
	      return styles[classification];
	    },
	    graywareDownloadLink: function graywareDownloadLink(sha1Checksum, size) {
	      return this.$apiSandbox.graywareDownloadLink(sha1Checksum, size);
	    },
	    graywareDownloadFilename: function graywareDownloadFilename(sha1Checksum, size) {
	      return sha1Checksum + '-' + size + '.dat';
	    }
	  }
	};

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _es6Promise = __webpack_require__(405);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _underscore = __webpack_require__(6);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _GoogleMap = __webpack_require__(69);
	
	var _GoogleMap2 = _interopRequireDefault(_GoogleMap);
	
	var _BootstrapPanel = __webpack_require__(210);
	
	var _BootstrapPanel2 = _interopRequireDefault(_BootstrapPanel);
	
	var _BootstrapPopover = __webpack_require__(459);
	
	var _BootstrapPopover2 = _interopRequireDefault(_BootstrapPopover);
	
	var _BootstrapModal = __webpack_require__(68);
	
	var _BootstrapModal2 = _interopRequireDefault(_BootstrapModal);
	
	var _Json = __webpack_require__(70);
	
	var _Json2 = _interopRequireDefault(_Json);
	
	var _httpRequest = __webpack_require__(22);
	
	var _httpRequest2 = _interopRequireDefault(_httpRequest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SANDBOX_PROCESSING_STATE_COMPLETED = 'COMPLETED';
	
	exports.default = {
	  components: {
	    GoogleMap: _GoogleMap2.default,
	    BootstrapPanel: _BootstrapPanel2.default,
	    BootstrapPopover: _BootstrapPopover2.default,
	    BootstrapModal: _BootstrapModal2.default,
	    Json: _Json2.default
	  },
	
	  data: function data() {
	    return {
	      sha1Checksum: '',
	      size: 0,
	      records: [],
	      classifications: [],
	      override: null,
	      updateMessage: '',
	      verdict: {},
	
	      PROCESSING_COMPLETED: SANDBOX_PROCESSING_STATE_COMPLETED
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.sha1Checksum = this.$route.params.sha1;
	    this.size = this.$route.params.size;
	
	    this.$apiSandbox.fetchVerdict(this.sha1Checksum, this.size).then(function (result) {
	      if (result.length > 0) {
	        _this.verdict = result[0];
	      }
	      return _this.$apiSandbox.fetchRecords(_this.sha1Checksum, _this.size);
	    }).then(function (result) {
	      _this.records = result;
	    });
	
	    this.$apiSandbox.fetchVerdictClassifications().then(function (result) {
	      _this.classifications = _underscore2.default.sortBy(result);
	    });
	
	    this.$apiSandbox.fetchVerdictOverride(this.sha1Checksum, this.size).then(function (result) {
	      if (result.data.length === 0) {
	        _this.override = '';
	      } else {
	        _this.override = result.data[0].classification;
	      }
	    });
	  },
	
	
	  methods: {
	    trim: function trim(val, length) {
	      return val ? val.substring(0, length) : '';
	    },
	    epochDate: function epochDate(epoch) {
	      return (0, _moment2.default)(epoch, 'x').format('YYYY-MM-DD');
	    },
	    overrideSubmit: function overrideSubmit() {
	      var _this2 = this;
	
	      var updatePromise;
	
	      if (this.override === '') {
	        updatePromise = this.$apiSandbox.deleteVerdictOverride(this.sha1Checksum, this.size);
	      } else {
	        updatePromise = this.$apiSandbox.updateVerdictOverride(this.sha1Checksum, this.size, this.override);
	      }
	
	      updatePromise.then(function (result) {
	        _this2.updateMessage = 'Successfully updated override.';
	
	        setTimeout(function () {
	          _this2.clearUpdateMessage();
	        }, 5000);
	      }).catch(function (error) {
	        _this2.updateMessage = 'Could not update override - an error occurred.';
	        console.log('error updating override', error);
	      });
	    },
	    clearUpdateMessage: function clearUpdateMessage() {
	      this.updateMessage = '';
	    }
	  },
	
	  computed: {
	    recordsSorted: function recordsSorted() {
	      return _underscore2.default.sortBy(this.records, 'timestamp');
	    },
	    ipAddresses: function ipAddresses() {
	      return _underscore2.default.chain(this.records).map(function (record) {
	        if ('metadata' in record && 'destAddr' in record.metadata) {
	          return record.metadata.destAddr;
	        } else {
	          return '';
	        }
	      }).uniq().without('').value();
	    },
	    hasAnalysisResult: function hasAnalysisResult() {
	      return 'analysisResult' in this.verdict;
	    }
	  },
	
	  asyncComputed: {
	    coordinates: function coordinates() {
	      var url = 'https://freegeoip.net/csv/';
	      var promises = [];
	      this.ipAddresses.map(function (ipAddress) {
	        promises.push(_httpRequest2.default.get(url + ipAddress).then(function (result) {
	          var fields = result.split(',');
	          return {
	            lat: Number(fields[8]),
	            long: Number(fields[9])
	          };
	        }));
	      });
	
	      return _es6Promise.Promise.all(promises);
	    }
	  }
	};

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(6);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _chart = __webpack_require__(223);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	var _license = __webpack_require__(51);
	
	var _license2 = _interopRequireDefault(_license);
	
	var _HighChart = __webpack_require__(211);
	
	var _HighChart2 = _interopRequireDefault(_HighChart);
	
	var _DateRangePicker = __webpack_require__(31);
	
	var _DateRangePicker2 = _interopRequireDefault(_DateRangePicker);
	
	var _TrackDays = __webpack_require__(475);
	
	var _TrackDays2 = _interopRequireDefault(_TrackDays);
	
	var _EventDays = __webpack_require__(460);
	
	var _EventDays2 = _interopRequireDefault(_EventDays);
	
	var _GoogleMap = __webpack_require__(69);
	
	var _GoogleMap2 = _interopRequireDefault(_GoogleMap);
	
	var _mutationTypes = __webpack_require__(2);
	
	var mutationTypes = _interopRequireWildcard(_mutationTypes);
	
	var _constants = __webpack_require__(12);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _stats = __webpack_require__(75);
	
	var _stats2 = _interopRequireDefault(_stats);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    HighChart: _HighChart2.default,
	    DateRangePicker: _DateRangePicker2.default,
	    TrackDays: _TrackDays2.default,
	    EventDays: _EventDays2.default,
	    GoogleMap: _GoogleMap2.default
	  },
	
	  data: function data() {
	    return {
	      serial: this.$route.params.id,
	      serialDetails: {},
	      serialLicenses: [],
	
	      trackLogs: [],
	      locations: [],
	
	      daterange: '',
	
	      activeTab: 'details',
	      tabs: ['details', 'licenses', 'proxy', 'os'],
	
	      malwareChartSeries: [],
	      malwareChartOptions: { chart: {} },
	
	      requestsChartSeries: [],
	      requestsChartOptions: { chart: {} },
	
	      bytesChartSeries: [],
	      bytesChartOptions: { chart: {} },
	
	      connectionsChartSeries: [],
	      connectionsChartOptions: { chart: {} },
	
	      aiMalwareChartSeries: [],
	      aiMalwareChartOptions: { chart: {} },
	
	      aiGraywareChartSeries: [],
	      aiGraywareChartOptions: { chart: {} },
	
	      sandboxMalwareChartSeries: [],
	      sandboxMalwareChartOptions: { chart: {} },
	
	      sandboxCleanChartSeries: [],
	      sandboxCleanChartOptions: { chart: {} },
	
	      urlsChartSeries: [],
	      urlsChartOptions: { chart: {} },
	
	      spamChartSeries: [],
	      spamChartOptions: { chart: {} },
	
	      uespFsCfChartSeries: [],
	      uespFsCfChartOptions: { chart: {} },
	
	      netIngressChartSeries: [],
	      netIngressChartOptions: { chart: {} },
	
	      netEgressChartSeries: [],
	      netEgressChartOptions: { chart: {} },
	
	      netControlChartSeries: [],
	      netControlChartOptions: { chart: {} },
	
	      netBridgeChartSeries: [],
	      netBridgeChartOptions: { chart: {} }
	    };
	  },
	  mounted: function mounted() {
	    this.malwareChartOptions = _chart2.default.chartOptions('column', 'AV Malware', 'count');
	    this.bytesChartOptions = _chart2.default.chartOptions('column', 'Bytes', 'count');
	    this.connectionsChartOptions = _chart2.default.chartOptions('column', 'Connections', 'count');
	    this.requestsChartOptions = _chart2.default.chartOptions('column', 'Requests', 'count');
	    this.aiMalwareChartOptions = _chart2.default.chartOptions('column', 'AI Malware', 'count');
	    this.aiGraywareChartOptions = _chart2.default.chartOptions('column', 'AI Grayware', 'count');
	    this.sandboxMalwareChartOptions = _chart2.default.chartOptions('column', 'Sandbox Malware', 'count');
	    this.sandboxCleanChartOptions = _chart2.default.chartOptions('column', 'Sandbox Clean', 'count');
	    this.urlsChartOptions = _chart2.default.chartOptions('column', 'Urls', 'count');
	    this.spamChartOptions = _chart2.default.chartOptions('column', 'Spam', 'count');
	
	    this.uespFsCfChartOptions = _chart2.default.percentageChartOptions('Disk Utilization', '');
	
	    this.netIngressChartOptions = _chart2.default.chartOptions('line', 'Ingress', 'bytes/sec');
	    this.netEgressChartOptions = _chart2.default.chartOptions('line', 'Egress', 'bytes/sec');
	    this.netControlChartOptions = _chart2.default.chartOptions('line', 'Control', 'bytes/sec');
	    this.netBridgeChartOptions = _chart2.default.chartOptions('line', 'Bridge', 'bytes/sec');
	
	    this.fetch();
	  },
	
	
	  computed: {
	    dateRange: {
	      get: function get() {
	        return this.$store.state.filterDateRange.dateRange;
	      },
	      set: function set(value) {
	        this.$store.commit(mutationTypes.FILTER_DATE_RANGE, value);
	      }
	    },
	    dateStart: function dateStart() {
	      return (0, _moment2.default)(this.dateRange[0], _constants2.default.M_FMT_MS).utc();
	    },
	    dateEnd: function dateEnd() {
	      return (0, _moment2.default)(this.dateRange[1], _constants2.default.M_FMT_MS).utc();
	    },
	    epochStart: function epochStart() {
	      return this.dateRange[0];
	    },
	    epochEnd: function epochEnd() {
	      return this.dateRange[1];
	    },
	    sortedTrackLogs: function sortedTrackLogs() {
	      return _underscore2.default.sortBy(this.trackLogs, 'range');
	    },
	    sortedLicenses: function sortedLicenses() {
	      return _underscore2.default.sortBy(this.serialLicenses, function (item) {
	        return item.activation.activateTime;
	      }).reverse();
	    },
	    licenseServices: function licenseServices() {
	      var services = [];
	      this.serialLicenses.forEach(function (license) {
	        services = services.concat(_underscore2.default.keys(license.attributes.license.service));
	      });
	      return _underscore2.default.sortBy(_underscore2.default.uniq(services));
	    },
	    reducedLicenses: function reducedLicenses() {
	      var _this = this;
	
	      var FMT_LIC = 'YYYY-MM-DD HH:mm';
	      return _underscore2.default.map(this.sortedLicenses, function (lic) {
	        var services = {};
	        var expired = false;
	        var expireSet = 'expires' in lic.attributes.license.root;
	        var durationSet = 'duration' in lic.attributes.license.root;
	        var duration = durationSet ? lic.attributes.license.root.duration : null;
	        var expiryDate = _license2.default.licenseExpiryDate(lic.activation.activateTime, lic.attributes.license.root.expires, duration);
	
	        _underscore2.default.each(_this.licenseServices, function (service) {
	          services[service] = service in lic.attributes.license.service && lic.attributes.license.service[service].enabled === 'true';
	        });
	
	        expired = (0, _moment2.default)().isAfter(expiryDate);
	
	        return {
	          key: lic.license.productKey,
	          activated: (0, _moment2.default)(lic.activation.activateTime).format(FMT_LIC),
	          issued: (0, _moment2.default)(lic.attributes.license.root.issued).format(FMT_LIC),
	          expires: expireSet ? (0, _moment2.default)(lic.attributes.license.root.expires) : '',
	          duration: duration || '',
	          services: services,
	          expired: expired,
	          expiryDate: expiryDate.format(FMT_LIC),
	          expiresFromNow: expiryDate.fromNow(),
	          expiresInDays: expiryDate.diff((0, _moment2.default)(), 'days')
	        };
	      });
	    },
	    softwareVersion: function softwareVersion() {
	      var length = this.sortedTrackLogs.length;
	      return length > 0 ? this.sortedTrackLogs[length - 1].softwareVersion : '';
	    },
	    locationCoordinates: function locationCoordinates() {
	      return _underscore2.default.map(this.locations, function (loc) {
	        return {
	          lat: loc.latitude,
	          long: loc.longitude
	        };
	      });
	    },
	    locationCountry: function locationCountry() {
	      return this.locationJoinField('country_name');
	    },
	    locationCity: function locationCity() {
	      return this.locationJoinField('city');
	    }
	  },
	
	  methods: {
	    dateRangeChange: function dateRangeChange(e) {
	      this.dateRange = e;
	    },
	    dateRangeFormat: function dateRangeFormat(date) {
	      return (0, _moment2.default)(date).format(_constants2.default.M_FMT_READABLE_WEEKDAY);
	    },
	    licenseRowClass: function licenseRowClass(expired, expiresInDays) {
	      var WARN_DAYS = 10;
	
	      if (expired) {
	        return 'danger';
	      }
	      return expiresInDays > 0 && expiresInDays < WARN_DAYS ? 'warning' : '';
	    },
	    showTab: function showTab(tabName) {
	      this.activeTab = tabName;
	    },
	    locationJoinField: function locationJoinField(fieldName) {
	      if (this.locations.length === 0) {
	        return '';
	      }
	      return _underscore2.default.uniq(_underscore2.default.pluck(this.locations, fieldName)).join(', ');
	    },
	
	    formatDate: function formatDate(date, format) {
	      var dateFormat = 'ddd MMM D, YYYY';
	      return (0, _moment2.default)(date, format).format(dateFormat);
	    },
	
	    fetch: function fetch() {
	      this.fetchTrack();
	
	      this.fetchStats();
	      this.fetchDetails();
	      this.fetchLicenses();
	    },
	    fetchTrack: function fetchTrack() {
	      var _this2 = this;
	
	      this.$apiWsoc.fetchTrack(this.serial, this.epochStart, this.epochEnd).then(function (result) {
	        _this2.trackLogs = result.result.Items;
	        _this2.locations = result.locations;
	      }).catch(function (error) {
	        console.log('fetch track error', error);
	      });
	    },
	
	
	    fetchDetails: function fetchDetails() {
	      var _this3 = this;
	
	      this.$apiWsoc.fetchDetails(this.serial).then(function (result) {
	        _this3.serialDetails = result.result;
	      }).catch(function (error) {
	        console.log('error', error);
	      });
	    },
	
	    fetchLicenses: function fetchLicenses() {
	      var _this4 = this;
	
	      this.$apiWsoc.fetchLicenses(this.serial).then(function (result) {
	        console.log('LICENSES', result);
	        _this4.serialLicenses = result.result;
	      }).catch(function (error) {
	        console.log('error', error);
	      });
	    },
	
	    fetchStats: function fetchStats() {
	      var _this5 = this;
	
	      this.$apiWsoc.fetchStats(this.serial, this.dateRange[0], this.dateRange[1]).then(function (result) {
	        var data = result.data;
	        var seriesData = function seriesData(dataObj) {
	          return _underscore2.default.values(dataObj).map(Number);
	        };
	
	        var chartSeries = function chartSeries(statName) {
	          return _stats2.default.protocols.map(function (protocol) {
	            return {
	              name: protocol,
	              data: seriesData(data[protocol + '.' + statName])
	            };
	          });
	        };
	
	
	        _this5.requestsChartSeries = chartSeries('totalRequests');
	        _this5.requestsChartOptions.xAxis.categories = _underscore2.default.keys(data['HTTP.totalRequests']);
	
	        _this5.malwareChartSeries = chartSeries('blockedVirus');
	        _this5.malwareChartOptions.xAxis.categories = _underscore2.default.keys(data['HTTP.blockedVirus']);
	
	        _this5.bytesChartSeries = chartSeries('totalBytesRead');
	        _this5.bytesChartOptions.xAxis.categories = _underscore2.default.keys(data['HTTP.totalBytesRead']);
	
	        _this5.connectionsChartSeries = chartSeries('totalConnections');
	        _this5.connectionsChartOptions.xAxis.categories = _underscore2.default.keys(data['HTTP.totalConnections']);
	
	        _this5.aiMalwareChartSeries = chartSeries('cylanceAvMalware');
	        _this5.aiMalwareChartOptions.xAxis.categories = _underscore2.default.keys(data['HTTP.cylanceAvMalware']);
	
	        _this5.aiGraywareChartSeries = chartSeries('cylanceAvGrayware');
	        _this5.aiGraywareChartOptions.xAxis.categories = _underscore2.default.keys(data['HTTP.cylanceAvGrayware']);
	
	        _this5.sandboxMalwareChartSeries = chartSeries('sandboxAvHashMalware');
	        _this5.sandboxMalwareChartOptions.xAxis.categories = _underscore2.default.keys(data['HTTP.sandboxAvHashMalware']);
	
	        _this5.sandboxCleanChartSeries = chartSeries('sandboxAvHashClean');
	        _this5.sandboxCleanChartOptions.xAxis.categories = _underscore2.default.keys(data['HTTP.sandboxAvHashClean']);
	
	        _this5.urlsChartSeries = [{
	          name: 'Blocked URL',
	          data: seriesData(data['HTTP.blockedUrls'])
	        }, {
	          name: 'Blocked WF URL',
	          data: seriesData(data['HTTP.blockedWfUrls'])
	        }, {
	          name: 'Warned WF URL',
	          data: seriesData(data['HTTP.warnedWfUrls'])
	        }, {
	          name: 'Blocked CM URL',
	          data: seriesData(data['HTTP.blockedCMUrls'])
	        }, {
	          name: 'Warned CM URL',
	          data: seriesData(data['HTTP.warnedCMUrls'])
	        }];
	        _this5.urlsChartOptions.xAxis.categories = _underscore2.default.keys(data['HTTP.blockedUrls']);
	
	        _this5.spamChartSeries = [{
	          name: 'SMTP',
	          data: seriesData(data['SMTP.spamCount'])
	        }, {
	          name: 'POP3',
	          data: seriesData(data['POP3.spamCount'])
	        }, {
	          name: 'IMAP',
	          data: seriesData(data['IMAP.spamCount'])
	        }];
	        _this5.spamChartOptions.xAxis.categories = _underscore2.default.keys(data['SMTP.spamCount']);
	
	        _this5.uespFsCfChartSeries = [{
	          name: 'Free',
	          data: seriesData(data['uesp-fs-cf']).map(function (val) {
	            return 100 - val;
	          })
	        }, {
	          name: 'Used',
	          data: seriesData(data['uesp-fs-cf'])
	        }];
	        _this5.uespFsCfChartOptions.xAxis.categories = _underscore2.default.keys(data['uesp-fs-cf']);
	
	        _this5.netIngressChartSeries = [{
	          name: 'tx bytes',
	          data: seriesData(data['ingress_tx_bytes'])
	        }, {
	          name: 'rx bytes',
	          data: seriesData(data['ingress_rx_bytes'])
	        }];
	        _this5.netIngressChartOptions.xAxis.categories = _underscore2.default.keys(data['ingress_tx_bytes']);
	
	        _this5.netEgressChartSeries = [{
	          name: 'tx bytes',
	          data: seriesData(data['egress_tx_bytes'])
	        }, {
	          name: 'rx bytes',
	          data: seriesData(data['egress_rx_bytes'])
	        }];
	        _this5.netEgressChartOptions.xAxis.categories = _underscore2.default.keys(data['egress_tx_bytes']);
	
	        _this5.netControlChartSeries = [{
	          name: 'tx bytes',
	          data: seriesData(data['control_tx_bytes'])
	        }, {
	          name: 'rx bytes',
	          data: seriesData(data['control_rx_bytes'])
	        }];
	        _this5.netControlChartOptions.xAxis.categories = _underscore2.default.keys(data['control_tx_bytes']);
	
	        _this5.netBridgeChartSeries = [{
	          name: 'tx bytes',
	          data: seriesData(data['bridge_tx_bytes'])
	        }, {
	          name: 'rx bytes',
	          data: seriesData(data['bridge_rx_bytes'])
	        }];
	        _this5.netBridgeChartOptions.xAxis.categories = _underscore2.default.keys(data['bridge_tx_bytes']);
	      }).catch(function (error) {
	        console.log('error', error);
	      });
	    }
	  },
	
	  watch: {
	    dateRange: function dateRange() {
	      this.fetchStats();
	      this.fetchTrack();
	    }
	  }
	};

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _underscore = __webpack_require__(6);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _escapeStringRegexp = __webpack_require__(406);
	
	var _escapeStringRegexp2 = _interopRequireDefault(_escapeStringRegexp);
	
	var _DateRangePicker = __webpack_require__(31);
	
	var _DateRangePicker2 = _interopRequireDefault(_DateRangePicker);
	
	var _mutationTypes = __webpack_require__(2);
	
	var mutationTypes = _interopRequireWildcard(_mutationTypes);
	
	var _constants = __webpack_require__(12);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    DateRangePicker: _DateRangePicker2.default
	  },
	
	  data: function data() {
	    return {
	      serials: []
	    };
	  },
	
	
	  computed: {
	    dateRange: {
	      get: function get() {
	        return this.$store.state.filterDateRange.dateRange;
	      },
	      set: function set(value) {
	        this.$store.commit(mutationTypes.FILTER_DATE_RANGE, value);
	      }
	    },
	    selectedCustomer: {
	      get: function get() {
	        return this.$store.state.filterSerialList.selectCustomer;
	      },
	      set: function set(value) {
	        this.$store.commit(mutationTypes.FILTER_SERIALS_SELECT_CUSTOMER, value);
	      }
	    },
	    selectedCity: {
	      get: function get() {
	        return this.$store.state.filterSerialList.selectCity;
	      },
	      set: function set(value) {
	        this.$store.commit(mutationTypes.FILTER_SERIALS_SELECT_CITY, value);
	      }
	    },
	    selectedCountry: {
	      get: function get() {
	        return this.$store.state.filterSerialList.selectCountry;
	      },
	      set: function set(value) {
	        this.$store.commit(mutationTypes.FILTER_SERIALS_SELECT_COUNTRY, value);
	      }
	    },
	    searchTerm: {
	      get: function get() {
	        return this.$store.state.filterSerialList.search;
	      },
	      set: function set(value) {
	        this.$store.commit(mutationTypes.FILTER_SERIALS_SEARCH, value);
	      }
	    },
	    dateStart: function dateStart() {
	      return (0, _moment2.default)(this.dateRange[0], _constants2.default.M_FMT_MS).utc();
	    },
	    dateEnd: function dateEnd() {
	      return (0, _moment2.default)(this.dateRange[1], _constants2.default.M_FMT_MS).utc();
	    },
	    epochStart: function epochStart() {
	      return this.dateRange[0];
	    },
	    epochEnd: function epochEnd() {
	      return this.dateRange[1];
	    },
	    serialCount: function serialCount() {
	      return this.reducedSerials.length;
	    },
	    filteredSerialCount: function filteredSerialCount() {
	      return this.filteredSerials.length;
	    },
	    customers: function customers() {
	      return this.pluckFilterValues('customer');
	    },
	    cities: function cities() {
	      return this.pluckFilterValues('city');
	    },
	    countries: function countries() {
	      return this.pluckFilterValues('country');
	    },
	    reducedSerials: function reducedSerials() {
	      return _underscore2.default.map(this.serials, function (val, key) {
	        return {
	          serial: key,
	          serial8: key.substring(0, 8),
	          customer: val.details.length > 0 ? val.details[0].customer : '',
	          serviceTag: val.details.length > 0 ? val.details[0].serviceTag : '',
	          city: val.latestTrack.location.city || '',
	          country: val.latestTrack.location.country_name || '',
	          softwareVersion: val.latestTrack.softwareVersion,
	          lastTracked: (0, _moment2.default)(val.latestTrack.range).format('YYYY-MM-DD HH:mm:ss')
	        };
	      });
	    },
	    filteredSerials: function filteredSerials() {
	      var vm = this;
	      var re = new RegExp((0, _escapeStringRegexp2.default)(this.searchTerm), 'ig');
	
	      return _underscore2.default.chain(this.reducedSerials).filter(function (val) {
	        return (vm.searchTerm === '' || val.serial.match(re) || val.serviceTag.match(re) || val.customer.match(re) || val.city.match(re) || val.country.match(re)) && (vm.selectedCustomer === '' || vm.selectedCustomer !== '' && vm.selectedCustomer === val.customer) && (vm.selectedCity === '' || vm.selectedCity !== '' && vm.selectedCity === val.city) && (vm.selectedCountry === '' || vm.selectedCountry !== '' && vm.selectedCountry === val.country);
	      }).sortBy('lastTracked').reverse().value();
	    }
	  },
	
	  mounted: function mounted() {
	    this.fetch();
	  },
	
	
	  methods: {
	    dateRangeChange: function dateRangeChange(e) {
	      this.dateRange = e;
	    },
	    fetch: function fetch() {
	      var _this = this;
	
	      this.$store.commit(mutationTypes.LOADER_LOADING);
	      this.$apiWsoc.fetchDetails(null, this.epochStart, this.epochEnd).then(function (result) {
	        _this.$store.commit(mutationTypes.LOADER_NOT_LOADING);
	
	        _this.serials = result;
	      }).catch(function (error) {
	        _this.$store.commit(mutationTypes.LOADER_NOT_LOADING);
	        console.log('serial list fetch error', error);
	      });
	    },
	    clearFilters: function clearFilters() {
	      this.searchTerm = '';
	      this.selectedCity = '';
	      this.selectedCountry = '';
	      this.selectedCustomer = '';
	    },
	    pluckFilterValues: function pluckFilterValues(key) {
	      return _underscore2.default.chain(this.reducedSerials).pluck(key).uniq().without('').sortBy().value();
	    },
	    dateRangeFormat: function dateRangeFormat(date) {
	      return (0, _moment2.default)(date).format(_constants2.default.M_FMT_READABLE_WEEKDAY);
	    }
	  },
	
	  watch: {
	    dateRange: function dateRange() {
	      this.fetch();
	    }
	  }
	};

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _NavBar = __webpack_require__(213);
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _LoadingBar = __webpack_require__(212);
	
	var _LoadingBar2 = _interopRequireDefault(_LoadingBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    NavBar: _NavBar2.default,
	    LoadingBar: _LoadingBar2.default
	  }
	};

/***/ },
/* 259 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  components: {}
	};

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(24);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  $el: function $el() {
	    return '#el';
	  },
	  data: function data() {
	    return {};
	  },
	
	
	  props: {
	    dateStart: {
	      type: String,
	      required: true,
	      default: function _default() {
	        return '';
	      }
	    },
	    dateEnd: {
	      type: String,
	      required: true,
	      default: function _default() {
	        return '';
	      }
	    },
	    days: {
	      type: Array,
	      required: true,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	
	  computed: {
	    trackDays: function trackDays() {
	      var trackDays = [];
	      var date = (0, _moment2.default)(this.dateStart, 'x');
	
	      do {
	        trackDays[date.format('YYYYMMDD')] = 0;
	        date = date.add(1, 'day');
	      } while (date.format('x') < this.dateEnd);
	
	      return trackDays;
	    },
	    dayStyles: function dayStyles() {
	      var date, keys, i;
	      var dayStyles = [];
	
	      for (i = 0; i < this.days.length; i++) {
	        date = (0, _moment2.default)(this.days[i].range).format('YYYYMMDD');
	
	        if (date in this.trackDays) {
	          this.trackDays[date] = 1;
	        }
	      }
	
	      keys = (0, _keys2.default)(this.trackDays).sort();
	      for (i = 0; i < keys.length; i++) {
	        dayStyles.push(this.trackDays[keys[i]] === 1 ? 'present' : 'missing');
	      }
	
	      return dayStyles;
	    }
	  }
	};

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(357);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _underscore = __webpack_require__(6);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vuex = __webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    userProfile: 'user'
	  }), {
	    roles: function roles() {
	      return _underscore2.default.sortBy(_underscore2.default.pluck(this.userProfile.roles, 'name')).join(', ');
	    }
	  })
	};

/***/ },
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function () {
	  return function (h) {
	
	    var items = [];
	
	    this.pages.map(function (page) {
	      items.push(h(
	        "li",
	        { "class": "VuePagination__pagination-item page-item " + this.activeClass(page) },
	        [h(
	          "a",
	          { "class": "page-link", attrs: { href: "javascript:void(0);"
	            },
	            on: {
	              "click": this.setPage.bind(this, page)
	            }
	          },
	          [page]
	        )]
	      ));
	    }.bind(this));
	
	    return h(
	      "div",
	      { "class": "VuePagination" },
	      [h(
	        "ul",
	        {
	          directives: [{
	            name: "show",
	            value: this.totalPages > 1
	          }],
	
	          "class": "pagination VuePagination__pagination" },
	        [h(
	          "li",
	          { "class": "VuePagination__pagination-item page-item VuePagination__pagination-item-prev-chunk " + this.allowedChunkClass(-1) },
	          [h(
	            "a",
	            { "class": "page-link", attrs: { href: "javascript:void(0);"
	              },
	              on: {
	                "click": this.setChunk.bind(this, -1)
	              }
	            },
	            ["<<"]
	          )]
	        ), h(
	          "li",
	          { "class": "VuePagination__pagination-item page-item VuePagination__pagination-item-prev-page " + this.allowedPageClass(this.page - 1) },
	          [h(
	            "a",
	            { "class": "page-link", attrs: { href: "javascript:void(0);"
	              },
	              on: {
	                "click": this.prev.bind(this)
	              }
	            },
	            ["<"]
	          )]
	        ), items, h(
	          "li",
	          { "class": "VuePagination__pagination-item page-item VuePagination__pagination-item-next-page " + this.allowedPageClass(this.page + 1) },
	          [h(
	            "a",
	            { "class": "page-link", attrs: { href: "javascript:void(0);"
	              },
	              on: {
	                "click": this.next.bind(this)
	              }
	            },
	            [">"]
	          )]
	        ), h(
	          "li",
	          { "class": "VuePagination__pagination-item page-item VuePagination__pagination-item-next-chunk " + this.allowedChunkClass(1) },
	          [h(
	            "a",
	            { "class": "page-link", attrs: { href: "javascript:void(0);"
	              },
	              on: {
	                "click": this.setChunk.bind(this, 1)
	              }
	            },
	            [">>"]
	          )]
	        )]
	      ), h(
	        "p",
	        {
	          directives: [{
	            name: "show",
	            value: parseInt(this.records)
	          }],
	
	          "class": "VuePagination__count" },
	        [this.count]
	      )]
	    );
	  };
	};

/***/ },
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _defineProperty2 = __webpack_require__(8);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (h, that) {
	
	  if (!that.opts.filterByColumn || !that.opts.filterable) return '';
	
	  var textFilter = __webpack_require__(343)(h, that);
	  var dateFilter = __webpack_require__(330)(h, that);
	  var listFilter = __webpack_require__(335)(h, that);
	
	  var filters = [];
	  var filter;
	
	  if (that.opts.childRow) filters.push(h(
	    'th',
	    null,
	    []
	  ));
	
	  that.allColumns.map(function (column) {
	
	    if (that.filterable(column)) {
	
	      switch (true) {
	        case that.isTextFilter(column):
	          filter = textFilter(column);break;
	        case that.isDateFilter(column):
	          filter = dateFilter(column);break;
	        case that.isListFilter(column):
	          filter = listFilter(column);break;
	      }
	    } else {
	      filter = '';
	    }
	
	    filters.push(h(
	      'th',
	      null,
	      [h(
	        'div',
	        (0, _defineProperty3.default)({ 'class': 'VueTables__column-filter' }, 'class', 'VueTables__' + column + '-filter-wrapper'),
	        [filter]
	      )]
	    ));
	  });
	
	  return h(
	    'tr',
	    { 'class': 'VueTables__filters-row' },
	    [filters]
	  );
	};

/***/ },
/* 330 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (h, that) {
	  return function (column) {
	    return h(
	      'div',
	      { 'class': 'VueTables__date-filter',
	        attrs: { id: 'VueTables__' + column + '-filter' }
	      },
	      [h(
	        'span',
	        { 'class': 'VueTables__filter-placeholder' },
	        [that.display('filterBy', { column: that.getHeading(column) })]
	      )]
	    );
	  };
	};

/***/ },
/* 331 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (h, that) {
	
	  if (that.count > 0 && that.opts.pagination.dropdown) {
	
	    var perPage = parseInt(that.limit);
	
	    var from = (that.Page - 1) * perPage + 1;
	    var to = that.Page == that.totalPages ? that.count : from + perPage - 1;
	
	    var parts = that.opts.texts.count.split('|');
	    var i = Math.min(that.count == 1 ? 2 : that.totalPages == 1 ? 1 : 0, parts.length - 1);
	
	    var count = parts[i].replace('{count}', that.count).replace('{from}', from).replace('{to}', to);
	
	    return h(
	      'div',
	      { 'class': 'VuePagination' },
	      [h(
	        'p',
	        { 'class': 'VuePagination__count' },
	        [count]
	      )]
	    );
	  }
	
	  return '';
	};

/***/ },
/* 332 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (h, that) {
	
	    if (that.opts.pagination && that.opts.pagination.dropdown) {
	
	        var pages = [];
	        var selected;
	
	        for (var pag = 1; pag <= that.totalPages; pag++) {
	            var selected = that.page == pag;
	            pages.push(h(
	                'option',
	                {
	                    attrs: { value: pag, selected: selected }
	                },
	                [pag]
	            ));
	        }
	
	        var id = 'VueTables__dropdown-pagination_' + that.id;
	        return h(
	            'div',
	            { 'class': 'form-group form-inline pull-right VueTables__dropdown-pagination',
	                directives: [{
	                    name: 'show',
	                    value: that.totalPages > 1
	                }]
	            },
	            [h(
	                'label',
	                {
	                    attrs: { 'for': id }
	                },
	                [that.display('page')]
	            ), h(
	                'select',
	                { 'class': 'form-control',
	                    attrs: { name: 'page',
	
	                        value: that.page,
	
	                        id: id
	                    },
	                    ref: 'page', on: {
	                        'change': that.setPage.bind(that, null)
	                    }
	                },
	                [pages]
	            )]
	        );
	    }
	
	    return '';
	};

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _defineProperty2 = __webpack_require__(8);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function (h, that) {
	
	  if (!that.opts.footerHeadings) return '';
	
	  var footerHeadings = [];
	
	  if (that.opts.footerHeadings) {
	
	    var columns = that.allColumns;
	
	    columns.map(function (column) {
	
	      footerHeadings.push(h(
	        "th",
	        {
	          on: {
	            "click": that.orderByColumn.bind(that, column)
	          },
	          "class": that.sortableClass(column) },
	        [h(
	          "span",
	          { "class": "VueTables__heading" },
	          [that.getHeading(column)]
	        ), h(
	          "span",
	          (0, _defineProperty3.default)({
	            directives: [{
	              name: "show",
	              value: that.sortable(column)
	            }],
	
	            "class": "VueTables__sort-icon pull-right"
	          }, "class", that.sortableChevronClass(column)),
	          []
	        )]
	      ));
	    });
	  }
	
	  return h(
	    "tfoot",
	    null,
	    [h(
	      "tr",
	      null,
	      [footerHeadings]
	    )]
	  );
	};

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = function (h, that) {
	
	  var sortControl = __webpack_require__(342)(h, that);
	
	  var headings = [];
	
	  if (that.opts.childRow) headings.push(h(
	    "th",
	    null,
	    []
	  ));
	
	  that.allColumns.map(function (column) {
	    headings.push(h(
	      "th",
	      {
	        on: {
	          "click": that.orderByColumn.bind(that, column)
	        },
	
	        "class": that.sortableClass(column) },
	      [h(
	        "span",
	        { "class": "VueTables__heading" },
	        [that.getHeading(column, h)]
	      ), sortControl(column)]
	    ));
	  }.bind(that));
	
	  return headings;
	};

/***/ },
/* 335 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (h, that) {
	
	  return function (column) {
	
	    var options = [];
	    var selected = void 0;
	
	    var search = that.source == 'client' ? that.search.bind(that, that.data) : that.serverSearch.bind(that);
	
	    that.opts.listColumns[column].map(function (option) {
	      selected = option.id == that.query[column] && that.query[column] !== '';
	      options.push(h(
	        'option',
	        {
	          attrs: { value: option.id, selected: selected }
	        },
	        [option.text]
	      ));
	    });
	
	    return h(
	      'div',
	      { 'class': 'VueTables__list-filter',
	        attrs: { id: 'VueTables__' + column + '-filter' }
	      },
	      [h(
	        'select',
	        { 'class': 'form-control',
	          on: {
	            'change': search
	          },
	          attrs: {
	            name: column,
	            value: that.query[column] }
	        },
	        [h(
	          'option',
	          {
	            attrs: { value: '' }
	          },
	          [that.display('defaultOption', { column: that.getHeading(column) })]
	        ), options]
	      )]
	    );
	  };
	};

/***/ },
/* 336 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function (h, that) {
	  if (that.count == 0) {
	
	    var colspan = that.allColumns.length;
	    if (that.opts.childRow) colspan++;
	
	    return h(
	      "tr",
	      { "class": "VueTables__no-results" },
	      [h(
	        "td",
	        { "class": "text-center",
	          attrs: { colspan: colspan }
	        },
	        [that.display(that.loading ? 'loading' : 'noResults')]
	      )]
	    );
	  }
	};

/***/ },
/* 337 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (h, that) {
	
	  if (!that.opts.filterable) return '';
	
	  var search = that.source == 'client' ? that.search.bind(that, that.data) : that.serverSearch.bind(that);
	
	  if (that.opts.filterable && !that.opts.filterByColumn) {
	    var id = 'VueTables__search_' + that.id;
	    return h(
	      'div',
	      { 'class': 'form-group form-inline pull-left VueTables__search' },
	      [h(
	        'label',
	        {
	          attrs: { 'for': id }
	        },
	        [that.display('filter')]
	      ), h(
	        'input',
	        { 'class': 'form-control',
	          attrs: { type: 'text',
	            value: that.query,
	            placeholder: that.display('filterPlaceholder'),
	
	            id: id
	          },
	          on: {
	            'keyup': search
	          }
	        },
	        []
	      )]
	    );
	  }
	
	  return '';
	};

/***/ },
/* 338 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function (h, that) {
	  if (that.opts.pagination && !that.opts.pagination.dropdown) {
	
	    var name = that.vuex ? that.name : that.id;
	
	    return h(
	      "pagination",
	      {
	        ref: "pagination",
	        attrs: { "for": name,
	          records: that.count,
	          "per-page": parseInt(that.limit),
	          chunk: that.opts.pagination.chunk,
	          "count-text": that.opts.texts.count }
	      },
	      []
	    );
	  }
	
	  return '';
	};

/***/ },
/* 339 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function (h, that) {
	  var perpageValues = [];
	
	  that.opts.perPageValues.every(function (value) {
	    var isLastEntry = value >= that.count;
	    var selected = that.limit == value || isLastEntry && that.limit > value;
	    perpageValues.push(h(
	      "option",
	      {
	        attrs: { value: value, selected: selected }
	      },
	      [value]
	    ));
	    return !isLastEntry;
	  });
	
	  return perpageValues;
	};

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function (h, that) {
	
	  var perpageValues = __webpack_require__(339)(h, that);
	
	  if (perpageValues.length > 1) {
	    var id = 'VueTables__limit_' + that.id;
	    return h(
	      'div',
	      { 'class': 'form-group form-inline pull-right VueTables__limit' },
	      [h(
	        'label',
	        {
	          attrs: { 'for': id }
	        },
	        [that.display('limit')]
	      ), h(
	        'select',
	        { 'class': 'form-control',
	          attrs: { name: 'limit',
	            value: that.limit,
	
	            id: id
	          },
	          on: {
	            'change': that.setLimit.bind(that)
	          }
	        },
	        [perpageValues]
	      )]
	    );
	  }
	
	  return '';
	};

/***/ },
/* 341 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (h, that) {
	  var rows = [];
	  var columns;
	  var rowKey = that.opts.childRowKey;
	  var rowClass;
	  var data = that.source == 'client' ? that.filteredData : that.tableData;
	
	  data.map(function (row, index) {
	    columns = [];
	
	    if (that.opts.childRow) columns.push(h(
	      'td',
	      null,
	      [h(
	        'span',
	        {
	          on: {
	            'click': that.toggleChildRow.bind(that, row[rowKey])
	          },
	          'class': 'VueTables__child-row-toggler ' + that.childRowTogglerClass(row[rowKey]) },
	        []
	      )]
	    ));
	
	    that.allColumns.map(function (column) {
	      columns.push(h(
	        'td',
	        null,
	        [that.render(row, column, h)]
	      ));
	    }.bind(that));
	
	    rowClass = that.opts.rowClassCallback ? that.opts.rowClassCallback(row) : '';
	
	    rows.push(h(
	      'tr',
	      { 'class': rowClass, on: {
	          'click': that.rowWasClicked.bind(that, row)
	        }
	      },
	      [columns, ' ']
	    ));
	
	    if (that.opts.childRow && this.rowsToggleState['row_' + row[rowKey]]) {
	      var childRow = that.opts.childRow;
	      var template = typeof childRow === 'function' ? childRow.apply(that, [h, row]) : h(childRow, {
	        attrs: {
	          data: row
	        }
	      });
	      rows.push(h(
	        'tr',
	        { 'class': 'VueTables__child-row' },
	        [h(
	          'td',
	          {
	            attrs: { colspan: that.allColumns.length + 1 }
	          },
	          [template]
	        )]
	      ));
	    }
	  }.bind(that));
	
	  return rows;
	};

/***/ },
/* 342 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (h, that) {
	  return function (column) {
	
	    if (!that.sortable(column)) return '';
	    return h(
	      'span',
	      { 'class': 'VueTables__sort-icon pull-right ' + that.sortableChevronClass(column) },
	      []
	    );
	  }.bind(that);
	};

/***/ },
/* 343 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function (h, that) {
	
	      var search = that.source == 'client' ? that.search.bind(that, that.data) : that.serverSearch.bind(that);
	
	      return function (column) {
	            return h(
	                  "input",
	                  {
	                        on: {
	                              "keyup": search
	                        },
	
	                        "class": "form-control",
	                        attrs: { name: column,
	                              type: "text",
	                              placeholder: that.display('filterBy', { column: that.getHeading(column) }),
	                              value: that.query[column]
	                        }
	                  },
	                  []
	            );
	      };
	};

/***/ },
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	
	exports.default = function (h, row) {
	   return h(
	      'a',
	      {
	         attrs: { href: '#/soc/serial/' + row.serial }
	      },
	      [row.serial.substring(0, 8)]
	   );
	};

/***/ },
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 408 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 409 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 410 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 411 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 412 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 413 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 414 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 415 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 416 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 417 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 418 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 419 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 420 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 421 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 422 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 423 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 424 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 425 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 426 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 427 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 428 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 429 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 430 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 431 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 432 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 433 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 434 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 435 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 436 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 437 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 438 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 439 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 440 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 441 */,
/* 442 */,
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var jQuery = __webpack_require__(30);
	
	'use strict';
	
	var _typeof2 = __webpack_require__(39);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	if (typeof jQuery === 'undefined') {
	  throw new Error('Bootstrap\'s JavaScript requires jQuery');
	}
	
	+function ($) {
	  'use strict';
	
	  var version = $.fn.jquery.split(' ')[0].split('.');
	  if (version[0] < 2 && version[1] < 9 || version[0] == 1 && version[1] == 9 && version[2] < 1 || version[0] > 3) {
	    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4');
	  }
	}(jQuery);
	
	+function ($) {
	  'use strict';
	
	  function transitionEnd() {
	    var el = document.createElement('bootstrap');
	
	    var transEndEventNames = {
	      WebkitTransition: 'webkitTransitionEnd',
	      MozTransition: 'transitionend',
	      OTransition: 'oTransitionEnd otransitionend',
	      transition: 'transitionend'
	    };
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return { end: transEndEventNames[name] };
	      }
	    }
	
	    return false;
	  }
	
	  $.fn.emulateTransitionEnd = function (duration) {
	    var called = false;
	    var $el = this;
	    $(this).one('bsTransitionEnd', function () {
	      called = true;
	    });
	    var callback = function callback() {
	      if (!called) $($el).trigger($.support.transition.end);
	    };
	    setTimeout(callback, duration);
	    return this;
	  };
	
	  $(function () {
	    $.support.transition = transitionEnd();
	
	    if (!$.support.transition) return;
	
	    $.event.special.bsTransitionEnd = {
	      bindType: $.support.transition.end,
	      delegateType: $.support.transition.end,
	      handle: function handle(e) {
	        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments);
	      }
	    };
	  });
	}(jQuery);
	
	+function ($) {
	  'use strict';
	
	  var dismiss = '[data-dismiss="alert"]';
	  var Alert = function Alert(el) {
	    $(el).on('click', dismiss, this.close);
	  };
	
	  Alert.VERSION = '3.3.7';
	
	  Alert.TRANSITION_DURATION = 150;
	
	  Alert.prototype.close = function (e) {
	    var $this = $(this);
	    var selector = $this.attr('data-target');
	
	    if (!selector) {
	      selector = $this.attr('href');
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '');
	    }
	
	    var $parent = $(selector === '#' ? [] : selector);
	
	    if (e) e.preventDefault();
	
	    if (!$parent.length) {
	      $parent = $this.closest('.alert');
	    }
	
	    $parent.trigger(e = $.Event('close.bs.alert'));
	
	    if (e.isDefaultPrevented()) return;
	
	    $parent.removeClass('in');
	
	    function removeElement() {
	      $parent.detach().trigger('closed.bs.alert').remove();
	    }
	
	    $.support.transition && $parent.hasClass('fade') ? $parent.one('bsTransitionEnd', removeElement).emulateTransitionEnd(Alert.TRANSITION_DURATION) : removeElement();
	  };
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.alert');
	
	      if (!data) $this.data('bs.alert', data = new Alert(this));
	      if (typeof option == 'string') data[option].call($this);
	    });
	  }
	
	  var old = $.fn.alert;
	
	  $.fn.alert = Plugin;
	  $.fn.alert.Constructor = Alert;
	
	  $.fn.alert.noConflict = function () {
	    $.fn.alert = old;
	    return this;
	  };
	
	  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close);
	}(jQuery);
	
	+function ($) {
	  'use strict';
	
	  var Button = function Button(element, options) {
	    this.$element = $(element);
	    this.options = $.extend({}, Button.DEFAULTS, options);
	    this.isLoading = false;
	  };
	
	  Button.VERSION = '3.3.7';
	
	  Button.DEFAULTS = {
	    loadingText: 'loading...'
	  };
	
	  Button.prototype.setState = function (state) {
	    var d = 'disabled';
	    var $el = this.$element;
	    var val = $el.is('input') ? 'val' : 'html';
	    var data = $el.data();
	
	    state += 'Text';
	
	    if (data.resetText == null) $el.data('resetText', $el[val]());
	
	    setTimeout($.proxy(function () {
	      $el[val](data[state] == null ? this.options[state] : data[state]);
	
	      if (state == 'loadingText') {
	        this.isLoading = true;
	        $el.addClass(d).attr(d, d).prop(d, true);
	      } else if (this.isLoading) {
	        this.isLoading = false;
	        $el.removeClass(d).removeAttr(d).prop(d, false);
	      }
	    }, this), 0);
	  };
	
	  Button.prototype.toggle = function () {
	    var changed = true;
	    var $parent = this.$element.closest('[data-toggle="buttons"]');
	
	    if ($parent.length) {
	      var $input = this.$element.find('input');
	      if ($input.prop('type') == 'radio') {
	        if ($input.prop('checked')) changed = false;
	        $parent.find('.active').removeClass('active');
	        this.$element.addClass('active');
	      } else if ($input.prop('type') == 'checkbox') {
	        if ($input.prop('checked') !== this.$element.hasClass('active')) changed = false;
	        this.$element.toggleClass('active');
	      }
	      $input.prop('checked', this.$element.hasClass('active'));
	      if (changed) $input.trigger('change');
	    } else {
	      this.$element.attr('aria-pressed', !this.$element.hasClass('active'));
	      this.$element.toggleClass('active');
	    }
	  };
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.button');
	      var options = (typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) == 'object' && option;
	
	      if (!data) $this.data('bs.button', data = new Button(this, options));
	
	      if (option == 'toggle') data.toggle();else if (option) data.setState(option);
	    });
	  }
	
	  var old = $.fn.button;
	
	  $.fn.button = Plugin;
	  $.fn.button.Constructor = Button;
	
	  $.fn.button.noConflict = function () {
	    $.fn.button = old;
	    return this;
	  };
	
	  $(document).on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	    var $btn = $(e.target).closest('.btn');
	    Plugin.call($btn, 'toggle');
	    if (!$(e.target).is('input[type="radio"], input[type="checkbox"]')) {
	      e.preventDefault();
	
	      if ($btn.is('input,button')) $btn.trigger('focus');else $btn.find('input:visible,button:visible').first().trigger('focus');
	    }
	  }).on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	    $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type));
	  });
	}(jQuery);
	
	+function ($) {
	  'use strict';
	
	  var Carousel = function Carousel(element, options) {
	    this.$element = $(element);
	    this.$indicators = this.$element.find('.carousel-indicators');
	    this.options = options;
	    this.paused = null;
	    this.sliding = null;
	    this.interval = null;
	    this.$active = null;
	    this.$items = null;
	
	    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this));
	
	    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element.on('mouseenter.bs.carousel', $.proxy(this.pause, this)).on('mouseleave.bs.carousel', $.proxy(this.cycle, this));
	  };
	
	  Carousel.VERSION = '3.3.7';
	
	  Carousel.TRANSITION_DURATION = 600;
	
	  Carousel.DEFAULTS = {
	    interval: 5000,
	    pause: 'hover',
	    wrap: true,
	    keyboard: true
	  };
	
	  Carousel.prototype.keydown = function (e) {
	    if (/input|textarea/i.test(e.target.tagName)) return;
	    switch (e.which) {
	      case 37:
	        this.prev();break;
	      case 39:
	        this.next();break;
	      default:
	        return;
	    }
	
	    e.preventDefault();
	  };
	
	  Carousel.prototype.cycle = function (e) {
	    e || (this.paused = false);
	
	    this.interval && clearInterval(this.interval);
	
	    this.options.interval && !this.paused && (this.interval = setInterval($.proxy(this.next, this), this.options.interval));
	
	    return this;
	  };
	
	  Carousel.prototype.getItemIndex = function (item) {
	    this.$items = item.parent().children('.item');
	    return this.$items.index(item || this.$active);
	  };
	
	  Carousel.prototype.getItemForDirection = function (direction, active) {
	    var activeIndex = this.getItemIndex(active);
	    var willWrap = direction == 'prev' && activeIndex === 0 || direction == 'next' && activeIndex == this.$items.length - 1;
	    if (willWrap && !this.options.wrap) return active;
	    var delta = direction == 'prev' ? -1 : 1;
	    var itemIndex = (activeIndex + delta) % this.$items.length;
	    return this.$items.eq(itemIndex);
	  };
	
	  Carousel.prototype.to = function (pos) {
	    var that = this;
	    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'));
	
	    if (pos > this.$items.length - 1 || pos < 0) return;
	
	    if (this.sliding) return this.$element.one('slid.bs.carousel', function () {
	      that.to(pos);
	    });
	    if (activeIndex == pos) return this.pause().cycle();
	
	    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos));
	  };
	
	  Carousel.prototype.pause = function (e) {
	    e || (this.paused = true);
	
	    if (this.$element.find('.next, .prev').length && $.support.transition) {
	      this.$element.trigger($.support.transition.end);
	      this.cycle(true);
	    }
	
	    this.interval = clearInterval(this.interval);
	
	    return this;
	  };
	
	  Carousel.prototype.next = function () {
	    if (this.sliding) return;
	    return this.slide('next');
	  };
	
	  Carousel.prototype.prev = function () {
	    if (this.sliding) return;
	    return this.slide('prev');
	  };
	
	  Carousel.prototype.slide = function (type, next) {
	    var $active = this.$element.find('.item.active');
	    var $next = next || this.getItemForDirection(type, $active);
	    var isCycling = this.interval;
	    var direction = type == 'next' ? 'left' : 'right';
	    var that = this;
	
	    if ($next.hasClass('active')) return this.sliding = false;
	
	    var relatedTarget = $next[0];
	    var slideEvent = $.Event('slide.bs.carousel', {
	      relatedTarget: relatedTarget,
	      direction: direction
	    });
	    this.$element.trigger(slideEvent);
	    if (slideEvent.isDefaultPrevented()) return;
	
	    this.sliding = true;
	
	    isCycling && this.pause();
	
	    if (this.$indicators.length) {
	      this.$indicators.find('.active').removeClass('active');
	      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)]);
	      $nextIndicator && $nextIndicator.addClass('active');
	    }
	
	    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction });
	    if ($.support.transition && this.$element.hasClass('slide')) {
	      $next.addClass(type);
	      $next[0].offsetWidth;
	      $active.addClass(direction);
	      $next.addClass(direction);
	      $active.one('bsTransitionEnd', function () {
	        $next.removeClass([type, direction].join(' ')).addClass('active');
	        $active.removeClass(['active', direction].join(' '));
	        that.sliding = false;
	        setTimeout(function () {
	          that.$element.trigger(slidEvent);
	        }, 0);
	      }).emulateTransitionEnd(Carousel.TRANSITION_DURATION);
	    } else {
	      $active.removeClass('active');
	      $next.addClass('active');
	      this.sliding = false;
	      this.$element.trigger(slidEvent);
	    }
	
	    isCycling && this.cycle();
	
	    return this;
	  };
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.carousel');
	      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), (typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) == 'object' && option);
	      var action = typeof option == 'string' ? option : options.slide;
	
	      if (!data) $this.data('bs.carousel', data = new Carousel(this, options));
	      if (typeof option == 'number') data.to(option);else if (action) data[action]();else if (options.interval) data.pause().cycle();
	    });
	  }
	
	  var old = $.fn.carousel;
	
	  $.fn.carousel = Plugin;
	  $.fn.carousel.Constructor = Carousel;
	
	  $.fn.carousel.noConflict = function () {
	    $.fn.carousel = old;
	    return this;
	  };
	
	  var clickHandler = function clickHandler(e) {
	    var href;
	    var $this = $(this);
	    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, ''));
	    if (!$target.hasClass('carousel')) return;
	    var options = $.extend({}, $target.data(), $this.data());
	    var slideIndex = $this.attr('data-slide-to');
	    if (slideIndex) options.interval = false;
	
	    Plugin.call($target, options);
	
	    if (slideIndex) {
	      $target.data('bs.carousel').to(slideIndex);
	    }
	
	    e.preventDefault();
	  };
	
	  $(document).on('click.bs.carousel.data-api', '[data-slide]', clickHandler).on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler);
	
	  $(window).on('load', function () {
	    $('[data-ride="carousel"]').each(function () {
	      var $carousel = $(this);
	      Plugin.call($carousel, $carousel.data());
	    });
	  });
	}(jQuery);
	
	+function ($) {
	  'use strict';
	
	  var Collapse = function Collapse(element, options) {
	    this.$element = $(element);
	    this.options = $.extend({}, Collapse.DEFAULTS, options);
	    this.$trigger = $('[data-toggle="collapse"][href="#' + element.id + '"],' + '[data-toggle="collapse"][data-target="#' + element.id + '"]');
	    this.transitioning = null;
	
	    if (this.options.parent) {
	      this.$parent = this.getParent();
	    } else {
	      this.addAriaAndCollapsedClass(this.$element, this.$trigger);
	    }
	
	    if (this.options.toggle) this.toggle();
	  };
	
	  Collapse.VERSION = '3.3.7';
	
	  Collapse.TRANSITION_DURATION = 350;
	
	  Collapse.DEFAULTS = {
	    toggle: true
	  };
	
	  Collapse.prototype.dimension = function () {
	    var hasWidth = this.$element.hasClass('width');
	    return hasWidth ? 'width' : 'height';
	  };
	
	  Collapse.prototype.show = function () {
	    if (this.transitioning || this.$element.hasClass('in')) return;
	
	    var activesData;
	    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing');
	
	    if (actives && actives.length) {
	      activesData = actives.data('bs.collapse');
	      if (activesData && activesData.transitioning) return;
	    }
	
	    var startEvent = $.Event('show.bs.collapse');
	    this.$element.trigger(startEvent);
	    if (startEvent.isDefaultPrevented()) return;
	
	    if (actives && actives.length) {
	      Plugin.call(actives, 'hide');
	      activesData || actives.data('bs.collapse', null);
	    }
	
	    var dimension = this.dimension();
	
	    this.$element.removeClass('collapse').addClass('collapsing')[dimension](0).attr('aria-expanded', true);
	
	    this.$trigger.removeClass('collapsed').attr('aria-expanded', true);
	
	    this.transitioning = 1;
	
	    var complete = function complete() {
	      this.$element.removeClass('collapsing').addClass('collapse in')[dimension]('');
	      this.transitioning = 0;
	      this.$element.trigger('shown.bs.collapse');
	    };
	
	    if (!$.support.transition) return complete.call(this);
	
	    var scrollSize = $.camelCase(['scroll', dimension].join('-'));
	
	    this.$element.one('bsTransitionEnd', $.proxy(complete, this)).emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize]);
	  };
	
	  Collapse.prototype.hide = function () {
	    if (this.transitioning || !this.$element.hasClass('in')) return;
	
	    var startEvent = $.Event('hide.bs.collapse');
	    this.$element.trigger(startEvent);
	    if (startEvent.isDefaultPrevented()) return;
	
	    var dimension = this.dimension();
	
	    this.$element[dimension](this.$element[dimension]())[0].offsetHeight;
	
	    this.$element.addClass('collapsing').removeClass('collapse in').attr('aria-expanded', false);
	
	    this.$trigger.addClass('collapsed').attr('aria-expanded', false);
	
	    this.transitioning = 1;
	
	    var complete = function complete() {
	      this.transitioning = 0;
	      this.$element.removeClass('collapsing').addClass('collapse').trigger('hidden.bs.collapse');
	    };
	
	    if (!$.support.transition) return complete.call(this);
	
	    this.$element[dimension](0).one('bsTransitionEnd', $.proxy(complete, this)).emulateTransitionEnd(Collapse.TRANSITION_DURATION);
	  };
	
	  Collapse.prototype.toggle = function () {
	    this[this.$element.hasClass('in') ? 'hide' : 'show']();
	  };
	
	  Collapse.prototype.getParent = function () {
	    return $(this.options.parent).find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]').each($.proxy(function (i, element) {
	      var $element = $(element);
	      this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element);
	    }, this)).end();
	  };
	
	  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
	    var isOpen = $element.hasClass('in');
	
	    $element.attr('aria-expanded', isOpen);
	    $trigger.toggleClass('collapsed', !isOpen).attr('aria-expanded', isOpen);
	  };
	
	  function getTargetFromTrigger($trigger) {
	    var href;
	    var target = $trigger.attr('data-target') || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '');
	
	    return $(target);
	  }
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.collapse');
	      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), (typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) == 'object' && option);
	
	      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false;
	      if (!data) $this.data('bs.collapse', data = new Collapse(this, options));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.collapse;
	
	  $.fn.collapse = Plugin;
	  $.fn.collapse.Constructor = Collapse;
	
	  $.fn.collapse.noConflict = function () {
	    $.fn.collapse = old;
	    return this;
	  };
	
	  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
	    var $this = $(this);
	
	    if (!$this.attr('data-target')) e.preventDefault();
	
	    var $target = getTargetFromTrigger($this);
	    var data = $target.data('bs.collapse');
	    var option = data ? 'toggle' : $this.data();
	
	    Plugin.call($target, option);
	  });
	}(jQuery);
	
	+function ($) {
	  'use strict';
	
	  var backdrop = '.dropdown-backdrop';
	  var toggle = '[data-toggle="dropdown"]';
	  var Dropdown = function Dropdown(element) {
	    $(element).on('click.bs.dropdown', this.toggle);
	  };
	
	  Dropdown.VERSION = '3.3.7';
	
	  function getParent($this) {
	    var selector = $this.attr('data-target');
	
	    if (!selector) {
	      selector = $this.attr('href');
	      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '');
	    }
	
	    var $parent = selector && $(selector);
	
	    return $parent && $parent.length ? $parent : $this.parent();
	  }
	
	  function clearMenus(e) {
	    if (e && e.which === 3) return;
	    $(backdrop).remove();
	    $(toggle).each(function () {
	      var $this = $(this);
	      var $parent = getParent($this);
	      var relatedTarget = { relatedTarget: this };
	
	      if (!$parent.hasClass('open')) return;
	
	      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return;
	
	      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget));
	
	      if (e.isDefaultPrevented()) return;
	
	      $this.attr('aria-expanded', 'false');
	      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget));
	    });
	  }
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this);
	
	    if ($this.is('.disabled, :disabled')) return;
	
	    var $parent = getParent($this);
	    var isActive = $parent.hasClass('open');
	
	    clearMenus();
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        $(document.createElement('div')).addClass('dropdown-backdrop').insertAfter($(this)).on('click', clearMenus);
	      }
	
	      var relatedTarget = { relatedTarget: this };
	      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget));
	
	      if (e.isDefaultPrevented()) return;
	
	      $this.trigger('focus').attr('aria-expanded', 'true');
	
	      $parent.toggleClass('open').trigger($.Event('shown.bs.dropdown', relatedTarget));
	    }
	
	    return false;
	  };
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return;
	
	    var $this = $(this);
	
	    e.preventDefault();
	    e.stopPropagation();
	
	    if ($this.is('.disabled, :disabled')) return;
	
	    var $parent = getParent($this);
	    var isActive = $parent.hasClass('open');
	
	    if (!isActive && e.which != 27 || isActive && e.which == 27) {
	      if (e.which == 27) $parent.find(toggle).trigger('focus');
	      return $this.trigger('click');
	    }
	
	    var desc = ' li:not(.disabled):visible a';
	    var $items = $parent.find('.dropdown-menu' + desc);
	
	    if (!$items.length) return;
	
	    var index = $items.index(e.target);
	
	    if (e.which == 38 && index > 0) index--;
	    if (e.which == 40 && index < $items.length - 1) index++;
	    if (!~index) index = 0;
	
	    $items.eq(index).trigger('focus');
	  };
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.dropdown');
	
	      if (!data) $this.data('bs.dropdown', data = new Dropdown(this));
	      if (typeof option == 'string') data[option].call($this);
	    });
	  }
	
	  var old = $.fn.dropdown;
	
	  $.fn.dropdown = Plugin;
	  $.fn.dropdown.Constructor = Dropdown;
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old;
	    return this;
	  };
	
	  $(document).on('click.bs.dropdown.data-api', clearMenus).on('click.bs.dropdown.data-api', '.dropdown form', function (e) {
	    e.stopPropagation();
	  }).on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle).on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown).on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown);
	}(jQuery);
	
	+function ($) {
	  'use strict';
	
	  var Modal = function Modal(element, options) {
	    this.options = options;
	    this.$body = $(document.body);
	    this.$element = $(element);
	    this.$dialog = this.$element.find('.modal-dialog');
	    this.$backdrop = null;
	    this.isShown = null;
	    this.originalBodyPad = null;
	    this.scrollbarWidth = 0;
	    this.ignoreBackdropClick = false;
	
	    if (this.options.remote) {
	      this.$element.find('.modal-content').load(this.options.remote, $.proxy(function () {
	        this.$element.trigger('loaded.bs.modal');
	      }, this));
	    }
	  };
	
	  Modal.VERSION = '3.3.7';
	
	  Modal.TRANSITION_DURATION = 300;
	  Modal.BACKDROP_TRANSITION_DURATION = 150;
	
	  Modal.DEFAULTS = {
	    backdrop: true,
	    keyboard: true,
	    show: true
	  };
	
	  Modal.prototype.toggle = function (_relatedTarget) {
	    return this.isShown ? this.hide() : this.show(_relatedTarget);
	  };
	
	  Modal.prototype.show = function (_relatedTarget) {
	    var that = this;
	    var e = $.Event('show.bs.modal', { relatedTarget: _relatedTarget });
	
	    this.$element.trigger(e);
	
	    if (this.isShown || e.isDefaultPrevented()) return;
	
	    this.isShown = true;
	
	    this.checkScrollbar();
	    this.setScrollbar();
	    this.$body.addClass('modal-open');
	
	    this.escape();
	    this.resize();
	
	    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this));
	
	    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
	      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
	        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true;
	      });
	    });
	
	    this.backdrop(function () {
	      var transition = $.support.transition && that.$element.hasClass('fade');
	
	      if (!that.$element.parent().length) {
	        that.$element.appendTo(that.$body);
	      }
	
	      that.$element.show().scrollTop(0);
	
	      that.adjustDialog();
	
	      if (transition) {
	        that.$element[0].offsetWidth;
	      }
	
	      that.$element.addClass('in');
	
	      that.enforceFocus();
	
	      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget });
	
	      transition ? that.$dialog.one('bsTransitionEnd', function () {
	        that.$element.trigger('focus').trigger(e);
	      }).emulateTransitionEnd(Modal.TRANSITION_DURATION) : that.$element.trigger('focus').trigger(e);
	    });
	  };
	
	  Modal.prototype.hide = function (e) {
	    if (e) e.preventDefault();
	
	    e = $.Event('hide.bs.modal');
	
	    this.$element.trigger(e);
	
	    if (!this.isShown || e.isDefaultPrevented()) return;
	
	    this.isShown = false;
	
	    this.escape();
	    this.resize();
	
	    $(document).off('focusin.bs.modal');
	
	    this.$element.removeClass('in').off('click.dismiss.bs.modal').off('mouseup.dismiss.bs.modal');
	
	    this.$dialog.off('mousedown.dismiss.bs.modal');
	
	    $.support.transition && this.$element.hasClass('fade') ? this.$element.one('bsTransitionEnd', $.proxy(this.hideModal, this)).emulateTransitionEnd(Modal.TRANSITION_DURATION) : this.hideModal();
	  };
	
	  Modal.prototype.enforceFocus = function () {
	    $(document).off('focusin.bs.modal').on('focusin.bs.modal', $.proxy(function (e) {
	      if (document !== e.target && this.$element[0] !== e.target && !this.$element.has(e.target).length) {
	        this.$element.trigger('focus');
	      }
	    }, this));
	  };
	
	  Modal.prototype.escape = function () {
	    if (this.isShown && this.options.keyboard) {
	      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
	        e.which == 27 && this.hide();
	      }, this));
	    } else if (!this.isShown) {
	      this.$element.off('keydown.dismiss.bs.modal');
	    }
	  };
	
	  Modal.prototype.resize = function () {
	    if (this.isShown) {
	      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this));
	    } else {
	      $(window).off('resize.bs.modal');
	    }
	  };
	
	  Modal.prototype.hideModal = function () {
	    var that = this;
	    this.$element.hide();
	    this.backdrop(function () {
	      that.$body.removeClass('modal-open');
	      that.resetAdjustments();
	      that.resetScrollbar();
	      that.$element.trigger('hidden.bs.modal');
	    });
	  };
	
	  Modal.prototype.removeBackdrop = function () {
	    this.$backdrop && this.$backdrop.remove();
	    this.$backdrop = null;
	  };
	
	  Modal.prototype.backdrop = function (callback) {
	    var that = this;
	    var animate = this.$element.hasClass('fade') ? 'fade' : '';
	
	    if (this.isShown && this.options.backdrop) {
	      var doAnimate = $.support.transition && animate;
	
	      this.$backdrop = $(document.createElement('div')).addClass('modal-backdrop ' + animate).appendTo(this.$body);
	
	      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
	        if (this.ignoreBackdropClick) {
	          this.ignoreBackdropClick = false;
	          return;
	        }
	        if (e.target !== e.currentTarget) return;
	        this.options.backdrop == 'static' ? this.$element[0].focus() : this.hide();
	      }, this));
	
	      if (doAnimate) this.$backdrop[0].offsetWidth;
	
	      this.$backdrop.addClass('in');
	
	      if (!callback) return;
	
	      doAnimate ? this.$backdrop.one('bsTransitionEnd', callback).emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) : callback();
	    } else if (!this.isShown && this.$backdrop) {
	      this.$backdrop.removeClass('in');
	
	      var callbackRemove = function callbackRemove() {
	        that.removeBackdrop();
	        callback && callback();
	      };
	      $.support.transition && this.$element.hasClass('fade') ? this.$backdrop.one('bsTransitionEnd', callbackRemove).emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) : callbackRemove();
	    } else if (callback) {
	      callback();
	    }
	  };
	
	  Modal.prototype.handleUpdate = function () {
	    this.adjustDialog();
	  };
	
	  Modal.prototype.adjustDialog = function () {
	    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight;
	
	    this.$element.css({
	      paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
	      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
	    });
	  };
	
	  Modal.prototype.resetAdjustments = function () {
	    this.$element.css({
	      paddingLeft: '',
	      paddingRight: ''
	    });
	  };
	
	  Modal.prototype.checkScrollbar = function () {
	    var fullWindowWidth = window.innerWidth;
	    if (!fullWindowWidth) {
	      var documentElementRect = document.documentElement.getBoundingClientRect();
	      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	    }
	    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth;
	    this.scrollbarWidth = this.measureScrollbar();
	  };
	
	  Modal.prototype.setScrollbar = function () {
	    var bodyPad = parseInt(this.$body.css('padding-right') || 0, 10);
	    this.originalBodyPad = document.body.style.paddingRight || '';
	    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth);
	  };
	
	  Modal.prototype.resetScrollbar = function () {
	    this.$body.css('padding-right', this.originalBodyPad);
	  };
	
	  Modal.prototype.measureScrollbar = function () {
	    var scrollDiv = document.createElement('div');
	    scrollDiv.className = 'modal-scrollbar-measure';
	    this.$body.append(scrollDiv);
	    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	    this.$body[0].removeChild(scrollDiv);
	    return scrollbarWidth;
	  };
	
	  function Plugin(option, _relatedTarget) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.modal');
	      var options = $.extend({}, Modal.DEFAULTS, $this.data(), (typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) == 'object' && option);
	
	      if (!data) $this.data('bs.modal', data = new Modal(this, options));
	      if (typeof option == 'string') data[option](_relatedTarget);else if (options.show) data.show(_relatedTarget);
	    });
	  }
	
	  var old = $.fn.modal;
	
	  $.fn.modal = Plugin;
	  $.fn.modal.Constructor = Modal;
	
	  $.fn.modal.noConflict = function () {
	    $.fn.modal = old;
	    return this;
	  };
	
	  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
	    var $this = $(this);
	    var href = $this.attr('href');
	    var $target = $($this.attr('data-target') || href && href.replace(/.*(?=#[^\s]+$)/, ''));
	    var option = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data());
	
	    if ($this.is('a')) e.preventDefault();
	
	    $target.one('show.bs.modal', function (showEvent) {
	      if (showEvent.isDefaultPrevented()) return;
	      $target.one('hidden.bs.modal', function () {
	        $this.is(':visible') && $this.trigger('focus');
	      });
	    });
	    Plugin.call($target, option, this);
	  });
	}(jQuery);
	
	+function ($) {
	  'use strict';
	
	  var Tooltip = function Tooltip(element, options) {
	    this.type = null;
	    this.options = null;
	    this.enabled = null;
	    this.timeout = null;
	    this.hoverState = null;
	    this.$element = null;
	    this.inState = null;
	
	    this.init('tooltip', element, options);
	  };
	
	  Tooltip.VERSION = '3.3.7';
	
	  Tooltip.TRANSITION_DURATION = 150;
	
	  Tooltip.DEFAULTS = {
	    animation: true,
	    placement: 'top',
	    selector: false,
	    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    container: false,
	    viewport: {
	      selector: 'body',
	      padding: 0
	    }
	  };
	
	  Tooltip.prototype.init = function (type, element, options) {
	    this.enabled = true;
	    this.type = type;
	    this.$element = $(element);
	    this.options = this.getOptions(options);
	    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : this.options.viewport.selector || this.options.viewport);
	    this.inState = { click: false, hover: false, focus: false };
	
	    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
	      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!');
	    }
	
	    var triggers = this.options.trigger.split(' ');
	
	    for (var i = triggers.length; i--;) {
	      var trigger = triggers[i];
	
	      if (trigger == 'click') {
	        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this));
	      } else if (trigger != 'manual') {
	        var eventIn = trigger == 'hover' ? 'mouseenter' : 'focusin';
	        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout';
	
	        this.$element.on(eventIn + '.' + this.type, this.options.selector, $.proxy(this.enter, this));
	        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this));
	      }
	    }
	
	    this.options.selector ? this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' }) : this.fixTitle();
	  };
	
	  Tooltip.prototype.getDefaults = function () {
	    return Tooltip.DEFAULTS;
	  };
	
	  Tooltip.prototype.getOptions = function (options) {
	    options = $.extend({}, this.getDefaults(), this.$element.data(), options);
	
	    if (options.delay && typeof options.delay == 'number') {
	      options.delay = {
	        show: options.delay,
	        hide: options.delay
	      };
	    }
	
	    return options;
	  };
	
	  Tooltip.prototype.getDelegateOptions = function () {
	    var options = {};
	    var defaults = this.getDefaults();
	
	    this._options && $.each(this._options, function (key, value) {
	      if (defaults[key] != value) options[key] = value;
	    });
	
	    return options;
	  };
	
	  Tooltip.prototype.enter = function (obj) {
	    var self = obj instanceof this.constructor ? obj : $(obj.currentTarget).data('bs.' + this.type);
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions());
	      $(obj.currentTarget).data('bs.' + this.type, self);
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true;
	    }
	
	    if (self.tip().hasClass('in') || self.hoverState == 'in') {
	      self.hoverState = 'in';
	      return;
	    }
	
	    clearTimeout(self.timeout);
	
	    self.hoverState = 'in';
	
	    if (!self.options.delay || !self.options.delay.show) return self.show();
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'in') self.show();
	    }, self.options.delay.show);
	  };
	
	  Tooltip.prototype.isInStateTrue = function () {
	    for (var key in this.inState) {
	      if (this.inState[key]) return true;
	    }
	
	    return false;
	  };
	
	  Tooltip.prototype.leave = function (obj) {
	    var self = obj instanceof this.constructor ? obj : $(obj.currentTarget).data('bs.' + this.type);
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions());
	      $(obj.currentTarget).data('bs.' + this.type, self);
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false;
	    }
	
	    if (self.isInStateTrue()) return;
	
	    clearTimeout(self.timeout);
	
	    self.hoverState = 'out';
	
	    if (!self.options.delay || !self.options.delay.hide) return self.hide();
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'out') self.hide();
	    }, self.options.delay.hide);
	  };
	
	  Tooltip.prototype.show = function () {
	    var e = $.Event('show.bs.' + this.type);
	
	    if (this.hasContent() && this.enabled) {
	      this.$element.trigger(e);
	
	      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);
	      if (e.isDefaultPrevented() || !inDom) return;
	      var that = this;
	
	      var $tip = this.tip();
	
	      var tipId = this.getUID(this.type);
	
	      this.setContent();
	      $tip.attr('id', tipId);
	      this.$element.attr('aria-describedby', tipId);
	
	      if (this.options.animation) $tip.addClass('fade');
	
	      var placement = typeof this.options.placement == 'function' ? this.options.placement.call(this, $tip[0], this.$element[0]) : this.options.placement;
	
	      var autoToken = /\s?auto?\s?/i;
	      var autoPlace = autoToken.test(placement);
	      if (autoPlace) placement = placement.replace(autoToken, '') || 'top';
	
	      $tip.detach().css({ top: 0, left: 0, display: 'block' }).addClass(placement).data('bs.' + this.type, this);
	
	      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element);
	      this.$element.trigger('inserted.bs.' + this.type);
	
	      var pos = this.getPosition();
	      var actualWidth = $tip[0].offsetWidth;
	      var actualHeight = $tip[0].offsetHeight;
	
	      if (autoPlace) {
	        var orgPlacement = placement;
	        var viewportDim = this.getPosition(this.$viewport);
	
	        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top' : placement == 'top' && pos.top - actualHeight < viewportDim.top ? 'bottom' : placement == 'right' && pos.right + actualWidth > viewportDim.width ? 'left' : placement == 'left' && pos.left - actualWidth < viewportDim.left ? 'right' : placement;
	
	        $tip.removeClass(orgPlacement).addClass(placement);
	      }
	
	      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight);
	
	      this.applyPlacement(calculatedOffset, placement);
	
	      var complete = function complete() {
	        var prevHoverState = that.hoverState;
	        that.$element.trigger('shown.bs.' + that.type);
	        that.hoverState = null;
	
	        if (prevHoverState == 'out') that.leave(that);
	      };
	
	      $.support.transition && this.$tip.hasClass('fade') ? $tip.one('bsTransitionEnd', complete).emulateTransitionEnd(Tooltip.TRANSITION_DURATION) : complete();
	    }
	  };
	
	  Tooltip.prototype.applyPlacement = function (offset, placement) {
	    var $tip = this.tip();
	    var width = $tip[0].offsetWidth;
	    var height = $tip[0].offsetHeight;
	
	    var marginTop = parseInt($tip.css('margin-top'), 10);
	    var marginLeft = parseInt($tip.css('margin-left'), 10);
	
	    if (isNaN(marginTop)) marginTop = 0;
	    if (isNaN(marginLeft)) marginLeft = 0;
	
	    offset.top += marginTop;
	    offset.left += marginLeft;
	
	    $.offset.setOffset($tip[0], $.extend({
	      using: function using(props) {
	        $tip.css({
	          top: Math.round(props.top),
	          left: Math.round(props.left)
	        });
	      }
	    }, offset), 0);
	
	    $tip.addClass('in');
	
	    var actualWidth = $tip[0].offsetWidth;
	    var actualHeight = $tip[0].offsetHeight;
	
	    if (placement == 'top' && actualHeight != height) {
	      offset.top = offset.top + height - actualHeight;
	    }
	
	    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight);
	
	    if (delta.left) offset.left += delta.left;else offset.top += delta.top;
	
	    var isVertical = /top|bottom/.test(placement);
	    var arrowDelta = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight;
	    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight';
	
	    $tip.offset(offset);
	    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical);
	  };
	
	  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
	    this.arrow().css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%').css(isVertical ? 'top' : 'left', '');
	  };
	
	  Tooltip.prototype.setContent = function () {
	    var $tip = this.tip();
	    var title = this.getTitle();
	
	    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title);
	    $tip.removeClass('fade in top bottom left right');
	  };
	
	  Tooltip.prototype.hide = function (callback) {
	    var that = this;
	    var $tip = $(this.$tip);
	    var e = $.Event('hide.bs.' + this.type);
	
	    function complete() {
	      if (that.hoverState != 'in') $tip.detach();
	      if (that.$element) {
	        that.$element.removeAttr('aria-describedby').trigger('hidden.bs.' + that.type);
	      }
	      callback && callback();
	    }
	
	    this.$element.trigger(e);
	
	    if (e.isDefaultPrevented()) return;
	
	    $tip.removeClass('in');
	
	    $.support.transition && $tip.hasClass('fade') ? $tip.one('bsTransitionEnd', complete).emulateTransitionEnd(Tooltip.TRANSITION_DURATION) : complete();
	
	    this.hoverState = null;
	
	    return this;
	  };
	
	  Tooltip.prototype.fixTitle = function () {
	    var $e = this.$element;
	    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
	      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '');
	    }
	  };
	
	  Tooltip.prototype.hasContent = function () {
	    return this.getTitle();
	  };
	
	  Tooltip.prototype.getPosition = function ($element) {
	    $element = $element || this.$element;
	
	    var el = $element[0];
	    var isBody = el.tagName == 'BODY';
	
	    var elRect = el.getBoundingClientRect();
	    if (elRect.width == null) {
	      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top });
	    }
	    var isSvg = window.SVGElement && el instanceof window.SVGElement;
	
	    var elOffset = isBody ? { top: 0, left: 0 } : isSvg ? null : $element.offset();
	    var scroll = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() };
	    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null;
	
	    return $.extend({}, elRect, scroll, outerDims, elOffset);
	  };
	
	  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
	    return placement == 'bottom' ? { top: pos.top + pos.height, left: pos.left + pos.width / 2 - actualWidth / 2 } : placement == 'top' ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } : placement == 'left' ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } : { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width };
	  };
	
	  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
	    var delta = { top: 0, left: 0 };
	    if (!this.$viewport) return delta;
	
	    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0;
	    var viewportDimensions = this.getPosition(this.$viewport);
	
	    if (/right|left/.test(placement)) {
	      var topEdgeOffset = pos.top - viewportPadding - viewportDimensions.scroll;
	      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight;
	      if (topEdgeOffset < viewportDimensions.top) {
	        delta.top = viewportDimensions.top - topEdgeOffset;
	      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) {
	        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset;
	      }
	    } else {
	      var leftEdgeOffset = pos.left - viewportPadding;
	      var rightEdgeOffset = pos.left + viewportPadding + actualWidth;
	      if (leftEdgeOffset < viewportDimensions.left) {
	        delta.left = viewportDimensions.left - leftEdgeOffset;
	      } else if (rightEdgeOffset > viewportDimensions.right) {
	        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset;
	      }
	    }
	
	    return delta;
	  };
	
	  Tooltip.prototype.getTitle = function () {
	    var title;
	    var $e = this.$element;
	    var o = this.options;
	
	    title = $e.attr('data-original-title') || (typeof o.title == 'function' ? o.title.call($e[0]) : o.title);
	
	    return title;
	  };
	
	  Tooltip.prototype.getUID = function (prefix) {
	    do {
	      prefix += ~~(Math.random() * 1000000);
	    } while (document.getElementById(prefix));
	    return prefix;
	  };
	
	  Tooltip.prototype.tip = function () {
	    if (!this.$tip) {
	      this.$tip = $(this.options.template);
	      if (this.$tip.length != 1) {
	        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!');
	      }
	    }
	    return this.$tip;
	  };
	
	  Tooltip.prototype.arrow = function () {
	    return this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow');
	  };
	
	  Tooltip.prototype.enable = function () {
	    this.enabled = true;
	  };
	
	  Tooltip.prototype.disable = function () {
	    this.enabled = false;
	  };
	
	  Tooltip.prototype.toggleEnabled = function () {
	    this.enabled = !this.enabled;
	  };
	
	  Tooltip.prototype.toggle = function (e) {
	    var self = this;
	    if (e) {
	      self = $(e.currentTarget).data('bs.' + this.type);
	      if (!self) {
	        self = new this.constructor(e.currentTarget, this.getDelegateOptions());
	        $(e.currentTarget).data('bs.' + this.type, self);
	      }
	    }
	
	    if (e) {
	      self.inState.click = !self.inState.click;
	      if (self.isInStateTrue()) self.enter(self);else self.leave(self);
	    } else {
	      self.tip().hasClass('in') ? self.leave(self) : self.enter(self);
	    }
	  };
	
	  Tooltip.prototype.destroy = function () {
	    var that = this;
	    clearTimeout(this.timeout);
	    this.hide(function () {
	      that.$element.off('.' + that.type).removeData('bs.' + that.type);
	      if (that.$tip) {
	        that.$tip.detach();
	      }
	      that.$tip = null;
	      that.$arrow = null;
	      that.$viewport = null;
	      that.$element = null;
	    });
	  };
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.tooltip');
	      var options = (typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) == 'object' && option;
	
	      if (!data && /destroy|hide/.test(option)) return;
	      if (!data) $this.data('bs.tooltip', data = new Tooltip(this, options));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.tooltip;
	
	  $.fn.tooltip = Plugin;
	  $.fn.tooltip.Constructor = Tooltip;
	
	  $.fn.tooltip.noConflict = function () {
	    $.fn.tooltip = old;
	    return this;
	  };
	}(jQuery);
	
	+function ($) {
	  'use strict';
	
	  var Popover = function Popover(element, options) {
	    this.init('popover', element, options);
	  };
	
	  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js');
	
	  Popover.VERSION = '3.3.7';
	
	  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	  });
	
	  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype);
	
	  Popover.prototype.constructor = Popover;
	
	  Popover.prototype.getDefaults = function () {
	    return Popover.DEFAULTS;
	  };
	
	  Popover.prototype.setContent = function () {
	    var $tip = this.tip();
	    var title = this.getTitle();
	    var content = this.getContent();
	
	    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title);
	    $tip.find('.popover-content').children().detach().end()[this.options.html ? typeof content == 'string' ? 'html' : 'append' : 'text'](content);
	
	    $tip.removeClass('fade top bottom left right in');
	
	    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide();
	  };
	
	  Popover.prototype.hasContent = function () {
	    return this.getTitle() || this.getContent();
	  };
	
	  Popover.prototype.getContent = function () {
	    var $e = this.$element;
	    var o = this.options;
	
	    return $e.attr('data-content') || (typeof o.content == 'function' ? o.content.call($e[0]) : o.content);
	  };
	
	  Popover.prototype.arrow = function () {
	    return this.$arrow = this.$arrow || this.tip().find('.arrow');
	  };
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.popover');
	      var options = (typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) == 'object' && option;
	
	      if (!data && /destroy|hide/.test(option)) return;
	      if (!data) $this.data('bs.popover', data = new Popover(this, options));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.popover;
	
	  $.fn.popover = Plugin;
	  $.fn.popover.Constructor = Popover;
	
	  $.fn.popover.noConflict = function () {
	    $.fn.popover = old;
	    return this;
	  };
	}(jQuery);
	
	+function ($) {
	  'use strict';
	
	  function ScrollSpy(element, options) {
	    this.$body = $(document.body);
	    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element);
	    this.options = $.extend({}, ScrollSpy.DEFAULTS, options);
	    this.selector = (this.options.target || '') + ' .nav li > a';
	    this.offsets = [];
	    this.targets = [];
	    this.activeTarget = null;
	    this.scrollHeight = 0;
	
	    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this));
	    this.refresh();
	    this.process();
	  }
	
	  ScrollSpy.VERSION = '3.3.7';
	
	  ScrollSpy.DEFAULTS = {
	    offset: 10
	  };
	
	  ScrollSpy.prototype.getScrollHeight = function () {
	    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight);
	  };
	
	  ScrollSpy.prototype.refresh = function () {
	    var that = this;
	    var offsetMethod = 'offset';
	    var offsetBase = 0;
	
	    this.offsets = [];
	    this.targets = [];
	    this.scrollHeight = this.getScrollHeight();
	
	    if (!$.isWindow(this.$scrollElement[0])) {
	      offsetMethod = 'position';
	      offsetBase = this.$scrollElement.scrollTop();
	    }
	
	    this.$body.find(this.selector).map(function () {
	      var $el = $(this);
	      var href = $el.data('target') || $el.attr('href');
	      var $href = /^#./.test(href) && $(href);
	
	      return $href && $href.length && $href.is(':visible') && [[$href[offsetMethod]().top + offsetBase, href]] || null;
	    }).sort(function (a, b) {
	      return a[0] - b[0];
	    }).each(function () {
	      that.offsets.push(this[0]);
	      that.targets.push(this[1]);
	    });
	  };
	
	  ScrollSpy.prototype.process = function () {
	    var scrollTop = this.$scrollElement.scrollTop() + this.options.offset;
	    var scrollHeight = this.getScrollHeight();
	    var maxScroll = this.options.offset + scrollHeight - this.$scrollElement.height();
	    var offsets = this.offsets;
	    var targets = this.targets;
	    var activeTarget = this.activeTarget;
	    var i;
	
	    if (this.scrollHeight != scrollHeight) {
	      this.refresh();
	    }
	
	    if (scrollTop >= maxScroll) {
	      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i);
	    }
	
	    if (activeTarget && scrollTop < offsets[0]) {
	      this.activeTarget = null;
	      return this.clear();
	    }
	
	    for (i = offsets.length; i--;) {
	      activeTarget != targets[i] && scrollTop >= offsets[i] && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1]) && this.activate(targets[i]);
	    }
	  };
	
	  ScrollSpy.prototype.activate = function (target) {
	    this.activeTarget = target;
	
	    this.clear();
	
	    var selector = this.selector + '[data-target="' + target + '"],' + this.selector + '[href="' + target + '"]';
	
	    var active = $(selector).parents('li').addClass('active');
	
	    if (active.parent('.dropdown-menu').length) {
	      active = active.closest('li.dropdown').addClass('active');
	    }
	
	    active.trigger('activate.bs.scrollspy');
	  };
	
	  ScrollSpy.prototype.clear = function () {
	    $(this.selector).parentsUntil(this.options.target, '.active').removeClass('active');
	  };
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.scrollspy');
	      var options = (typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) == 'object' && option;
	
	      if (!data) $this.data('bs.scrollspy', data = new ScrollSpy(this, options));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.scrollspy;
	
	  $.fn.scrollspy = Plugin;
	  $.fn.scrollspy.Constructor = ScrollSpy;
	
	  $.fn.scrollspy.noConflict = function () {
	    $.fn.scrollspy = old;
	    return this;
	  };
	
	  $(window).on('load.bs.scrollspy.data-api', function () {
	    $('[data-spy="scroll"]').each(function () {
	      var $spy = $(this);
	      Plugin.call($spy, $spy.data());
	    });
	  });
	}(jQuery);
	
	+function ($) {
	  'use strict';
	
	  var Tab = function Tab(element) {
	    this.element = $(element);
	  };
	
	  Tab.VERSION = '3.3.7';
	
	  Tab.TRANSITION_DURATION = 150;
	
	  Tab.prototype.show = function () {
	    var $this = this.element;
	    var $ul = $this.closest('ul:not(.dropdown-menu)');
	    var selector = $this.data('target');
	
	    if (!selector) {
	      selector = $this.attr('href');
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '');
	    }
	
	    if ($this.parent('li').hasClass('active')) return;
	
	    var $previous = $ul.find('.active:last a');
	    var hideEvent = $.Event('hide.bs.tab', {
	      relatedTarget: $this[0]
	    });
	    var showEvent = $.Event('show.bs.tab', {
	      relatedTarget: $previous[0]
	    });
	
	    $previous.trigger(hideEvent);
	    $this.trigger(showEvent);
	
	    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return;
	
	    var $target = $(selector);
	
	    this.activate($this.closest('li'), $ul);
	    this.activate($target, $target.parent(), function () {
	      $previous.trigger({
	        type: 'hidden.bs.tab',
	        relatedTarget: $this[0]
	      });
	      $this.trigger({
	        type: 'shown.bs.tab',
	        relatedTarget: $previous[0]
	      });
	    });
	  };
	
	  Tab.prototype.activate = function (element, container, callback) {
	    var $active = container.find('> .active');
	    var transition = callback && $.support.transition && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length);
	
	    function next() {
	      $active.removeClass('active').find('> .dropdown-menu > .active').removeClass('active').end().find('[data-toggle="tab"]').attr('aria-expanded', false);
	
	      element.addClass('active').find('[data-toggle="tab"]').attr('aria-expanded', true);
	
	      if (transition) {
	        element[0].offsetWidth;
	        element.addClass('in');
	      } else {
	        element.removeClass('fade');
	      }
	
	      if (element.parent('.dropdown-menu').length) {
	        element.closest('li.dropdown').addClass('active').end().find('[data-toggle="tab"]').attr('aria-expanded', true);
	      }
	
	      callback && callback();
	    }
	
	    $active.length && transition ? $active.one('bsTransitionEnd', next).emulateTransitionEnd(Tab.TRANSITION_DURATION) : next();
	
	    $active.removeClass('in');
	  };
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.tab');
	
	      if (!data) $this.data('bs.tab', data = new Tab(this));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.tab;
	
	  $.fn.tab = Plugin;
	  $.fn.tab.Constructor = Tab;
	
	  $.fn.tab.noConflict = function () {
	    $.fn.tab = old;
	    return this;
	  };
	
	  var clickHandler = function clickHandler(e) {
	    e.preventDefault();
	    Plugin.call($(this), 'show');
	  };
	
	  $(document).on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler).on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler);
	}(jQuery);
	
	+function ($) {
	  'use strict';
	
	  var Affix = function Affix(element, options) {
	    this.options = $.extend({}, Affix.DEFAULTS, options);
	
	    this.$target = $(this.options.target).on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this)).on('click.bs.affix.data-api', $.proxy(this.checkPositionWithEventLoop, this));
	
	    this.$element = $(element);
	    this.affixed = null;
	    this.unpin = null;
	    this.pinnedOffset = null;
	
	    this.checkPosition();
	  };
	
	  Affix.VERSION = '3.3.7';
	
	  Affix.RESET = 'affix affix-top affix-bottom';
	
	  Affix.DEFAULTS = {
	    offset: 0,
	    target: window
	  };
	
	  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
	    var scrollTop = this.$target.scrollTop();
	    var position = this.$element.offset();
	    var targetHeight = this.$target.height();
	
	    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false;
	
	    if (this.affixed == 'bottom') {
	      if (offsetTop != null) return scrollTop + this.unpin <= position.top ? false : 'bottom';
	      return scrollTop + targetHeight <= scrollHeight - offsetBottom ? false : 'bottom';
	    }
	
	    var initializing = this.affixed == null;
	    var colliderTop = initializing ? scrollTop : position.top;
	    var colliderHeight = initializing ? targetHeight : height;
	
	    if (offsetTop != null && scrollTop <= offsetTop) return 'top';
	    if (offsetBottom != null && colliderTop + colliderHeight >= scrollHeight - offsetBottom) return 'bottom';
	
	    return false;
	  };
	
	  Affix.prototype.getPinnedOffset = function () {
	    if (this.pinnedOffset) return this.pinnedOffset;
	    this.$element.removeClass(Affix.RESET).addClass('affix');
	    var scrollTop = this.$target.scrollTop();
	    var position = this.$element.offset();
	    return this.pinnedOffset = position.top - scrollTop;
	  };
	
	  Affix.prototype.checkPositionWithEventLoop = function () {
	    setTimeout($.proxy(this.checkPosition, this), 1);
	  };
	
	  Affix.prototype.checkPosition = function () {
	    if (!this.$element.is(':visible')) return;
	
	    var height = this.$element.height();
	    var offset = this.options.offset;
	    var offsetTop = offset.top;
	    var offsetBottom = offset.bottom;
	    var scrollHeight = Math.max($(document).height(), $(document.body).height());
	
	    if ((typeof offset === 'undefined' ? 'undefined' : (0, _typeof3.default)(offset)) != 'object') offsetBottom = offsetTop = offset;
	    if (typeof offsetTop == 'function') offsetTop = offset.top(this.$element);
	    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element);
	
	    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom);
	
	    if (this.affixed != affix) {
	      if (this.unpin != null) this.$element.css('top', '');
	
	      var affixType = 'affix' + (affix ? '-' + affix : '');
	      var e = $.Event(affixType + '.bs.affix');
	
	      this.$element.trigger(e);
	
	      if (e.isDefaultPrevented()) return;
	
	      this.affixed = affix;
	      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null;
	
	      this.$element.removeClass(Affix.RESET).addClass(affixType).trigger(affixType.replace('affix', 'affixed') + '.bs.affix');
	    }
	
	    if (affix == 'bottom') {
	      this.$element.offset({
	        top: scrollHeight - height - offsetBottom
	      });
	    }
	  };
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.affix');
	      var options = (typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) == 'object' && option;
	
	      if (!data) $this.data('bs.affix', data = new Affix(this, options));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.affix;
	
	  $.fn.affix = Plugin;
	  $.fn.affix.Constructor = Affix;
	
	  $.fn.affix.noConflict = function () {
	    $.fn.affix = old;
	    return this;
	  };
	
	  $(window).on('load', function () {
	    $('[data-spy="affix"]').each(function () {
	      var $spy = $(this);
	      var data = $spy.data();
	
	      data.offset = data.offset || {};
	
	      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom;
	      if (data.offsetTop != null) data.offset.top = data.offsetTop;
	
	      Plugin.call($spy, data);
	    });
	  });
	}(jQuery);


/***/ },
/* 444 */,
/* 445 */,
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 102,
		"./af.js": 102,
		"./ar": 108,
		"./ar-dz": 103,
		"./ar-dz.js": 103,
		"./ar-ly": 104,
		"./ar-ly.js": 104,
		"./ar-ma": 105,
		"./ar-ma.js": 105,
		"./ar-sa": 106,
		"./ar-sa.js": 106,
		"./ar-tn": 107,
		"./ar-tn.js": 107,
		"./ar.js": 108,
		"./az": 109,
		"./az.js": 109,
		"./be": 110,
		"./be.js": 110,
		"./bg": 111,
		"./bg.js": 111,
		"./bn": 112,
		"./bn.js": 112,
		"./bo": 113,
		"./bo.js": 113,
		"./br": 114,
		"./br.js": 114,
		"./bs": 115,
		"./bs.js": 115,
		"./ca": 116,
		"./ca.js": 116,
		"./cs": 117,
		"./cs.js": 117,
		"./cv": 118,
		"./cv.js": 118,
		"./cy": 119,
		"./cy.js": 119,
		"./da": 120,
		"./da.js": 120,
		"./de": 122,
		"./de-at": 121,
		"./de-at.js": 121,
		"./de.js": 122,
		"./dv": 123,
		"./dv.js": 123,
		"./el": 124,
		"./el.js": 124,
		"./en-au": 125,
		"./en-au.js": 125,
		"./en-ca": 126,
		"./en-ca.js": 126,
		"./en-gb": 127,
		"./en-gb.js": 127,
		"./en-ie": 128,
		"./en-ie.js": 128,
		"./en-nz": 129,
		"./en-nz.js": 129,
		"./eo": 130,
		"./eo.js": 130,
		"./es": 132,
		"./es-do": 131,
		"./es-do.js": 131,
		"./es.js": 132,
		"./et": 133,
		"./et.js": 133,
		"./eu": 134,
		"./eu.js": 134,
		"./fa": 135,
		"./fa.js": 135,
		"./fi": 136,
		"./fi.js": 136,
		"./fo": 137,
		"./fo.js": 137,
		"./fr": 140,
		"./fr-ca": 138,
		"./fr-ca.js": 138,
		"./fr-ch": 139,
		"./fr-ch.js": 139,
		"./fr.js": 140,
		"./fy": 141,
		"./fy.js": 141,
		"./gd": 142,
		"./gd.js": 142,
		"./gl": 143,
		"./gl.js": 143,
		"./he": 144,
		"./he.js": 144,
		"./hi": 145,
		"./hi.js": 145,
		"./hr": 146,
		"./hr.js": 146,
		"./hu": 147,
		"./hu.js": 147,
		"./hy-am": 148,
		"./hy-am.js": 148,
		"./id": 149,
		"./id.js": 149,
		"./is": 150,
		"./is.js": 150,
		"./it": 151,
		"./it.js": 151,
		"./ja": 152,
		"./ja.js": 152,
		"./jv": 153,
		"./jv.js": 153,
		"./ka": 154,
		"./ka.js": 154,
		"./kk": 155,
		"./kk.js": 155,
		"./km": 156,
		"./km.js": 156,
		"./ko": 157,
		"./ko.js": 157,
		"./ky": 158,
		"./ky.js": 158,
		"./lb": 159,
		"./lb.js": 159,
		"./lo": 160,
		"./lo.js": 160,
		"./lt": 161,
		"./lt.js": 161,
		"./lv": 162,
		"./lv.js": 162,
		"./me": 163,
		"./me.js": 163,
		"./mi": 164,
		"./mi.js": 164,
		"./mk": 165,
		"./mk.js": 165,
		"./ml": 166,
		"./ml.js": 166,
		"./mr": 167,
		"./mr.js": 167,
		"./ms": 169,
		"./ms-my": 168,
		"./ms-my.js": 168,
		"./ms.js": 169,
		"./my": 170,
		"./my.js": 170,
		"./nb": 171,
		"./nb.js": 171,
		"./ne": 172,
		"./ne.js": 172,
		"./nl": 174,
		"./nl-be": 173,
		"./nl-be.js": 173,
		"./nl.js": 174,
		"./nn": 175,
		"./nn.js": 175,
		"./pa-in": 176,
		"./pa-in.js": 176,
		"./pl": 177,
		"./pl.js": 177,
		"./pt": 179,
		"./pt-br": 178,
		"./pt-br.js": 178,
		"./pt.js": 179,
		"./ro": 180,
		"./ro.js": 180,
		"./ru": 181,
		"./ru.js": 181,
		"./se": 182,
		"./se.js": 182,
		"./si": 183,
		"./si.js": 183,
		"./sk": 184,
		"./sk.js": 184,
		"./sl": 185,
		"./sl.js": 185,
		"./sq": 186,
		"./sq.js": 186,
		"./sr": 188,
		"./sr-cyrl": 187,
		"./sr-cyrl.js": 187,
		"./sr.js": 188,
		"./ss": 189,
		"./ss.js": 189,
		"./sv": 190,
		"./sv.js": 190,
		"./sw": 191,
		"./sw.js": 191,
		"./ta": 192,
		"./ta.js": 192,
		"./te": 193,
		"./te.js": 193,
		"./tet": 194,
		"./tet.js": 194,
		"./th": 195,
		"./th.js": 195,
		"./tl-ph": 196,
		"./tl-ph.js": 196,
		"./tlh": 197,
		"./tlh.js": 197,
		"./tr": 198,
		"./tr.js": 198,
		"./tzl": 199,
		"./tzl.js": 199,
		"./tzm": 201,
		"./tzm-latn": 200,
		"./tzm-latn.js": 200,
		"./tzm.js": 201,
		"./uk": 202,
		"./uk.js": 202,
		"./uz": 203,
		"./uz.js": 203,
		"./vi": 204,
		"./vi.js": 204,
		"./x-pseudo": 205,
		"./x-pseudo.js": 205,
		"./yo": 206,
		"./yo.js": 206,
		"./zh-cn": 207,
		"./zh-cn.js": 207,
		"./zh-hk": 208,
		"./zh-hk.js": 208,
		"./zh-tw": 209,
		"./zh-tw.js": 209
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 446;


/***/ },
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/wedge-logo.18e2cb1.png";

/***/ },
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(418)
	
	/* script */
	__vue_exports__ = __webpack_require__(232)
	
	/* template */
	var __vue_template__ = __webpack_require__(491)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-27f743ee"
	
	module.exports = __vue_exports__


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(425)
	
	/* script */
	__vue_exports__ = __webpack_require__(233)
	
	/* template */
	var __vue_template__ = __webpack_require__(499)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-509a0d00"
	
	module.exports = __vue_exports__


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(437)
	
	/* script */
	__vue_exports__ = __webpack_require__(234)
	
	/* template */
	var __vue_template__ = __webpack_require__(514)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f694902a"
	
	module.exports = __vue_exports__


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(411)
	
	/* script */
	__vue_exports__ = __webpack_require__(235)
	
	/* template */
	var __vue_template__ = __webpack_require__(484)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-15ace698"
	
	module.exports = __vue_exports__


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(434)
	
	/* script */
	__vue_exports__ = __webpack_require__(238)
	
	/* template */
	var __vue_template__ = __webpack_require__(510)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(420)
	
	/* script */
	__vue_exports__ = __webpack_require__(240)
	
	/* template */
	var __vue_template__ = __webpack_require__(493)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-35a2ea7c"
	
	module.exports = __vue_exports__


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(424)
	
	/* script */
	__vue_exports__ = __webpack_require__(242)
	
	/* template */
	var __vue_template__ = __webpack_require__(498)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5080b747"
	
	module.exports = __vue_exports__


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(417)
	
	/* script */
	__vue_exports__ = __webpack_require__(245)
	
	/* template */
	var __vue_template__ = __webpack_require__(490)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-26c9619c"
	
	module.exports = __vue_exports__


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(430)
	
	/* script */
	__vue_exports__ = __webpack_require__(247)
	
	/* template */
	var __vue_template__ = __webpack_require__(505)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6feb489a"
	
	module.exports = __vue_exports__


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(414)
	
	/* script */
	__vue_exports__ = __webpack_require__(249)
	
	/* template */
	var __vue_template__ = __webpack_require__(487)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2486863d"
	
	module.exports = __vue_exports__


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(410)
	
	/* script */
	__vue_exports__ = __webpack_require__(250)
	
	/* template */
	var __vue_template__ = __webpack_require__(483)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1399e3b6"
	
	module.exports = __vue_exports__


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(429)
	
	/* script */
	__vue_exports__ = __webpack_require__(251)
	
	/* template */
	var __vue_template__ = __webpack_require__(504)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6b672dd3"
	
	module.exports = __vue_exports__


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(428)
	
	/* script */
	__vue_exports__ = __webpack_require__(252)
	
	/* template */
	var __vue_template__ = __webpack_require__(503)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5db7bdf1"
	
	module.exports = __vue_exports__


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(408)
	
	/* script */
	__vue_exports__ = __webpack_require__(253)
	
	/* template */
	var __vue_template__ = __webpack_require__(481)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0b5d9552"
	
	module.exports = __vue_exports__


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(427)
	
	/* script */
	__vue_exports__ = __webpack_require__(254)
	
	/* template */
	var __vue_template__ = __webpack_require__(502)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-59e45290"
	
	module.exports = __vue_exports__


/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(412)
	
	/* script */
	__vue_exports__ = __webpack_require__(255)
	
	/* template */
	var __vue_template__ = __webpack_require__(485)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1d61f6a9"
	
	module.exports = __vue_exports__


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(426)
	
	/* script */
	__vue_exports__ = __webpack_require__(256)
	
	/* template */
	var __vue_template__ = __webpack_require__(501)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-56cb12da"
	
	module.exports = __vue_exports__


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(409)
	
	/* script */
	__vue_exports__ = __webpack_require__(257)
	
	/* template */
	var __vue_template__ = __webpack_require__(482)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0e8cd25e"
	
	module.exports = __vue_exports__


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(431)
	
	/* script */
	__vue_exports__ = __webpack_require__(258)
	
	/* template */
	var __vue_template__ = __webpack_require__(506)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-729ec9f8"
	
	module.exports = __vue_exports__


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(422)
	
	/* script */
	__vue_exports__ = __webpack_require__(259)
	
	/* template */
	var __vue_template__ = __webpack_require__(495)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4b1417fe"
	
	module.exports = __vue_exports__


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(435)
	
	/* script */
	__vue_exports__ = __webpack_require__(260)
	
	/* template */
	var __vue_template__ = __webpack_require__(511)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-921a6f1a"
	
	module.exports = __vue_exports__


/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(413)
	
	/* script */
	__vue_exports__ = __webpack_require__(261)
	
	/* template */
	var __vue_template__ = __webpack_require__(486)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1d6a4b4f"
	
	module.exports = __vue_exports__


/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(346)
	
	/* template */
	var __vue_template__ = __webpack_require__(512)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(347)
	
	/* template */
	var __vue_template__ = __webpack_require__(496)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(349)
	
	/* template */
	var __vue_template__ = __webpack_require__(500)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(433)
	
	/* script */
	__vue_exports__ = __webpack_require__(350)
	
	/* template */
	var __vue_template__ = __webpack_require__(509)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 481 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container-fluid"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'dashboard'
	      }
	    }
	  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Security Events")])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('date-range-picker', {
	    on: {
	      "daterange-change": _vm.dateRangeChange
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('h5', [_vm._v(_vm._s(_vm.dateRangeFormat(_vm.dateStart)) + " - " + _vm._s(_vm.dateRangeFormat(_vm.dateEnd)))])])]), _vm._v(" "), _c('form', {
	    staticClass: "form-inline"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "checkbox"
	  }, [_c('label', {
	    staticClass: "checkbox-inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.showDetails),
	      expression: "showDetails"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "value": _vm.showDetails,
	      "checked": Array.isArray(_vm.showDetails) ? _vm._i(_vm.showDetails, _vm.showDetails) > -1 : (_vm.showDetails)
	    },
	    on: {
	      "click": function($event) {
	        var $$a = _vm.showDetails,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = _vm.showDetails,
	            $$i = _vm._i($$a, $$v);
	          if ($$c) {
	            $$i < 0 && (_vm.showDetails = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.showDetails = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.showDetails = $$c
	        }
	      }
	    }
	  }), _vm._v("Show Details")])])]), _vm._v(" "), (_vm.showDetails) ? _c('div', {
	    staticClass: "form-group"
	  }, _vm._l((_vm.protocols), function(protocol) {
	    return _c('div', {
	      staticClass: "checkbox"
	    }, [_c('label', {
	      staticClass: "checkbox-inline"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.selectedProtocols),
	        expression: "selectedProtocols"
	      }],
	      attrs: {
	        "type": "checkbox"
	      },
	      domProps: {
	        "value": protocol,
	        "checked": Array.isArray(_vm.selectedProtocols) ? _vm._i(_vm.selectedProtocols, protocol) > -1 : (_vm.selectedProtocols)
	      },
	      on: {
	        "click": function($event) {
	          var $$a = _vm.selectedProtocols,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = protocol,
	              $$i = _vm._i($$a, $$v);
	            if ($$c) {
	              $$i < 0 && (_vm.selectedProtocols = $$a.concat($$v))
	            } else {
	              $$i > -1 && (_vm.selectedProtocols = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.selectedProtocols = $$c
	          }
	        }
	      }
	    }), _vm._v(_vm._s(protocol))])])
	  })) : _vm._e()]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "people"
	    }
	  }, [_c('v-client-table', {
	    attrs: {
	      "data": _vm.tableData,
	      "columns": _vm.columns,
	      "options": _vm.options
	    }
	  }, [_c('v-client-table')], 1)], 1)])
	},staticRenderFns: []}

/***/ },
/* 482 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'dashboard'
	      }
	    }
	  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Serials")])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('date-range-picker', {
	    on: {
	      "daterange-change": _vm.dateRangeChange
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('h5', [_vm._v(_vm._s(_vm.dateRangeFormat(_vm.dateStart)) + " - " + _vm._s(_vm.dateRangeFormat(_vm.dateEnd)))])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-2 button-wrapper"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.clearFilters
	    }
	  }, [_vm._v("Clear All Filters")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3"
	  }, [_c('p', [_vm._v("Showing " + _vm._s(_vm.filteredSerialCount) + " of " + _vm._s(_vm.serialCount) + " serials")])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3 col-sm-6"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchTerm),
	      expression: "searchTerm"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Search..."
	    },
	    domProps: {
	      "value": _vm._s(_vm.searchTerm)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searchTerm = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-6"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedCustomer),
	      expression: "selectedCustomer"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": function($event) {
	        _vm.selectedCustomer = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("Select Customer")]), _vm._v(" "), _vm._l((_vm.customers), function(customer) {
	    return _c('option', [_vm._v(_vm._s(customer))])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-6"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedCity),
	      expression: "selectedCity"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": function($event) {
	        _vm.selectedCity = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("Select City")]), _vm._v(" "), _vm._l((_vm.cities), function(city) {
	    return _c('option', [_vm._v(_vm._s(city))])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-3 col-sm-6"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedCountry),
	      expression: "selectedCountry"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": function($event) {
	        _vm.selectedCountry = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    }
	  }, [_vm._v("Select Country")]), _vm._v(" "), _vm._l((_vm.countries), function(country) {
	    return _c('option', [_vm._v(_vm._s(country))])
	  })], 2)])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('table', {
	    staticClass: "table"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredSerials), function(details) {
	    return _c('tr', [_c('td', [_c('router-link', {
	      attrs: {
	        "to": {
	          name: 'serial',
	          params: {
	            id: details.serial
	          }
	        }
	      }
	    }, [_vm._v(_vm._s(details.serial8))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(details.customer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(details.serviceTag))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(details.city))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(details.country))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(details.softwareVersion))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(details.lastTracked))])])
	  }))])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('th', [_vm._v("Serial")]), _vm._v(" "), _c('th', [_vm._v("Customer")]), _vm._v(" "), _c('th', [_vm._v("Service Tag")]), _vm._v(" "), _c('th', [_vm._v("City")]), _vm._v(" "), _c('th', [_vm._v("Country")]), _vm._v(" "), _c('th', [_vm._v("Software Version")]), _vm._v(" "), _c('th', [_vm._v("Last Tracked")])])
	}]}

/***/ },
/* 483 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [(_vm.preValidation) ? _c('div', [_c('div', {
	    staticClass: "centre-column"
	  }, [_c('h2', [_vm._v("Reset Password")]), _vm._v(" "), (_vm.success) ? _c('div', [_c('p', [_vm._v("\n          Password successfully reset.  Please\n          "), _c('router-link', {
	    attrs: {
	      "to": {
	        name: 'login'
	      }
	    }
	  }, [_vm._v("log in")])], 1)]) : _c('div', [_c('form', {
	    staticClass: "form-signin"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: _vm.validatePassword ? '' : 'has-error'
	  }, [_c('label', {
	    staticClass: "sr-only",
	    attrs: {
	      "for": "inputPassword"
	    }
	  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.password),
	      expression: "password"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "id": "inputPassword",
	      "placeholder": "Password",
	      "required": ""
	    },
	    domProps: {
	      "value": _vm._s(_vm.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.password = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: _vm.validatePassword2 ? '' : 'has-error'
	  }, [_c('label', {
	    staticClass: "sr-only",
	    attrs: {
	      "for": "inputPassword2"
	    }
	  }, [_vm._v("Re-enter Password")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.password2),
	      expression: "password2"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "id": "inputPassword2",
	      "placeholder": "Re-enter password",
	      "required": ""
	    },
	    domProps: {
	      "value": _vm._s(_vm.password2)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.password2 = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), (!_vm.passwordsMatch) ? _c('p', {
	    staticClass: "error"
	  }, [_vm._v("Passwords do not match")]) : _vm._e(), _vm._v(" "), (!_vm.passwordLength) ? _c('p', {
	    staticClass: "error"
	  }, [_vm._v("Password must be at least " + _vm._s(_vm.passwordMinLength) + " characters")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-lg btn-primary btn-block",
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submit($event)
	      }
	    }
	  }, [_vm._v("Reset")])]), _vm._v(" "), (_vm.error) ? _c('p', {
	    staticClass: "error"
	  }, [_vm._v("We apologize, but your password could not be updated at this time.  Please contact Wedge Networks support for assisstance.")]) : _vm._e()])])]) : _c('div', [_c('p', [_vm._v("We are unable to reset your password at this time.  Please contact Wedge Networks support for assistance.")])])])
	},staticRenderFns: []}

/***/ },
/* 484 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'dashboard'
	      }
	    }
	  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Admin - Users")])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-6"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'adminUser',
	        params: {
	          id: 0
	        }
	      }
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button",
	      "aria-label": "Left Align"
	    }
	  }, [_vm._v("\n          Create User\n        ")])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-6"
	  }, [_c('form', {
	    staticClass: "form-inline"
	  }, [_c('div', {
	    staticClass: "form-group has-feedback"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchTerm),
	      expression: "searchTerm"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "inputSearch",
	      "placeholder": "search...",
	      "aria-describedby": "inputSearchStatus"
	    },
	    domProps: {
	      "value": _vm._s(_vm.searchTerm)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searchTerm = $event.target.value
	      }
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "responsive-table"
	  }, [_c('table', {
	    staticClass: "table"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedUsers), function(user) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(user.first_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.last_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('td', [_c('router-link', {
	      attrs: {
	        "to": {
	          name: 'adminUser',
	          params: {
	            id: user.id
	          }
	        }
	      }
	    }, [_c('button', {
	      staticClass: "btn btn-default btn-sm",
	      attrs: {
	        "type": "button",
	        "aria-label": "Left Align"
	      }
	    }, [_c('span', {
	      staticClass: "glyphicon glyphicon-pencil",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })])]), _vm._v(" "), _vm._m(1, true)], 1)])
	  }))])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('th', [_vm._v("First Name")]), _vm._v(" "), _c('th', [_vm._v("Last Name")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('td')])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn btn-default btn-sm",
	    attrs: {
	      "type": "button",
	      "aria-label": "Left Align"
	    }
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-trash",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })])
	}]}

/***/ },
/* 485 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'dashboard'
	      }
	    }
	  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'sandbox'
	      }
	    }
	  }, [_vm._v("Sandbox")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Payload Records")])]), _vm._v(" "), _c('bootstrap-modal', {
	    attrs: {
	      "title": "Analysis Details",
	      "name": "analysisJson"
	    }
	  }, [_c('json', {
	    attrs: {
	      "jsonObject": _vm.verdict.analysisResult
	    }
	  })], 1), _vm._v(" "), _c('h4', [_vm._v("Payload " + _vm._s(_vm.sha1Checksum) + " - " + _vm._s(_vm.size))]), _vm._v(" "), _c('div', {
	    staticClass: "panel-group",
	    attrs: {
	      "id": "accordion"
	    }
	  }, [_c('bootstrap-panel', {
	    attrs: {
	      "title": "Verdict Details"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [(_vm.verdict.processingState === _vm.PROCESSING_COMPLETED) ? _c('div', [_c('table', {
	    staticClass: "table table-condensed"
	  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Classification")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.verdict.classification))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.verdict.virusName))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Date Processed")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.epochDate(_vm.verdict.timestamp)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Analysis Details")]), _vm._v(" "), (_vm.hasAnalysisResult) ? _c('td', [_c('a', {
	    attrs: {
	      "href": "#analysisJson",
	      "data-toggle": "modal"
	    }
	  }, [_vm._v("show")])]) : _c('td')])])])]) : _c('div', [_c('p', [_vm._v("Payload processing " + _vm._s(_vm.verdict.processingState))])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6"
	  }, [(_vm.override === null) ? _c('div', [_c('p', [_vm._v("fetching overrides...")])]) : _c('div', [(_vm.override === '') ? _c('p', [_vm._v("No verdict override configured.")]) : _c('p', [_vm._v("\n              Verdict overridden to "), _c('strong', [_vm._v(_vm._s(_vm.override))])]), _vm._v(" "), _c('form', {
	    staticClass: "form-inline",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.overrideSubmit($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', [_vm._v("Override Verdict")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.override),
	      expression: "override"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": function($event) {
	        _vm.override = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": ""
	    },
	    domProps: {
	      "selected": _vm.override === ''
	    }
	  }, [_vm._v("None")]), _vm._v(" "), _vm._l((_vm.classifications), function(verdict) {
	    return _c('option', {
	      domProps: {
	        "selected": _vm.override === verdict,
	        "value": verdict
	      }
	    }, [_vm._v("\n                    " + _vm._s(verdict) + "\n                  ")])
	  })], 2)]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Save")])]), _vm._v(" "), (_vm.updateMessage) ? _c('p', [_vm._v(_vm._s(_vm.updateMessage))]) : _vm._e()])])])]), _vm._v(" "), _c('bootstrap-panel', {
	    attrs: {
	      "title": "Record Locations"
	    }
	  }, [_c('google-map', {
	    attrs: {
	      "coordinates": _vm.coordinates,
	      "height": "400px"
	    }
	  })], 1), _vm._v(" "), _c('bootstrap-panel', {
	    attrs: {
	      "title": "Payload Records"
	    }
	  }, [_c('table', {
	    staticClass: "table table-condensed"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Customer")]), _vm._v(" "), _c('th', [_vm._v("Serial")]), _vm._v(" "), _c('th', [_vm._v("Service Tag")]), _vm._v(" "), _c('th', [_vm._v("Protocol")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Url")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.recordsSorted), function(record, index) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.epochDate(record.timestamp)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.metadata.licenseCustomer))]), _vm._v(" "), _c('td', [_c('router-link', {
	      attrs: {
	        "to": {
	          name: 'serial',
	          params: {
	            id: record.metadata.licenseSerial
	          }
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.trim(record.metadata.licenseSerial, 8)))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.metadata.licenseServiceTag))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.metadata.protocol))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.trim(record.metadata.magic, 20)) + "\n              "), _c('bootstrap-popover', {
	      attrs: {
	        "placement": "top",
	        "content": record.metadata.magic
	      }
	    }, [_vm._v("...")])], 1), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.trim(record.metadata.url, 20)) + "\n              "), _c('bootstrap-popover', {
	      attrs: {
	        "placement": "top",
	        "content": record.metadata.url
	      }
	    }, [_vm._v("...")])], 1)])
	  }))])])], 1)], 1)
	},staticRenderFns: []}

/***/ },
/* 486 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('h4', [_vm._v("User Profile")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('table', {
	    staticClass: "table"
	  }, [_c('tbody', [_c('tr', [_c('td', {
	    staticClass: "bold"
	  }, [_vm._v("Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userProfile.first_name) + " " + _vm._s(_vm.userProfile.last_name))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "bold"
	  }, [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userProfile.email))])]), _vm._v(" "), _c('tr', [_c('td', {
	    staticClass: "bold"
	  }, [_vm._v("Roles")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roles))])])])])])])])
	},staticRenderFns: []}

/***/ },
/* 487 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "centre-column"
	  }, [_c('h2', [_vm._v("Forgot Password")]), _vm._v(" "), (_vm.success) ? _c('div', [_c('p', [_vm._v("\n        Your request was successful.  Please check your email, and click the link in the email to reset your password.\n      ")])]) : _c('div', [_c('p', [_vm._v("\n        An email will be sent to your email address containing a link that can be used to reset your password.\n      ")]), _vm._v(" "), _c('form', {
	    staticClass: "form-signin"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: _vm.validateEmail ? '' : 'has-error'
	  }, [_c('label', {
	    staticClass: "sr-only",
	    attrs: {
	      "for": "inputEmail"
	    }
	  }, [_vm._v("Email Address")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.email),
	      expression: "email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "email",
	      "id": "inputEmail",
	      "placeholder": "Email address",
	      "required": "",
	      "autofocus": ""
	    },
	    domProps: {
	      "value": _vm._s(_vm.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.email = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-lg btn-primary btn-block",
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submit($event)
	      }
	    }
	  }, [_vm._v("Submit")])]), _vm._v(" "), (_vm.error) ? _c('p', {
	    staticClass: "error"
	  }, [_vm._v("There was a problem making the password reset request.  Please double check your email address, and if the problem continues, contact Wedge Networks support.")]) : _vm._e()])])])
	},staticRenderFns: []}

/***/ },
/* 488 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('pre', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.json)
	    }
	  }, [_vm._v("\n")])
	},staticRenderFns: []}

/***/ },
/* 489 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('gmap-map', {
	    style: (_vm.height ? 'height:' + _vm.height : ''),
	    attrs: {
	      "center": _vm.centerPosition.position,
	      "zoom": _vm.centerPosition.zoom
	    }
	  }, _vm._l((_vm.markers), function(m, index) {
	    return _c('gmap-marker', {
	      attrs: {
	        "position": m.position,
	        "clickable": !!m.popupText,
	        "draggable": false
	      },
	      on: {
	        "click": function($event) {
	          _vm.markerClick(index)
	        }
	      }
	    }, [_c('gmap-info-window', {
	      attrs: {
	        "opened": _vm.markersVisibility[index] === true,
	        "content": m.popupText
	      },
	      on: {
	        "closeclick": function($event) {
	          _vm.infoWindowClose(index)
	        }
	      }
	    })], 1)
	  }))], 1)
	},staticRenderFns: []}

/***/ },
/* 490 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'dashboard'
	      }
	    }
	  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Licenses")])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('date-range-picker', {
	    on: {
	      "daterange-change": _vm.dateRangeChange
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('h5', [_vm._v(_vm._s(_vm.dateRangeFormat(_vm.dateStart)) + " - " + _vm._s(_vm.dateRangeFormat(_vm.dateEnd)))])])]), _vm._v(" "), _c('p', [_vm._v("Showing " + _vm._s(_vm.licenseCount) + " licenses")]), _vm._v(" "), _vm._l((_vm.sortedLicenses), function(lic) {
	    return _c('div', {
	      staticClass: "panel panel-default"
	    }, [_c('div', {
	      staticClass: "panel-heading"
	    }, [_vm._v("\n      " + _vm._s(lic.license.key) + "\n    ")]), _vm._v(" "), _c('span', [_vm._v("Issued - " + _vm._s(_vm.formatDate(lic.license.issued)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(lic.license.numActivations) + " / " + _vm._s(lic.license.maxInstances) + " activations")]), _vm._v(" "), _c('div', {
	      staticClass: "table-responsive"
	    }, [_c('table', {
	      staticClass: "table"
	    }, [_c('thead', [_c('tr', _vm._l((lic.attributes.license.service), function(service, name) {
	      return _c('th', [_vm._v("\n            " + _vm._s(name) + "\n          ")])
	    }))]), _vm._v(" "), _c('tbody', [_c('tr', _vm._l((lic.attributes.license.service), function(service) {
	      return _c('td', [(service.enabled === 'true') ? _c('span', {
	        staticClass: "glyphicon glyphicon-ok",
	        attrs: {
	          "aria-hidden": "true"
	        }
	      }) : _vm._e()])
	    }))])])]), _vm._v(" "), (lic.activations.length > 0) ? _c('div', [_c('table', {
	      staticClass: "table"
	    }, [_vm._m(0, true), _vm._v(" "), _c('tbody', _vm._l((lic.activations), function(activation) {
	      return _c('tr', {
	        class: _vm.expiresRowClass(activation.activateTime, lic.attributes.license.root.expires, lic.attributes.license.root.duration)
	      }, [_c('td', [_vm._v(_vm._s(_vm.formatDate(activation.activateTime)))]), _vm._v(" "), _c('td', [_c('router-link', {
	        attrs: {
	          "to": {
	            name: 'serial',
	            params: {
	              id: activation.serial
	            }
	          }
	        }
	      }, [_vm._v(_vm._s(_vm.trim(activation.serial, 8)))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.serialDetails[activation.serial] ? _vm.serialDetails[activation.serial].customer : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseExpiryDate(activation.activateTime, lic.attributes.license.root.expires, lic.attributes.license.root.duration).format('YYYY-MM-DD HH:mm')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseExpiryDate(activation.activateTime, lic.attributes.license.root.expires, lic.attributes.license.root.duration).fromNow()))]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(activation.installed === 1 ? 'yes' : 'no'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(activation.installInfo))])])
	    }))])]) : _c('div', [_c('span', [_vm._v("No license activations.")])])])
	  })], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('th', [_vm._v("Activation Date")]), _vm._v(" "), _c('th', [_vm._v("Serial")]), _vm._v(" "), _c('th', [_vm._v("Customer")]), _vm._v(" "), _c('th', [_vm._v("Expiry Date")]), _vm._v(" "), _c('th', [_vm._v("Expires In")]), _vm._v(" "), _c('th', [_vm._v("Installed")]), _vm._v(" "), _c('th', [_vm._v("Info")])])
	}]}

/***/ },
/* 491 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('date-range-picker', {
	    on: {
	      "daterange-change": _vm.dateRangeChange
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('h5', [_vm._v(_vm._s(_vm.dateRangeFormat(_vm.dateStart)) + " - " + _vm._s(_vm.dateRangeFormat(_vm.dateEnd)))])])]), _vm._v(" "), _c('bootstrap-panel', {
	    attrs: {
	      "title": "Appliance Locations"
	    }
	  }, [_c('google-map', {
	    attrs: {
	      "coordinates": _vm.trackCoordinates,
	      "height": "400px"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6 col-md-6"
	  }, [_c('high-chart', {
	    attrs: {
	      "options": _vm.appliancesChartOptions,
	      "series": _vm.appliancesChartSeries
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6 col-md-6"
	  }, [_c('high-chart', {
	    attrs: {
	      "options": _vm.versionsChartOptions,
	      "series": _vm.versionsChartSeries
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-3 col-md-3"
	  }, [_c('high-chart', {
	    attrs: {
	      "options": _vm.requestsChartOptions,
	      "series": _vm.requestsChartSeries
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3 col-md-3"
	  }, [_c('high-chart', {
	    attrs: {
	      "options": _vm.malwareChartOptions,
	      "series": _vm.malwareChartSeries
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3 col-md-3"
	  }, [_c('high-chart', {
	    attrs: {
	      "options": _vm.bytesChartOptions,
	      "series": _vm.bytesChartSeries
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3 col-md-3"
	  }, [_c('high-chart', {
	    attrs: {
	      "options": _vm.connectionsChartOptions,
	      "series": _vm.connectionsChartSeries
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-3 col-md-3"
	  }, [_c('high-chart', {
	    attrs: {
	      "options": _vm.aiMalwareChartOptions,
	      "series": _vm.aiMalwareChartSeries
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3 col-md-3"
	  }, [_c('high-chart', {
	    attrs: {
	      "options": _vm.aiGraywareChartOptions,
	      "series": _vm.aiGraywareChartSeries
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3 col-md-3"
	  }, [_c('high-chart', {
	    attrs: {
	      "options": _vm.sandboxMalwareChartOptions,
	      "series": _vm.sandboxMalwareChartSeries
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3 col-md-3"
	  }, [_c('high-chart', {
	    attrs: {
	      "options": _vm.sandboxCleanChartOptions,
	      "series": _vm.sandboxCleanChartSeries
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-3 col-md-3"
	  }, [_c('high-chart', {
	    attrs: {
	      "options": _vm.urlsChartOptions,
	      "series": _vm.urlsChartSeries
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-3 col-md-3"
	  }, [_c('high-chart', {
	    attrs: {
	      "options": _vm.spamChartOptions,
	      "series": _vm.spamChartSeries
	    }
	  })], 1)])], 1)
	},staticRenderFns: []}

/***/ },
/* 492 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "el"
	  })
	},staticRenderFns: []}

/***/ },
/* 493 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('svg', {
	    attrs: {
	      "width": "800",
	      "height": "30",
	      "xmlns": "http://www.w3.org/2000/svg",
	      "xmlns:xlink": "http://www.w3.org/1999/xlink"
	    }
	  }, _vm._l((_vm.dayStyles), function(style, index) {
	    return _c('rect', {
	      class: style,
	      attrs: {
	        "track-by": "$index",
	        "x": index * 12,
	        "y": "0",
	        "height": "10",
	        "width": "10",
	        "rx": "2",
	        "ry": "2"
	      }
	    })
	  }))])
	},staticRenderFns: []}

/***/ },
/* 494 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "loader-container"
	  }, [(_vm.loading) ? _c('div', {
	    staticClass: "loader"
	  }) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 495 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ },
/* 496 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    ref: "flyaway"
	  }, [_vm._t("default", [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.content)
	    }
	  })])], 2)])
	},staticRenderFns: []}

/***/ },
/* 497 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', {
	    staticClass: "navbar navbar-default navbar-fixed-top"
	  }, [_c('div', {
	    staticClass: "container-fluid"
	  }, [_c('div', {
	    staticClass: "navbar-header"
	  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
	    staticClass: "navbar-brand",
	    attrs: {
	      "to": "/"
	    }
	  }, [_vm._v("Wedge SOC")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "collapse navbar-collapse",
	    attrs: {
	      "id": "soc-navbar"
	    }
	  }, [_c('ul', {
	    staticClass: "nav navbar-nav"
	  }, [(_vm.userIsAdmin) ? _c('li', {
	    staticClass: "dropdown",
	    class: _vm.pathPrefixMatches('/admin') ? 'active' : ''
	  }, [_vm._m(1), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('router-link', {
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'adminUsers'
	      }
	    }
	  }, [_c('a', [_vm._v("Users")])])], 1)]) : _vm._e(), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'serial-list'
	      }
	    }
	  }, [_c('a', [_vm._v("Serial")])]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'license'
	      }
	    }
	  }, [_c('a', [_vm._v("License")])]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'sandbox'
	      }
	    }
	  }, [_c('a', [_vm._v("Sandbox")])]), _vm._v(" "), _c('li', {
	    staticClass: "dropdown",
	    class: _vm.pathPrefixMatches('/soc/report') ? 'active' : ''
	  }, [_vm._m(2), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('router-link', {
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'reportSecurityEvent'
	      }
	    }
	  }, [_c('a', [_vm._v("Security Events")])]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "tag": "li",
	      "to": {
	        name: 'reportLicenseExpiry'
	      }
	    }
	  }, [_c('a', [_vm._v("License Expiry")])])], 1)])], 1), _vm._v(" "), _c('ul', {
	    staticClass: "nav navbar-nav navbar-right"
	  }, [_c('li', {
	    staticClass: "dropdown",
	    class: _vm.pathPrefixMatches('/user') ? 'active' : ''
	  }, [_c('a', {
	    staticClass: "dropdown-toggle",
	    attrs: {
	      "href": "#",
	      "data-toggle": "dropdown",
	      "role": "button",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    }
	  }, [_vm._v("\n            " + _vm._s(_vm.userProfile.email) + "\n            "), _c('span', {
	    staticClass: "caret"
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'userProfile'
	      }
	    }
	  }, [_vm._v("User Profile")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'logout'
	      }
	    }
	  }, [_vm._v("Logout")])], 1)])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "navbar-toggle collapsed",
	    attrs: {
	      "type": "button",
	      "data-toggle": "collapse",
	      "data-target": "#soc-navbar",
	      "aria-expanded": "false"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-bar"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "icon-bar"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "icon-bar"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "dropdown-toggle",
	    attrs: {
	      "href": "#",
	      "data-toggle": "dropdown",
	      "role": "button",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    }
	  }, [_vm._v("Admin "), _c('span', {
	    staticClass: "caret"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "dropdown-toggle",
	    attrs: {
	      "href": "#",
	      "data-toggle": "dropdown",
	      "role": "button",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    }
	  }, [_vm._v("Reports "), _c('span', {
	    staticClass: "caret"
	  })])
	}]}

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _c('h3', [_vm._v("Content Hash Lookup")]), _vm._v(" "), _vm._l((_vm.verdicts), function(verdict, index) {
	    return _c('bootstrap-modal', {
	      attrs: {
	        "title": "Analysis Details",
	        "name": 'analysisJson' + index
	      }
	    }, [_c('json', {
	      attrs: {
	        "jsonObject": verdict.analysisResult
	      }
	    })], 1)
	  }), _vm._v(" "), _c('form', {
	    staticClass: "form",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.lookupSubmit($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 col-sm-8"
	  }, [_c('div', {
	    staticClass: "input-group input-group-lg"
	  }, [_c('label', {
	    staticClass: "sr-only",
	    attrs: {
	      "for": "contentHash"
	    }
	  }, [_vm._v("Content Hash")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contentHash),
	      expression: "contentHash"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "contenthash",
	      "placeholder": "Content SHA1 Hash",
	      "autofocus": ""
	    },
	    domProps: {
	      "value": _vm._s(_vm.contentHash)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.contentHash = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Lookup")]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-default",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.clearForm($event)
	      }
	    }
	  }, [_vm._v("Clear")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "spacer10"
	  }), _vm._v(" "), (_vm.displayVerdict) ? _c('div', [(_vm.verdicts.length > 0) ? _c('table', {
	    staticClass: "table"
	  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.verdicts), function(verdict, index) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(verdict.size))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatEpoch(verdict.timestamp)))]), _vm._v(" "), _c('td', [_vm._v("WedgeMA™")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(verdict.classification))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(verdict.virusName || 'N/A'))]), _vm._v(" "), ('analysisResult' in verdict) ? _c('td', [_c('a', {
	      attrs: {
	        "href": '#analysisJson' + index,
	        "data-toggle": "modal"
	      }
	    }, [_vm._v("show")])]) : _c('td')])
	  }))]) : _c('p', [_vm._v("\n        No verdicts found for content hash.\n      ")])]) : _vm._e()], 2)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "logo"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(450),
	      "width": "200px"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Size")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Service")]), _vm._v(" "), _c('th', [_vm._v("Classification")]), _vm._v(" "), _c('th', [_vm._v("Virus Name")]), _vm._v(" "), _c('th', [_vm._v("Analysis Result")])])])
	}]}

/***/ },
/* 499 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('nav-bar'), _vm._v(" "), _c('loading-bar'), _vm._v(" "), _c('router-view')], 1)
	},staticRenderFns: []}

/***/ },
/* 500 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', [_c('span', {
	    domProps: {
	      "textContent": _vm._s(_vm.label)
	    }
	  }), _vm._v(" "), _c('input', {
	    ref: "input",
	    class: _vm.className,
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.placeholder
	    }
	  })])
	},staticRenderFns: []}

/***/ },
/* 501 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'dashboard'
	      }
	    }
	  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'serial-list'
	      }
	    }
	  }, [_vm._v("Serials")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v(_vm._s(_vm.serial))])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('date-range-picker', {
	    on: {
	      "daterange-change": _vm.dateRangeChange
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('h5', [_vm._v(_vm._s(_vm.dateRangeFormat(_vm.dateStart)) + " - " + _vm._s(_vm.dateRangeFormat(_vm.dateEnd)))])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('track-days', {
	    attrs: {
	      "date-start": _vm.epochStart,
	      "date-end": _vm.epochEnd,
	      "days": _vm.sortedTrackLogs
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('ul', {
	    staticClass: "nav nav-tabs"
	  }, [_c('li', {
	    class: _vm.activeTab === 'details' ? 'active' : ''
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        _vm.showTab('details')
	      }
	    }
	  }, [_vm._v("Details")])]), _vm._v(" "), _c('li', {
	    class: _vm.activeTab === 'licenses' ? 'active' : ''
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        _vm.showTab('licenses')
	      }
	    }
	  }, [_vm._v("Licenses")])]), _vm._v(" "), _c('li', {
	    class: _vm.activeTab === 'proxy' ? 'active' : ''
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        _vm.showTab('proxy')
	      }
	    }
	  }, [_vm._v("Proxy Stats")])]), _vm._v(" "), _c('li', {
	    class: _vm.activeTab === 'os' ? 'active' : ''
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        _vm.showTab('os')
	      }
	    }
	  }, [_vm._v("OS Stats")])])])]), _vm._v(" "), (_vm.activeTab === 'details') ? _c('div', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-sm-12"
	  }, [_c('table', {
	    staticClass: "table"
	  }, [_c('thead'), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Serial")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.serial))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Customer")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.serialDetails.customer))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Country")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.locationCountry))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("City")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.locationCity))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Wedge SO Version")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.softwareVersion))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Service Tag")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.serialDetails.serviceTag))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("MAC Address")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.serialDetails.mac))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Support Group")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.serialDetails.supportGroup))])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-sm-12"
	  }, [_c('google-map', {
	    attrs: {
	      "coordinates": _vm.locationCoordinates,
	      "height": "250px"
	    }
	  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'licenses') ? _c('div', [_c('div', {
	    staticClass: "row"
	  }, [(_vm.serialLicenses.length === 0) ? _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('p', [_vm._v("No licenses have been activated for this appliance serial.")])]) : _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Key")]), _vm._v(" "), _c('th', [_vm._v("Activated")]), _vm._v(" "), _c('th', [_vm._v("Issued")]), _vm._v(" "), _c('th', [_vm._v("Expiry Date")]), _vm._v(" "), _c('th', [_vm._v("Expires")]), _vm._v(" "), _c('th', [_vm._v("Duration")]), _vm._v(" "), _vm._l((_vm.licenseServices), function(service) {
	    return _c('th', [_vm._v(_vm._s(service))])
	  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.reducedLicenses), function(license) {
	    return _c('tr', {
	      class: _vm.licenseRowClass(license.expired, license.expiresInDays)
	    }, [_c('td', [_vm._v(_vm._s(license.key))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(license.activated))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(license.issued))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(license.expiryDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(license.expiresFromNow))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(license.duration))]), _vm._v(" "), _vm._l((_vm.licenseServices), function(service) {
	      return _c('td', [(license.services[service]) ? _c('span', {
	        staticClass: "glyphicon glyphicon-ok",
	        attrs: {
	          "aria-hidden": "true"
	        }
	      }) : _vm._e()])
	    })], 2)
	  }))])])])])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'proxy') ? _c('div', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6 col-md-6"
	  }, [_c('high-chart', {
	    attrs: {
	      "options": _vm.requestsChartOptions,
	      "series": _vm.requestsChartSeries
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6 col-md-6"
	  }, [_c('high-chart', {
	    attrs: {
	      "options": _vm.connectionsChartOptions,
	      "series": _vm.connectionsChartSeries
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6 col-md-6"
	  }, [_c('high-chart', {
	    attrs: {
	      "options": _vm.malwareChartOptions,
	      "series": _vm.malwareChartSeries
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6 col-md-6"
	  }, [_c('high-chart', {
	    attrs: {
	      "options": _vm.bytesChartOptions,
	      "series": _vm.bytesChartSeries
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6 col-md-6"
	  }, [_c('high-chart', {
	    attrs: {
	      "options": _vm.aiMalwareChartOptions,
	      "series": _vm.aiMalwareChartSeries
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6 col-md-6"
	  }, [_c('high-chart', {
	    attrs: {
	      "options": _vm.aiGraywareChartOptions,
	      "series": _vm.aiGraywareChartSeries
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6 col-md-6"
	  }, [_c('high-chart', {
	    attrs: {
	      "options": _vm.sandboxMalwareChartOptions,
	      "series": _vm.sandboxMalwareChartSeries
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6 col-md-6"
	  }, [_c('high-chart', {
	    attrs: {
	      "options": _vm.sandboxCleanChartOptions,
	      "series": _vm.sandboxCleanChartSeries
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6 col-md-6"
	  }, [_c('high-chart', {
	    attrs: {
	      "options": _vm.urlsChartOptions,
	      "series": _vm.urlsChartSeries
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6 col-md-6"
	  }, [_c('high-chart', {
	    attrs: {
	      "options": _vm.spamChartOptions,
	      "series": _vm.spamChartSeries
	    }
	  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'os') ? _c('div', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6 col-md-6"
	  }, [_c('high-chart', {
	    attrs: {
	      "options": _vm.netIngressChartOptions,
	      "series": _vm.netIngressChartSeries
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6 col-md-6"
	  }, [_c('high-chart', {
	    attrs: {
	      "options": _vm.netEgressChartOptions,
	      "series": _vm.netEgressChartSeries
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6 col-md-6"
	  }, [_c('high-chart', {
	    attrs: {
	      "options": _vm.netBridgeChartOptions,
	      "series": _vm.netBridgeChartSeries
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6 col-md-6"
	  }, [_c('high-chart', {
	    attrs: {
	      "options": _vm.netControlChartOptions,
	      "series": _vm.netControlChartSeries
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6 col-md-6"
	  }, [_c('high-chart', {
	    attrs: {
	      "options": _vm.uespFsCfChartOptions,
	      "series": _vm.uespFsCfChartSeries
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6 col-md-6"
	  })])]) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 502 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'dashboard'
	      }
	    }
	  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("Sandbox")])]), _vm._v(" "), _c('h4', [_vm._v("Analysis Verdicts")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "table-responsive"
	  }, [_c('table', {
	    staticClass: "table"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.verdictsSorted), function(verdict, index) {
	    return _c('tr', {
	      staticClass: "accordion-toggle",
	      class: _vm.tableRowStyle(verdict.classification),
	      attrs: {
	        "data-toggle": "collapse",
	        "data-target": '#details' + index
	      }
	    }, [_c('td', [_vm._v(_vm._s(_vm.epochDate(verdict.timestamp)))]), _vm._v(" "), _c('td', [_c('router-link', {
	      attrs: {
	        "to": {
	          name: 'SandboxRecord',
	          params: {
	            sha1: verdict.sha1Checksum,
	            size: verdict.size
	          }
	        }
	      }
	    }, [_vm._v(_vm._s(verdict.sha1Checksum))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(verdict.size))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(verdict.processingState))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(verdict.classification))]), _vm._v(" "), _c('td', [_c('a', {
	      attrs: {
	        "href": _vm.graywareDownloadLink(verdict.sha1Checksum, verdict.size),
	        "download": _vm.graywareDownloadFilename(verdict.sha1Checksum, verdict.size)
	      }
	    }, [_c('span', {
	      staticClass: "glyphicon glyphicon-download",
	      attrs: {
	        "aria-hidden": "true"
	      }
	    })])])])
	  }))])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("SHA1 Checksum")]), _vm._v(" "), _c('th', [_vm._v("Size")]), _vm._v(" "), _c('th', [_vm._v("Processing State")]), _vm._v(" "), _c('th', [_vm._v("Classification")]), _vm._v(" "), _c('th')])])
	}]}

/***/ },
/* 503 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'dashboard'
	      }
	    }
	  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v("License Expiry")])]), _vm._v(" "), _vm._l((_vm.filteredActivations), function(license, index) {
	    return _c('bootstrap-modal', {
	      attrs: {
	        "title": "License Details",
	        "name": 'attributesJson' + index
	      }
	    }, [_c('json', {
	      attrs: {
	        "jsonObject": license.attributes
	      }
	    })], 1)
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('date-range-picker', {
	    attrs: {
	      "placeHolder": "Licenses Issued Between",
	      "ranges": _vm.datePickerRanges
	    },
	    on: {
	      "daterange-change": _vm.dateRangeChange
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('h5', [_vm._v(_vm._s(_vm.dateRangeFormat(_vm.dateStart)) + " - " + _vm._s(_vm.dateRangeFormat(_vm.dateEnd)))])])]), _vm._v(" "), _c('form', {
	    staticClass: "form-inline"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "activationsExpiredInput"
	    }
	  }, [_vm._v("Activations expired in last (days)")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.expiresAgoDays),
	      expression: "expiresAgoDays"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "activationsExpiredInput",
	      "placeholder": "days"
	    },
	    domProps: {
	      "value": _vm.expiresAgoDays,
	      "value": _vm._s(_vm.expiresAgoDays)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.expiresAgoDays = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "activationsWillExpireDays"
	    }
	  }, [_vm._v("or in the next (days)")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.expiresInDays),
	      expression: "expiresInDays"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "activationsWillExpireDays",
	      "placeholder": "days"
	    },
	    domProps: {
	      "value": _vm.expiresInDays,
	      "value": _vm._s(_vm.expiresInDays)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.expiresInDays = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), (_vm.filteredActivations.length > 0) ? _c('div', [_c('p', [_vm._v("Showing " + _vm._s(_vm.licenseCount) + " license activations")]), _vm._v(" "), _c('table', {
	    staticClass: "table"
	  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredActivations), function(lic, index) {
	    return _c('tr', {
	      class: lic.rowClass
	    }, [_c('td', [_vm._v(_vm._s(_vm.formatDate(lic.activation.activateTime)))]), _vm._v(" "), _c('td', [_c('router-link', {
	      attrs: {
	        "to": {
	          name: 'serial',
	          params: {
	            id: lic.activation.serial
	          }
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.trim(lic.activation.serial, 8)))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.serialDetails[lic.activation.serial] ? _vm.serialDetails[lic.activation.serial].customer : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(lic.licenseExpiryDate.format('YYYY-MM-DD HH:mm')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.abs(lic.expiryDays)) + " " + _vm._s(lic.expiryDays < 0 ? 'days ago' : 'days'))]), _vm._v(" "), ('attributes' in lic) ? _c('td', [_c('a', {
	      attrs: {
	        "href": '#attributesJson' + index,
	        "data-toggle": "modal"
	      }
	    }, [_vm._v("show")])]) : _c('td')])
	  }))])]) : _c('div', [_c('span', [_vm._v("No license activations.")])])], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('thead', [_c('th', [_vm._v("Activation Date")]), _vm._v(" "), _c('th', [_vm._v("Serial")]), _vm._v(" "), _c('th', [_vm._v("Customer")]), _vm._v(" "), _c('th', [_vm._v("Expiry Date")]), _vm._v(" "), _c('th', [_vm._v("Expires")]), _vm._v(" "), _c('th', [_vm._v("Details")])])
	}]}

/***/ },
/* 504 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ },
/* 505 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container centre-column"
	  }, [(_vm.$route.query.redirect) ? _c('p', [_vm._v("\n    You need to log in first.\n  ")]) : _vm._e(), _vm._v(" "), _c('form', {
	    staticClass: "form-signin"
	  }, [_c('h2', [_vm._v("Please log in")]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: _vm.validateEmail ? '' : 'has-error'
	  }, [_c('label', {
	    staticClass: "sr-only",
	    attrs: {
	      "for": "inputEmail"
	    }
	  }, [_vm._v("Email Address")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.email),
	      expression: "email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "email",
	      "id": "inputEmail",
	      "placeholder": "Email address",
	      "required": "",
	      "autofocus": ""
	    },
	    domProps: {
	      "value": _vm._s(_vm.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.email = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group",
	    class: _vm.validatePassword ? '' : 'has-error'
	  }, [_c('label', {
	    staticClass: "sr-only",
	    attrs: {
	      "for": "inputPassword"
	    }
	  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.password),
	      expression: "password"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "id": "inputPassword",
	      "placeholder": "Password",
	      "required": ""
	    },
	    domProps: {
	      "value": _vm._s(_vm.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.password = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-lg btn-primary btn-block",
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submit($event)
	      }
	    }
	  }, [_vm._v("Log in")])]), _vm._v(" "), _c('div', {
	    staticClass: "centre-column"
	  }, [_c('p', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'forgot-password'
	      }
	    }
	  }, [_vm._v("forgot password")])], 1), _vm._v(" "), (_vm.error) ? _c('p', {
	    staticClass: "error"
	  }, [_vm._v("email or password is not correct")]) : _vm._e()])])
	},staticRenderFns: []}

/***/ },
/* 506 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('nav-bar'), _vm._v(" "), _c('loading-bar'), _vm._v(" "), _c('router-view')], 1)
	},staticRenderFns: []}

/***/ },
/* 507 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": _vm.name,
	      "tabindex": "-1",
	      "role": "dialog",
	      "aria-labelledby": "myModalLabel"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog modal-lg",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_vm._m(0), _vm._v(" "), _c('h5', {
	    staticClass: "modal-title",
	    attrs: {
	      "id": "myModalLabel"
	    }
	  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_vm._t("default")], 2), _vm._v(" "), _vm._m(1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("Close")])])
	}]}

/***/ },
/* 508 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form-group has-feedback"
	  }, [_c('input', {
	    ref: "el",
	    staticClass: "form-control",
	    attrs: {
	      "readonly": "",
	      "placeholder": _vm.placeHolder
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "glyphicon glyphicon-calendar form-control-feedback"
	  })])
	},staticRenderFns: []}

/***/ },
/* 509 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vue-street-view-pano-container"
	  }, [_c('div', {
	    ref: "vue-street-view-pano",
	    staticClass: "vue-street-view-pano"
	  }), _vm._v(" "), _vm._t("default")], 2)
	},staticRenderFns: []}

/***/ },
/* 510 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "id": "el",
	      "data-toggle": "popover",
	      "title": _vm.title,
	      "data-content": _vm.content
	    }
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ },
/* 511 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('svg', {
	    attrs: {
	      "id": "tracker",
	      "width": "800",
	      "height": "30",
	      "xmlns": "http://www.w3.org/2000/svg",
	      "xmlns:xlink": "http://www.w3.org/1999/xlink"
	    }
	  }, _vm._l((_vm.dayStyles), function(style, index) {
	    return _c('rect', {
	      class: style,
	      attrs: {
	        "track-by": "index",
	        "x": index * 12,
	        "y": "0",
	        "height": "10",
	        "width": "10",
	        "rx": "2",
	        "ry": "2"
	      }
	    })
	  }))])
	},staticRenderFns: []}

/***/ },
/* 512 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('input', {
	    ref: "input",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.placeholder
	    },
	    domProps: {
	      "value": _vm.value
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 513 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "panel panel-default",
	    attrs: {
	      "id": "el"
	    }
	  }, [_c('div', {
	    staticClass: "panel-heading"
	  }, [_c('h5', {
	    staticClass: "panel-title"
	  }, [_c('a', {
	    attrs: {
	      "data-toggle": "collapse",
	      "data-target": "#collapseMap"
	    }
	  }, [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _c('div', {
	    staticClass: "panel-collapse collapse in",
	    attrs: {
	      "id": "collapseMap"
	    }
	  }, [_c('div', {
	    staticClass: "panel-body"
	  }, [_vm._t("default")], 2)])])
	},staticRenderFns: []}

/***/ },
/* 514 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'dashboard'
	      }
	    }
	  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'adminUsers'
	      }
	    }
	  }, [_vm._v("Admin - Users")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_vm._v(_vm._s(_vm.user.first_name) + " " + _vm._s(_vm.user.last_name))])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 col-sm-10"
	  }, [_c('form', {
	    staticClass: "form-horizontal"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "col-sm-3 control-label",
	    attrs: {
	      "for": "inputFirstName"
	    }
	  }, [_vm._v("First Name")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.first_name),
	      expression: "user.first_name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "inputFirstName"
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.first_name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.first_name = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "col-sm-3 control-label",
	    attrs: {
	      "for": "inputLastName"
	    }
	  }, [_vm._v("Last Name")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.last_name),
	      expression: "user.last_name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "inputLastName"
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.last_name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.last_name = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "col-sm-3 control-label",
	    attrs: {
	      "for": "inputEmail"
	    }
	  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.email),
	      expression: "user.email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "inputEmail"
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.email = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "col-sm-offset-3 col-sm-2"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.save($event)
	      }
	    }
	  }, [_vm._v("Save")])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-5"
	  }, [(_vm.saved) ? _c('p', [_vm._v("User saved successfully.")]) : _vm._e(), _vm._v(" "), (_vm.savedError) ? _c('p', {
	    staticClass: "error"
	  }, [_vm._v("There was a problem saving the user.")]) : _vm._e()])])])])])])
	},staticRenderFns: []}

/***/ },
/* 515 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vue-map-container"
	  }, [_c('div', {
	    ref: "vue-map",
	    staticClass: "vue-map"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "vue-map-hidden"
	  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
	},staticRenderFns: []}

/***/ },
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.b30c924319ccac00dc28.js